/* eslint-disable */
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** Date scalar type formatted without timezone */
  LocalDate: string;
};

export type AccountManager = {
  __typename?: 'AccountManager';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type AddFlexibleGuestOrdersPayload = {
  __typename?: 'AddFlexibleGuestOrdersPayload';
  flexibleGuestOrdersId: Scalars['String'];
  flexibleTableBillId: Scalars['String'];
  guestOrder: FlexibleGuestOrderPayload;
  tableNumber: Scalars['String'];
};

export type AddToFlexibleGuestOrdersInput = {
  cart: FlexibleCartInput;
  flexibleGuestOrdersId: Scalars['String'];
  guestId: Scalars['String'];
};

export type AfterpayAmount = {
  __typename?: 'AfterpayAmount';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type AfterpayConfiguration = {
  __typename?: 'AfterpayConfiguration';
  maximumAmount?: Maybe<AfterpayAmount>;
  minimumAmount?: Maybe<AfterpayAmount>;
};

export enum Allergens {
  Celery = 'CELERY',
  CerealsContainingGluten = 'CEREALS_CONTAINING_GLUTEN',
  Crustaceans = 'CRUSTACEANS',
  Eggs = 'EGGS',
  Fish = 'FISH',
  Garlic = 'GARLIC',
  Ginger = 'GINGER',
  Gluten = 'GLUTEN',
  GroundNuts = 'GROUND_NUTS',
  Legumes = 'LEGUMES',
  Lupin = 'LUPIN',
  Mango = 'MANGO',
  Milk = 'MILK',
  Molluscs = 'MOLLUSCS',
  Mustard = 'MUSTARD',
  Onion = 'ONION',
  Peanuts = 'PEANUTS',
  Sesame = 'SESAME',
  SesameSeeds = 'SESAME_SEEDS',
  SoyaOrSoybeans = 'SOYA_OR_SOYBEANS',
  Soybeans = 'SOYBEANS',
  SulphurDioxideAndSulphites = 'SULPHUR_DIOXIDE_AND_SULPHITES',
  TreeNuts = 'TREE_NUTS'
}

export type AuraMembershipPayload = {
  __typename?: 'AuraMembershipPayload';
  id: Scalars['String'];
};

export type AvailableSlot = {
  __typename?: 'AvailableSlot';
  endTime: Scalars['String'];
  id: Scalars['String'];
  isPast: Scalars['Boolean'];
  orderingWindowStartDate: Scalars['LocalDate'];
  startTime: Scalars['String'];
  unlimitedOrders: Scalars['Boolean'];
  windows: Scalars['Float'];
};

export type BatchGroupBatchInterval = {
  __typename?: 'BatchGroupBatchInterval';
  batchIntervalInMilliseconds: Scalars['Float'];
  orderingType: OrderingType;
};

export type BatchingGroup = {
  __typename?: 'BatchingGroup';
  batchIntervalInMilliseconds: Scalars['Float'];
  batchingGroupTimeBlock?: Maybe<BatchingGroupTimeBlock>;
  id: Scalars['String'];
  name: Scalars['String'];
  perOrderingTypeIntervals?: Maybe<Array<BatchGroupBatchInterval>>;
  venueId: Scalars['String'];
};

export type BatchingGroupTimeBlock = {
  __typename?: 'BatchingGroupTimeBlock';
  fri?: Maybe<Array<BatchingGroupTimeSlot>>;
  id: Scalars['String'];
  mon?: Maybe<Array<BatchingGroupTimeSlot>>;
  sat?: Maybe<Array<BatchingGroupTimeSlot>>;
  sun?: Maybe<Array<BatchingGroupTimeSlot>>;
  thu?: Maybe<Array<BatchingGroupTimeSlot>>;
  tue?: Maybe<Array<BatchingGroupTimeSlot>>;
  wed?: Maybe<Array<BatchingGroupTimeSlot>>;
};

export type BatchingGroupTimeSlot = {
  __typename?: 'BatchingGroupTimeSlot';
  batchIntervalInMilliseconds: Scalars['Float'];
  endTime: Scalars['String'];
  orderingType: OrderingType;
  startTime: Scalars['String'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Cart = {
  __typename?: 'Cart';
  cartItems: Array<CartItem>;
  cartToken?: Maybe<Scalars['String']>;
  /** @deprecated Replaced by cartValidationErrorsV2 */
  cartValidationErrors: Array<CartValidationError>;
  cartValidationErrorsV2: Array<CartValidationErrorV2>;
  coverCount?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  currentLocation?: Maybe<Location>;
  deliveryOption?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isReadOnly: Scalars['Boolean'];
  itemValidation: Array<ItemValidation>;
  notes?: Maybe<Scalars['String']>;
  orderingType: OrderingType;
  orderingWindowEnabled: Scalars['Boolean'];
  orderingWindowEndDate?: Maybe<Scalars['LocalDate']>;
  orderingWindowStartDate?: Maybe<Scalars['LocalDate']>;
  pickupOption?: Maybe<Scalars['String']>;
  sharedPaymentId?: Maybe<Scalars['String']>;
  skipCardSurcharge?: Maybe<Scalars['Boolean']>;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
  total: CartTotal;
};

export type CartBaseInput = {
  id: Scalars['String'];
  quantity: Scalars['Float'];
};

export type CartClubMembershipSurcountApplyInput = {
  clubMembershipNumber: Scalars['String'];
  orderingType: OrderingType;
  venueSlug: Scalars['String'];
};

export type CartDiscount = {
  __typename?: 'CartDiscount';
  chargeType: ChargeType;
  code?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['String']>;
  discountInCents: Scalars['Float'];
  discountName: Scalars['String'];
  discountRate: Scalars['Float'];
  /** Code indicates the discount is from inputted code, venue is from a venue wide discount */
  discountType?: Maybe<Scalars['String']>;
  /** This is for external discounts, MrYum's discount has undefined */
  externalVoucherType?: Maybe<Scalars['String']>;
  /** This indicates if the surcharge is removable */
  isRemovable?: Maybe<Scalars['Boolean']>;
  /** This indicates if the discount is stackable */
  isStackable?: Maybe<Scalars['Boolean']>;
  itemId: Scalars['String'];
  posDiscountId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  /** @deprecated Moving to more specific name */
  type?: Maybe<Scalars['String']>;
};

export type CartDiscountApplyInput = {
  discountCode: Scalars['String'];
  orderingType: OrderingType;
  unformattedDiscountCode?: Maybe<Scalars['String']>;
  venueSlug: Scalars['String'];
};

export type CartDiscountRemove = {
  orderingType: OrderingType;
  reApplyVenueWideDiscount?: Maybe<Scalars['Boolean']>;
  venueSlug: Scalars['String'];
};

export type CartDiscountRemoveByCode = {
  code: Scalars['String'];
  orderingType: OrderingType;
  venueSlug: Scalars['String'];
};

export type CartInputBase = {
  orderingType: OrderingType;
  venueSlug: Scalars['String'];
};

export type CartItem = {
  __typename?: 'CartItem';
  cartModifiers?: Maybe<Array<CartItem>>;
  cartUpsells?: Maybe<Array<CartItem>>;
  groupingId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isFree: Scalars['Boolean'];
  item?: Maybe<MenuItem>;
  modifier?: Maybe<MenuItemModifier>;
  name: Scalars['String'];
  originalPriceInCents: Scalars['Float'];
  parentId?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  taxRate: Scalars['Float'];
  totalInCents: Scalars['Float'];
  type: CartItemType;
  upsell?: Maybe<MenuItemUpsell>;
  upsellGroupId?: Maybe<Scalars['String']>;
};

export type CartItemInput = {
  item: CartBaseInput;
  modifiers?: Maybe<Array<CartBaseInput>>;
  orderingType: OrderingType;
  upgrades?: Maybe<Array<CartUpsellInput>>;
  upsells?: Maybe<Array<CartUpsellInput>>;
  venueSlug: Scalars['String'];
};

export type CartItemQuantityUpdate = {
  id: Scalars['String'];
  orderingType: OrderingType;
  quantity: Scalars['Float'];
  venueSlug: Scalars['String'];
};

export enum CartItemType {
  ComboItem = 'COMBO_ITEM',
  MenuItem = 'MENU_ITEM',
  Modifier = 'MODIFIER',
  UpsellItem = 'UPSELL_ITEM',
  VirtualItem = 'VIRTUAL_ITEM'
}

export type CartItemsRemove = {
  id: Scalars['String'];
  orderingType: OrderingType;
  venueSlug: Scalars['String'];
};

export type CartLocationInput = {
  googlePlaceId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  orderingType: OrderingType;
  streetAddress?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  venueSlug: Scalars['String'];
};

export type CartLoyaltyDiscountApplyInput = {
  orderingType: OrderingType;
  rewardId: Scalars['String'];
  venueSlug: Scalars['String'];
};

export type CartNotesInput = {
  notes?: Maybe<Scalars['String']>;
  orderingType: OrderingType;
  venueSlug: Scalars['String'];
};

export type CartOptionsInput = {
  coverCount?: Maybe<Scalars['Float']>;
  deliveryOption?: Maybe<Scalars['String']>;
  orderingType: OrderingType;
  pickupOption?: Maybe<Scalars['String']>;
  reApplyVenueWide?: Maybe<Scalars['Boolean']>;
  venueSlug: Scalars['String'];
};

export type CartOrderingWindowInput = {
  orderingType: OrderingType;
  orderingWindowEndDate?: Maybe<Scalars['LocalDate']>;
  orderingWindowId?: Maybe<Scalars['String']>;
  orderingWindowStartDate?: Maybe<Scalars['LocalDate']>;
  venueSlug: Scalars['String'];
};

export type CartServiceCharge = {
  __typename?: 'CartServiceCharge';
  chargeInCents: Scalars['Int'];
  chargeName: Scalars['String'];
  isRemovable: Scalars['Boolean'];
  posDiscountId?: Maybe<Scalars['String']>;
  serviceChargeId: Scalars['String'];
};

export type CartServiceChargeRemove = {
  orderingType: OrderingType;
  venueSlug: Scalars['String'];
};

export type CartTableNumberInput = {
  orderingType: OrderingType;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber: Scalars['String'];
  venueSlug: Scalars['String'];
};

export type CartTipApplyInput = {
  gratuityInCents?: Maybe<Scalars['Float']>;
  orderingType: OrderingType;
  venueSlug: Scalars['String'];
};

export type CartTotal = {
  __typename?: 'CartTotal';
  cardSurchargeInCents: Scalars['Float'];
  cardSurchargeName?: Maybe<Scalars['String']>;
  cartDiscounts?: Maybe<Array<CartDiscount>>;
  cartServiceCharge?: Maybe<CartServiceCharge>;
  deliveryFeeInCents: Scalars['Float'];
  gratuityInCents: Scalars['Float'];
  isTaxInclusive: Scalars['Boolean'];
  minDeliveryOrderValueInCents: Scalars['Float'];
  minDeliveryThresholdNotReached: Scalars['Boolean'];
  minFreeDeliveryThresholdNotReached: Scalars['Boolean'];
  minOrderValueForFreeDeliveryInCents: Scalars['Float'];
  subTotalInCents: Scalars['Float'];
  taxName: Scalars['String'];
  totalInCents: Scalars['Float'];
  totalTaxInCents: Scalars['Float'];
};

export type CartUpsellInput = {
  id: Scalars['String'];
  modifiers?: Maybe<Array<CartBaseInput>>;
  quantity: Scalars['Float'];
  upsellGroupId: Scalars['String'];
};

export enum CartValidationError {
  EmptyCart = 'EMPTY_CART',
  InvalidTableNumber = 'INVALID_TABLE_NUMBER',
  ItemPriceChanged = 'ITEM_PRICE_CHANGED',
  ItemQuantityMax = 'ITEM_QUANTITY_MAX',
  ItemQuantityMin = 'ITEM_QUANTITY_MIN',
  MissingDeliveryAddress = 'MISSING_DELIVERY_ADDRESS',
  MissingDeliveryOption = 'MISSING_DELIVERY_OPTION',
  MissingNotes = 'MISSING_NOTES',
  MissingOrderingWindow = 'MISSING_ORDERING_WINDOW',
  MissingPickupOption = 'MISSING_PICKUP_OPTION',
  MissingTableArea = 'MISSING_TABLE_AREA',
  MissingTableNumber = 'MISSING_TABLE_NUMBER',
  MissingTip = 'MISSING_TIP',
  MissingUser = 'MISSING_USER',
  OrderingTypeUnavailable = 'ORDERING_TYPE_UNAVAILABLE',
  OrderingWindowInvalid = 'ORDERING_WINDOW_INVALID',
  PosAdjustmentRequired = 'POS_ADJUSTMENT_REQUIRED',
  PurchasedCart = 'PURCHASED_CART',
  TableNumberAlcoholOff = 'TABLE_NUMBER_ALCOHOL_OFF',
  TableNumberAllOff = 'TABLE_NUMBER_ALL_OFF',
  UnavailableItem = 'UNAVAILABLE_ITEM',
  VenueClosed = 'VENUE_CLOSED',
  VenueNotTakingOrders = 'VENUE_NOT_TAKING_ORDERS'
}

export type CartValidationErrorV2 = {
  __typename?: 'CartValidationErrorV2';
  message: Scalars['String'];
  type: CartValidationError;
};

export type CdnImage = {
  __typename?: 'CdnImage';
  defaultImage: Scalars['String'];
  id: Scalars['String'];
  imageAlt?: Maybe<Scalars['String']>;
  /** Source set for the cdn image */
  imageSources?: Maybe<Array<ImageSource>>;
  originalImagePath?: Maybe<Scalars['String']>;
  originalImageUrl: Scalars['String'];
  srcSet: Scalars['String'];
  transform?: Maybe<Scalars['String']>;
};

export type ChargeActionRequired = {
  __typename?: 'ChargeActionRequired';
  nextAction: Scalars['String'];
  paymentIntentId: Scalars['String'];
  processorReference: Scalars['String'];
  verificationUrl?: Maybe<Scalars['String']>;
};

export type ChargeInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  paymentIntentId: Scalars['String'];
  paymentMethodId: Scalars['String'];
  paymentProcessor: Scalars['String'];
  paymentTargetId: Scalars['String'];
  venueId: Scalars['String'];
};

export type ChargeSharedPaymentInput = {
  cardToken?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  /** Tip amount a guest will include for the shared payment session */
  gratuityInCents?: Maybe<Scalars['Int']>;
  idempotencyKey?: Maybe<Scalars['String']>;
  newPaymentMethod?: Maybe<Scalars['Boolean']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentProcessorType?: PaymentProcessorType;
  savePaymentDetails?: Maybe<Scalars['Boolean']>;
  sharedPaymentId: Scalars['ID'];
  /** A specific amount that a guest will pay for the shared payment session */
  totalInCents: Scalars['Int'];
};

export type ChargeSharedPaymentPayload = {
  __typename?: 'ChargeSharedPaymentPayload';
  cart: Cart;
  error?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderPaymentChallenge?: Maybe<PaymentTransactionChallenge>;
  orderPaymentRedirect?: Maybe<PaymentTransactionRedirect>;
  validation?: Maybe<OrderCreateInputValidation>;
};

export enum ChargeType {
  Discount = 'DISCOUNT',
  ServiceCharge = 'SERVICE_CHARGE',
  Surcharge = 'SURCHARGE'
}

export enum ChurnReason {
  CovidTakeawayOnly = 'COVID_TAKEAWAY_ONLY',
  LostToCompetitor = 'LOST_TO_COMPETITOR',
  MissingFeature = 'MISSING_FEATURE',
  PermanentlyClosed = 'PERMANENTLY_CLOSED',
  RemovedByUs = 'REMOVED_BY_US',
  ServiceModelCovid = 'SERVICE_MODEL_COVID',
  TechIntegrationIssues = 'TECH_INTEGRATION_ISSUES',
  TemporarilyClosed = 'TEMPORARILY_CLOSED',
  UnderNewManagement = 'UNDER_NEW_MANAGEMENT'
}

export enum ChurnStatus {
  Churned = 'CHURNED',
  ChurnedPopup = 'CHURNED_POPUP',
  Passive = 'PASSIVE',
  PassivePopup = 'PASSIVE_POPUP',
  Popup = 'POPUP'
}

export type ComputePointsToUseInput = {
  rewardId: Scalars['String'];
};

export type ComputePointsToUsePayload = {
  __typename?: 'ComputePointsToUsePayload';
  amountInCents: Scalars['Float'];
  id: Scalars['String'];
  pointsToRedeem: Scalars['Float'];
};

export type ConfirmSocialTabMemberResponse = {
  __typename?: 'ConfirmSocialTabMemberResponse';
  success: Scalars['Boolean'];
  validation?: Maybe<Array<SocialTabValidationError>>;
};

export type CreateOrderInput = {
  cardToken?: Maybe<Scalars['String']>;
  clubMembershipNumber?: Maybe<Scalars['String']>;
  coverCount?: Maybe<Scalars['Float']>;
  customerId?: Maybe<Scalars['String']>;
  /** API Key returned by EONX API to be used for their internal calls */
  eonxPaymentApiKey?: Maybe<Scalars['String']>;
  eonxPaymentBeenCaptured?: Maybe<Scalars['Boolean']>;
  eonxPaymentIntentId?: Maybe<Scalars['String']>;
  idempotencyKey?: Maybe<Scalars['String']>;
  intentError?: Maybe<Scalars['String']>;
  newPaymentMethod?: Scalars['Boolean'];
  paymentIntentId?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentPath?: Maybe<Scalars['String']>;
  paymentProcessorType?: PaymentProcessorType;
  roomName?: Maybe<Scalars['String']>;
  roomNumber?: Maybe<Scalars['String']>;
  savePaymentDetails?: Maybe<Scalars['Boolean']>;
  socialTabId?: Maybe<Scalars['String']>;
  startNewSocialTab?: Scalars['Boolean'];
  type?: Maybe<OrderingType>;
  venueSlug?: Maybe<Scalars['String']>;
  walletPaymentProcessor?: Maybe<PaymentProcessorType>;
};

export type CreatePaymentIntentInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  lastCompletedPaymentIntentId?: Maybe<Scalars['String']>;
  paymentProcessor: Scalars['String'];
  paymentTargetId: Scalars['String'];
  venueId: Scalars['String'];
};

export type CreatePaymentIntentResponse = {
  __typename?: 'CreatePaymentIntentResponse';
  paymentIntentId: Scalars['String'];
  processorReference: Scalars['String'];
};

export type CreatePaymentMethodInput = {
  currency: Scalars['String'];
  paymentMethodId: Scalars['String'];
  paymentProcessor: Scalars['String'];
};

export type CreateReviewInput = {
  notes?: Maybe<Scalars['String']>;
  orderId: Scalars['String'];
  rating: Scalars['Float'];
};

export type Cuisine = {
  __typename?: 'Cuisine';
  name: Scalars['String'];
  slug: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
};

/** DataProcessorType data processor type */
export enum DataProcessorType {
  Impact = 'IMPACT',
  Lexer = 'LEXER',
  Qvc = 'QVC'
}


export type Discount = {
  __typename?: 'Discount';
  amount: Scalars['Float'];
  categories?: Maybe<Array<MenuItemCategory>>;
  chargeType: ChargeType;
  code: Scalars['String'];
  description: Scalars['String'];
  doshiiSurcountId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAutoGenerated: Scalars['Boolean'];
  isEffective?: Maybe<Scalars['Boolean']>;
  isRemovable: Scalars['Boolean'];
  isStackable: Scalars['Boolean'];
  isVenueWide: Scalars['Boolean'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  timeBlocks?: Maybe<TimeBlocks>;
  timeFrames?: Maybe<Array<TimeFrame>>;
  type: Scalars['String'];
};

export enum DisplayViewSelectRequirement {
  Collapsed = 'COLLAPSED',
  Expanded = 'EXPANDED',
  Hidden = 'HIDDEN'
}

export type DoordashDasher = {
  __typename?: 'DoordashDasher';
  dasher_phone_number_for_customer: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['String'];
  last_name: Scalars['String'];
  phone_number: Scalars['String'];
};

export type DoordashDelivery = {
  __typename?: 'DoordashDelivery';
  actualDeliveryTime?: Maybe<Scalars['DateTime']>;
  actualPickupTime?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  dasher?: Maybe<DoordashDasher>;
  deliveryTrackingUrl?: Maybe<Scalars['String']>;
  deliveryVerificationImageUrl?: Maybe<Scalars['String']>;
  displayStatus: Scalars['String'];
  doordashId: Scalars['Float'];
  estimatedDeliveryTime: Scalars['DateTime'];
  estimatedPickupTime: Scalars['DateTime'];
  fee?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  quotedDeliveryTime?: Maybe<Scalars['DateTime']>;
  quotedPickupTime?: Maybe<Scalars['DateTime']>;
  rating?: Maybe<Scalars['String']>;
  status: DoordashDeliveryStatus;
  venueId: Scalars['String'];
};

export enum DoordashDeliveryStatus {
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  CouldNotDeliver = 'COULD_NOT_DELIVER',
  Delivered = 'DELIVERED',
  PickedUp = 'PICKED_UP',
  Scheduled = 'SCHEDULED'
}

export type EonxPaymentMethod = {
  __typename?: 'EonxPaymentMethod';
  brand: Scalars['String'];
  expiry: Scalars['String'];
  last4: Scalars['String'];
};

export type FindOrCreateSharedPaymentInput = {
  cartId: Scalars['String'];
  currency: Scalars['String'];
};

export type FindOrCreateSharedPaymentPayload = {
  __typename?: 'FindOrCreateSharedPaymentPayload';
  sharedPaymentId: Scalars['String'];
};

export type FlexibleCart = {
  __typename?: 'FlexibleCart';
  flexibleGuestOrderId: Scalars['String'];
  id: Scalars['String'];
  items: Array<FlexibleItem>;
  source: Scalars['String'];
  tableNumber: Scalars['String'];
};

export type FlexibleCartInput = {
  id: Scalars['String'];
};

export type FlexibleGuest = {
  __typename?: 'FlexibleGuest';
  email: Scalars['String'];
  id: Scalars['String'];
  isFromPos: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type FlexibleGuestOrderPayload = {
  __typename?: 'FlexibleGuestOrderPayload';
  cart: Array<FlexibleCart>;
  flexibleTableBillId: Scalars['String'];
  guest: FlexibleGuest;
  id: Scalars['String'];
  payments: Array<FlexiblePayment>;
  serviceChargeAmount: Scalars['Float'];
  subtotalAmount: Scalars['Float'];
  tableNumber: Scalars['String'];
  taxAmount: Scalars['Float'];
  tipAmount: Scalars['Float'];
  totalAmount: Scalars['Float'];
  totalPaid: Scalars['Float'];
};

export type FlexibleItem = {
  __typename?: 'FlexibleItem';
  cartId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  priceInCents: Scalars['Float'];
  quantity: Scalars['Float'];
  taxRate: Scalars['Float'];
};

export type FlexibleOrderReceiptForGuestPayload = {
  __typename?: 'FlexibleOrderReceiptForGuestPayload';
  flexibleGuestOrdersId: Scalars['String'];
  gratuity: Scalars['Float'];
  guestId: Scalars['String'];
  order: OrderForReceipt;
  payments?: Maybe<Array<FlexiblePayment>>;
  serviceCharge: Scalars['Float'];
  totalAmount: Scalars['Float'];
};

export type FlexibleOrderReceiptForTablePayload = {
  __typename?: 'FlexibleOrderReceiptForTablePayload';
  flexibleTableBillId: Scalars['String'];
  guestPayments?: Maybe<Array<FlexiblePayment>>;
  id: Scalars['String'];
  items?: Maybe<Array<FlexibleItem>>;
  tableArea: Scalars['String'];
  tableNumber: Scalars['String'];
};

export type FlexiblePayment = {
  __typename?: 'FlexiblePayment';
  currency: Scalars['String'];
  gratuityInCents: Scalars['Float'];
  guestId: Scalars['String'];
  id: Scalars['String'];
  source: Scalars['String'];
  totalInCents: Scalars['Float'];
};

export type FtpStorage = {
  __typename?: 'FtpStorage';
  dataProcessor?: Maybe<DataProcessorType>;
  host?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  port?: Maybe<Scalars['Float']>;
  privateKey: Scalars['Boolean'];
  username?: Maybe<Scalars['String']>;
};

export type GuestCreateInput = {
  /** GuestRegister data */
  input: GuestRegisterInput;
  venueId: Scalars['String'];
};

export type GuestImage = {
  __typename?: 'GuestImage';
  id: Scalars['ID'];
  originalImagePath?: Maybe<Scalars['String']>;
  originalImageUrl: Scalars['String'];
};

export type GuestMenuCategory = {
  __typename?: 'GuestMenuCategory';
  extendedWaitTime?: Maybe<GuestWaitTime>;
  hideMenuWhenClosed: Scalars['Boolean'];
  hours?: Maybe<TimeBlocks>;
  id: Scalars['ID'];
  image?: Maybe<GuestImage>;
  isClosed: Scalars['Boolean'];
  menuCategoryType: MenuCategoryType;
  menuSections: Array<GuestMenuSection>;
  mvoFeatured?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orderingType?: Maybe<Array<OrderingType>>;
  position?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
};


export type GuestMenuCategoryImageArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type GuestMenuCategoryIsClosedArgs = {
  orderingType?: Maybe<OrderingType>;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
};

export type GuestMenuItem = {
  __typename?: 'GuestMenuItem';
  allergens?: Maybe<Array<Allergens>>;
  available: Scalars['Boolean'];
  category: MenuItemCategory;
  deletedAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionPlain?: Maybe<Scalars['String']>;
  descriptionde?: Maybe<Scalars['String']>;
  descriptionel?: Maybe<Scalars['String']>;
  descriptiones?: Maybe<Scalars['String']>;
  descriptionfr?: Maybe<Scalars['String']>;
  descriptionit?: Maybe<Scalars['String']>;
  descriptionzhCN?: Maybe<Scalars['String']>;
  dietaryDescriptors?: Maybe<Scalars['String']>;
  dietaryTags?: Maybe<Array<Scalars['String']>>;
  extendedWaitTime?: Maybe<GuestWaitTime>;
  externalPosId?: Maybe<Scalars['String']>;
  externalPosPriceInCents?: Maybe<Scalars['Int']>;
  filterTags?: Maybe<Array<Scalars['String']>>;
  hideFromMenu: Scalars['Boolean'];
  id: Scalars['ID'];
  image?: Maybe<GuestImage>;
  imageCredit?: Maybe<Scalars['String']>;
  inventoryCount?: Maybe<Scalars['Int']>;
  inventoryEnabled: Scalars['Boolean'];
  isAvailable: Scalars['Boolean'];
  isAvailableForOrdering: Scalars['Boolean'];
  isLive: Scalars['Boolean'];
  isPopular: Scalars['Boolean'];
  maxQuantity?: Maybe<Scalars['Int']>;
  menuCategories?: Maybe<Array<GuestMenuCategory>>;
  minQuantity: Scalars['Int'];
  modifierGroups: Array<GuestMenuItemModifierGroup>;
  name?: Maybe<Scalars['String']>;
  namede?: Maybe<Scalars['String']>;
  nameel?: Maybe<Scalars['String']>;
  namees?: Maybe<Scalars['String']>;
  namefr?: Maybe<Scalars['String']>;
  nameit?: Maybe<Scalars['String']>;
  namezhCN?: Maybe<Scalars['String']>;
  priceData: GuestPriceData;
  priceLevels?: Maybe<Array<PriceLevel>>;
  rewardPrice?: Maybe<GuestRewardPrice>;
  shortName?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  upgradeGroup?: Maybe<GuestUpgradeGroup>;
  upsellGroups: Array<GuestUpsellGroup>;
};


export type GuestMenuItemImageArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type GuestMenuItemIsAvailableArgs = {
  orderingWindowStartDate?: Maybe<Scalars['String']>;
};


export type GuestMenuItemIsAvailableForOrderingArgs = {
  input: GuestMenuItemAvailabilityInput;
};


export type GuestMenuItemMenuCategoriesArgs = {
  input?: Maybe<MenuCategoryAvailabilityInput>;
};


export type GuestMenuItemModifierGroupsArgs = {
  upgradeId?: Maybe<Scalars['String']>;
};

export type GuestMenuItemAvailabilityInput = {
  orderingType: OrderingType;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
};

export type GuestMenuItemModifierGroup = {
  __typename?: 'GuestMenuItemModifierGroup';
  displayViewSelectRequirement: DisplayViewSelectRequirement;
  hasPreselectedOption: Scalars['Boolean'];
  id: Scalars['ID'];
  maxQuantity?: Maybe<Scalars['Int']>;
  minQuantity: Scalars['Int'];
  modifiers: Array<GuestModifier>;
  name: Scalars['String'];
  orderingTypes?: Maybe<Array<OrderingType>>;
  selectRequirement: MenuItemSelectRequirement;
  selectType: MenuItemSelectType;
};

export type GuestMenuSection = {
  __typename?: 'GuestMenuSection';
  extendedWaitTime?: Maybe<GuestWaitTime>;
  id: Scalars['ID'];
  menuItems: Array<GuestMenuItem>;
  name: Scalars['String'];
  position: Scalars['Int'];
  slug: Scalars['String'];
  subSection?: Maybe<Scalars['String']>;
};

export type GuestModifier = {
  __typename?: 'GuestModifier';
  available: Scalars['Boolean'];
  displayPrice: Scalars['String'];
  externalPosGroupId?: Maybe<Scalars['String']>;
  externalPosGroupName?: Maybe<Scalars['String']>;
  externalPosId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isTaxExempt: Scalars['Boolean'];
  maxQuantity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  position: Scalars['Int'];
  priceData?: Maybe<GuestPriceData>;
  priceInCents: Scalars['Int'];
  priceLevels?: Maybe<Array<PriceLevel>>;
  taxRate?: Maybe<Scalars['Float']>;
};

export type GuestPriceData = {
  __typename?: 'GuestPriceData';
  displayPrice?: Maybe<Scalars['String']>;
  hasPriceOverride: Scalars['Boolean'];
  isMembershipPricing?: Maybe<Scalars['Boolean']>;
  originalDisplayPrice?: Maybe<Scalars['String']>;
  originalPriceInCents?: Maybe<Scalars['Float']>;
  priceInCents?: Maybe<Scalars['Float']>;
};

export type GuestRegisterInput = {
  addressOrEmail?: Maybe<Scalars['String']>;
  ageRequirement?: Maybe<Scalars['Boolean']>;
  correctDeclaration?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  marketingOptInEnabled: Scalars['Boolean'];
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  symptomsConfirmation?: Maybe<Scalars['Boolean']>;
  tableNumber?: Maybe<Scalars['String']>;
  temperature?: Maybe<Scalars['String']>;
};

export enum GuestRegistryFieldRequirement {
  Hidden = 'Hidden',
  Optional = 'Optional',
  Required = 'Required'
}

export type GuestRegistrySettings = {
  __typename?: 'GuestRegistrySettings';
  addressOrEmail: GuestRegistryFieldRequirement;
  ageRequirement: GuestRegistryFieldRequirement;
  correctDeclaration: GuestRegistryFieldRequirement;
  email: GuestRegistryFieldRequirement;
  enabled: Scalars['Boolean'];
  externalGuestRegistryUrl?: Maybe<Scalars['String']>;
  idNumber: GuestRegistryFieldRequirement;
  mobile: GuestRegistryFieldRequirement;
  name: GuestRegistryFieldRequirement;
  postcode: GuestRegistryFieldRequirement;
  symptomsConfirmation: GuestRegistryFieldRequirement;
  tableNumber: GuestRegistryFieldRequirement;
  temperature: GuestRegistryFieldRequirement;
  id: Scalars['String'];
};

export type GuestRewardPrice = {
  __typename?: 'GuestRewardPrice';
  originalAmountInCents?: Maybe<Scalars['Float']>;
  originalDisplayAmount?: Maybe<Scalars['String']>;
};

export type GuestSession = {
  __typename?: 'GuestSession';
  id: Scalars['ID'];
};

export type GuestUpgrade = {
  __typename?: 'GuestUpgrade';
  available: Scalars['Boolean'];
  displayPrice?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  menuItem: GuestMenuItem;
  name: Scalars['String'];
  position: Scalars['Int'];
  showFullPrice: Scalars['Boolean'];
};

export type GuestUpgradeGroup = {
  __typename?: 'GuestUpgradeGroup';
  available: Scalars['Boolean'];
  /** if true, the first item of the upsells should be preselected on the UI */
  hasPreselectedOption: Scalars['Boolean'];
  id: Scalars['ID'];
  maxQuantity?: Maybe<Scalars['Int']>;
  minQuantity: Scalars['Int'];
  name: Scalars['String'];
  orderingTypes?: Maybe<Array<OrderingType>>;
  selectRequirement: MenuItemSelectRequirement;
  selectType: MenuItemSelectType;
  upgrades: Array<GuestUpgrade>;
};

export type GuestUpsell = {
  __typename?: 'GuestUpsell';
  available: Scalars['Boolean'];
  displayPrice?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  menuItem: GuestMenuItem;
  name: Scalars['String'];
  position: Scalars['Int'];
  showFullPrice: Scalars['Boolean'];
};

export type GuestUpsellGroup = {
  __typename?: 'GuestUpsellGroup';
  available: Scalars['Boolean'];
  displayViewSelectRequirement: DisplayViewSelectRequirement;
  hasPreselectedOption?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isDynamic?: Maybe<Scalars['Boolean']>;
  maxQuantity?: Maybe<Scalars['Int']>;
  minQuantity: Scalars['Int'];
  name: Scalars['String'];
  orderingTypes?: Maybe<Array<OrderingType>>;
  respectCartQuantity?: Maybe<Scalars['Boolean']>;
  selectRequirement: MenuItemSelectRequirement;
  selectType: MenuItemSelectType;
  type: MenuUpsellGroupType;
  upsells: Array<GuestUpsell>;
};

export type GuestVenue = {
  __typename?: 'GuestVenue';
  ageRestrictionText?: Maybe<Scalars['String']>;
  alwaysShowVisualMenu?: Maybe<Scalars['Boolean']>;
  availableOrderingType: OrderingType;
  banner?: Maybe<GuestImage>;
  /** @deprecated Use Flexible Wait Times */
  barBusyUntil?: Maybe<Scalars['String']>;
  bookingLink?: Maybe<Scalars['String']>;
  brandingAccent?: Maybe<Scalars['String']>;
  brandingAccentText?: Maybe<Scalars['String']>;
  brandingEnabled: Scalars['Boolean'];
  brandingPrimary?: Maybe<Scalars['String']>;
  brandingPrimaryText?: Maybe<Scalars['String']>;
  canSkipGratuity: Scalars['Boolean'];
  clubMembershipsEnabled: Scalars['Boolean'];
  countryCode: Scalars['String'];
  cuisines?: Maybe<Array<Cuisine>>;
  currency: Scalars['String'];
  customGratuityText?: Maybe<Scalars['String']>;
  defaultOrderingType?: Maybe<OrderingType>;
  facebookPixelId?: Maybe<Scalars['String']>;
  flexibleGratuityEnabled: Scalars['Boolean'];
  googleTagManagerId?: Maybe<Scalars['String']>;
  gratuityEnabled: Scalars['Boolean'];
  gratuityOptions?: Maybe<Array<Scalars['Float']>>;
  gratuityRate: Scalars['Float'];
  guestRegistrySetting?: Maybe<GuestRegistrySettings>;
  hours?: Maybe<TimeBlocks>;
  id: Scalars['ID'];
  isBarBusy: Scalars['Boolean'];
  isClosed: Scalars['Boolean'];
  isIframe?: Maybe<Scalars['Boolean']>;
  isKitchenBusy: Scalars['Boolean'];
  isLive: Scalars['Boolean'];
  isOrderingAvailable: Scalars['Boolean'];
  /** @deprecated Use Flexible Wait Times */
  kitchenBusyUntil?: Maybe<Scalars['String']>;
  landingCallToActionText?: Maybe<Scalars['String']>;
  landingCallToActionUrl?: Maybe<Scalars['String']>;
  landingWelcomeText?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  logo?: Maybe<GuestImage>;
  marketingOptInDefault?: Maybe<Scalars['Boolean']>;
  marketingOptInEnabled?: Maybe<Scalars['Boolean']>;
  marketingOptInMessage?: Maybe<Scalars['String']>;
  mobileBanner?: Maybe<GuestImage>;
  multiVendorEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  ogImage?: Maybe<GuestImage>;
  openGraphImage?: Maybe<GuestImage>;
  ordering: Scalars['Boolean'];
  orderingType?: Maybe<OrderingTypeSetting>;
  orderingTypes: Array<OrderingTypeSetting>;
  organizationId?: Maybe<Scalars['String']>;
  paymentProcessor?: Maybe<GuestVenuePaymentProcessor>;
  popupNotificationImage?: Maybe<GuestImage>;
  popupNotificationText?: Maybe<Scalars['String']>;
  posIntegration?: Maybe<GuestVenuePosIntegration>;
  showCategoryListViewOnLandingPage: Scalars['Boolean'];
  showOrderingTypePicker?: Maybe<Scalars['Boolean']>;
  skipTableNumberModal?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  squareThumbImage?: Maybe<GuestImage>;
  startTabAvailable?: Maybe<Scalars['Boolean']>;
  supportEmail?: Maybe<Scalars['String']>;
  supportPhone?: Maybe<Scalars['String']>;
  surveyLink?: Maybe<Scalars['String']>;
  tableAreas?: Maybe<Scalars['String']>;
  tableText: Scalars['String'];
  tabsEnabled?: Maybe<Scalars['Boolean']>;
  timezone?: Maybe<Scalars['String']>;
  tipjarUrl?: Maybe<Scalars['String']>;
  yumpingoVenueId?: Maybe<Scalars['String']>;
};


export type GuestVenueBannerArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type GuestVenueLogoArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type GuestVenueMobileBannerArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type GuestVenueOgImageArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type GuestVenueOrderingTypeArgs = {
  orderingType?: Maybe<OrderingType>;
};


export type GuestVenueOrderingTypesArgs = {
  orderingType?: Maybe<OrderingType>;
};

export type GuestVenuePaymentProcessor = {
  __typename?: 'GuestVenuePaymentProcessor';
  id: Scalars['ID'];
  types: Array<GuestVenuePaymentProcessorType>;
  unpaidProcessorTypeLabel?: Maybe<Scalars['String']>;
};

export enum GuestVenuePaymentProcessorType {
  Afterpay = 'AFTERPAY',
  Braintree = 'BRAINTREE',
  Cash = 'CASH',
  ChargeToRoom = 'CHARGE_TO_ROOM',
  Eonx = 'EONX',
  Loke = 'LOKE',
  Paystack = 'PAYSTACK',
  Peach = 'PEACH',
  SharedPayment = 'SHARED_PAYMENT',
  Snapscan = 'SNAPSCAN',
  Stripe = 'STRIPE',
  Unpaid = 'UNPAID',
  Wallet = 'WALLET'
}

export type GuestVenuePosIntegration = {
  __typename?: 'GuestVenuePosIntegration';
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
};

export type GuestVoucher = {
  __typename?: 'GuestVoucher';
  barcode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  imgSrc?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Float']>;
};

export type GuestWaitTime = {
  __typename?: 'GuestWaitTime';
  estimate: WaitTimeEstimateType;
  estimateInMilliseconds?: Maybe<Scalars['Int']>;
  expiry: WaitTimeExpiryType;
  expiryEndTime?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
};

export enum HyperwalletTransferMethodStatus {
  Activated = 'ACTIVATED',
  DeActivated = 'DE_ACTIVATED',
  Invalid = 'INVALID',
  Verified = 'VERIFIED'
}

export type HyperwalletUser = {
  __typename?: 'HyperwalletUser';
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  status: HyperwalletUserStatus;
  token: Scalars['String'];
  transferMethodCountry?: Maybe<Scalars['String']>;
  transferMethodCurrency?: Maybe<Scalars['String']>;
  transferMethodStatus?: Maybe<HyperwalletTransferMethodStatus>;
  transferMethodToken?: Maybe<Scalars['String']>;
};

export enum HyperwalletUserStatus {
  Activated = 'ACTIVATED',
  DeActivated = 'DE_ACTIVATED',
  Frozen = 'FROZEN',
  Locked = 'LOCKED',
  PreActivated = 'PRE_ACTIVATED'
}

export type ImageSource = {
  __typename?: 'ImageSource';
  sourceUrls: Array<SourceUrl>;
  type: Scalars['String'];
};

export type ItemValidation = {
  __typename?: 'ItemValidation';
  canDecrement: Scalars['Boolean'];
  canIncrement: Scalars['Boolean'];
  id: Scalars['String'];
  itemsDeleted: Array<CartItem>;
};

export type LineItem = {
  __typename?: 'LineItem';
  category: MenuItemCategory;
  children?: Maybe<Array<LineItem>>;
  description?: Maybe<Scalars['String']>;
  externalPosGroupId?: Maybe<Scalars['String']>;
  externalPosId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  kind: LineItemKind;
  menuItemId?: Maybe<Scalars['String']>;
  menuItemModifierId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Discounts won't be modifying the price */
  originalPriceInCents: Scalars['Float'];
  parentId?: Maybe<Scalars['String']>;
  paymentTransactionId?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Float'];
  quantity: Scalars['Float'];
  shortName?: Maybe<Scalars['String']>;
  taxAmountInCents?: Maybe<Scalars['Int']>;
  taxRate: Scalars['Float'];
  type: LineItemType;
};

export enum LineItemKind {
  Affirmation = 'AFFIRMATION',
  Reversal = 'REVERSAL'
}

/** LineItemReportDataFieldType available fields to customize */
export enum LineItemReportDataFieldType {
  Category = 'CATEGORY',
  CreatedAt = 'CREATED_AT',
  CustomerCreatedAt = 'CUSTOMER_CREATED_AT',
  CustomerEmail = 'CUSTOMER_EMAIL',
  CustomerId = 'CUSTOMER_ID',
  CustomerMobile = 'CUSTOMER_MOBILE',
  CustomerName = 'CUSTOMER_NAME',
  DineInNotes = 'DINE_IN_NOTES',
  DiscountDescription = 'DISCOUNT_DESCRIPTION',
  ExternalPosGroupId = 'EXTERNAL_POS_GROUP_ID',
  ExternalPosId = 'EXTERNAL_POS_ID',
  Kind = 'KIND',
  MenuCategoryName = 'MENU_CATEGORY_NAME',
  MenuSectionName = 'MENU_SECTION_NAME',
  OrderingWindowStartDate = 'ORDERING_WINDOW_START_DATE',
  OrderAddress = 'ORDER_ADDRESS',
  OrderAddressUnit = 'ORDER_ADDRESS_UNIT',
  OrderId = 'ORDER_ID',
  OrderNotes = 'ORDER_NOTES',
  OrderOption = 'ORDER_OPTION',
  OrderPostcode = 'ORDER_POSTCODE',
  PaymentProcessor = 'PAYMENT_PROCESSOR',
  PaymentTransactionId = 'PAYMENT_TRANSACTION_ID',
  PosStatus = 'POS_STATUS',
  PreDiscountPrice = 'PRE_DISCOUNT_PRICE',
  Price = 'PRICE',
  PrinterGroupName = 'PRINTER_GROUP_NAME',
  ProductName = 'PRODUCT_NAME',
  Quantity = 'QUANTITY',
  RefundTransactionId = 'REFUND_TRANSACTION_ID',
  Status = 'STATUS',
  TableNumber = 'TABLE_NUMBER',
  TotalPrice = 'TOTAL_PRICE',
  Type = 'TYPE',
  VenueId = 'VENUE_ID'
}

export enum LineItemType {
  AbsoluteDiscount = 'ABSOLUTE_DISCOUNT',
  CardFee = 'CARD_FEE',
  ComboItem = 'COMBO_ITEM',
  DeliveryFee = 'DELIVERY_FEE',
  Gratuity = 'GRATUITY',
  MenuItem = 'MENU_ITEM',
  Modifier = 'MODIFIER',
  ServiceCharge = 'SERVICE_CHARGE',
  SpecialItem = 'SPECIAL_ITEM',
  UpsellItem = 'UPSELL_ITEM',
  VirtualItem = 'VIRTUAL_ITEM'
}


export type Location = {
  __typename?: 'Location';
  adminArea1?: Maybe<Scalars['String']>;
  adminArea1Long?: Maybe<Scalars['String']>;
  adminArea2?: Maybe<Scalars['String']>;
  adminArea2Long?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  countryCode: Scalars['String'];
  formattedAddress: Scalars['String'];
  googlePlaceId: Scalars['String'];
  id: Scalars['String'];
  latitude: Scalars['Float'];
  locality?: Maybe<Scalars['String']>;
  localityLong?: Maybe<Scalars['String']>;
  longitude: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  priceLevel?: Maybe<Scalars['Float']>;
  route?: Maybe<Scalars['String']>;
  routeLong?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetAddressLong?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type LoginAsTestGuestInput = {
  /** When true, guest ids are recreated, otherwise, guest is reused from the test bank. */
  fresh: Scalars['Boolean'];
};

export type LoginAsTestGuestPayload = {
  __typename?: 'LoginAsTestGuestPayload';
  id: Scalars['String'];
  mobile: Scalars['String'];
};

export type LoginInput = {
  /** Mobile phone number in international format */
  mobile: Scalars['String'];
  /** One time password */
  otp: Scalars['String'];
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  mobile: Scalars['String'];
};

export type LoyaltyDetailsInput = {
  externalMemberId?: Maybe<Scalars['String']>;
  venueSlug: Scalars['String'];
};

export type LoyaltyDetailsPayload = {
  __typename?: 'LoyaltyDetailsPayload';
  features: LoyaltyFeaturesPayload;
  guestData?: Maybe<LoyaltyGuestDataPayload>;
  id: Scalars['String'];
  lastOrder?: Maybe<LoyaltyLastOrderPayload>;
  metadata?: Maybe<LoyaltyMetadataPayload>;
  points?: Maybe<LoyaltyGuestDataPayload>;
  rewards?: Maybe<Array<LoyaltyRewardPayload>>;
  vouchers?: Maybe<Array<GuestVoucher>>;
};

export type LoyaltyFeaturesPayload = {
  __typename?: 'LoyaltyFeaturesPayload';
  canEarnPoints: Scalars['Boolean'];
  canOptIn: Scalars['Boolean'];
  canShowPointBalance: Scalars['Boolean'];
  canSignUp: Scalars['Boolean'];
  canSpendPoints: Scalars['Boolean'];
  /** Venue ID */
  id: Scalars['String'];
};

export type LoyaltyGuestDataPayload = {
  __typename?: 'LoyaltyGuestDataPayload';
  /** Guest ID */
  id: Scalars['String'];
  isOptedIn: Scalars['Boolean'];
  points: Scalars['Float'];
};

export type LoyaltyLastOrderPayload = {
  __typename?: 'LoyaltyLastOrderPayload';
  /** Order ID */
  id: Scalars['String'];
  points: Scalars['Float'];
};

export type LoyaltyMetadata = {
  __typename?: 'LoyaltyMetadata';
  createAccountCaption?: Maybe<Scalars['String']>;
  earnPointsCaption?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  infoLink?: Maybe<Scalars['String']>;
  introBody?: Maybe<Scalars['String']>;
  introHeader?: Maybe<Scalars['String']>;
  introHeaderImage?: Maybe<CdnImage>;
  memberName?: Maybe<Scalars['String']>;
  minimumPointsRequired?: Maybe<Scalars['Float']>;
  organizationId?: Maybe<Scalars['String']>;
  pointEquivalent?: Maybe<Scalars['Float']>;
  pointName?: Maybe<Scalars['String']>;
  pointToDollarEquivalent?: Maybe<Scalars['Float']>;
  programName?: Maybe<Scalars['String']>;
  spendPointsCaption?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['String']>;
};


export type LoyaltyMetadataIntroHeaderImageArgs = {
  transform?: Maybe<Scalars['String']>;
};

export type LoyaltyMetadataPayload = {
  __typename?: 'LoyaltyMetadataPayload';
  createAccountCaption?: Maybe<Scalars['String']>;
  earnPointsCaption?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  infoLink?: Maybe<Scalars['String']>;
  introBody?: Maybe<Scalars['String']>;
  introHeader?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  minimumPointsRequired?: Maybe<Scalars['Float']>;
  pointEquivalent?: Maybe<Scalars['Float']>;
  pointName?: Maybe<Scalars['String']>;
  pointToDollarEquivalent?: Maybe<Scalars['Float']>;
  programName?: Maybe<Scalars['String']>;
  spendPointsCaption?: Maybe<Scalars['String']>;
};

export type LoyaltyRewardPayload = {
  __typename?: 'LoyaltyRewardPayload';
  id: Scalars['String'];
  name: Scalars['String'];
  rewardId: Scalars['String'];
};

export type MslAuthSettings = {
  __typename?: 'MSLAuthSettings';
  id: Scalars['String'];
  membershipAuthUrl?: Maybe<Scalars['String']>;
};

export type MarketingOptIn = {
  __typename?: 'MarketingOptIn';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  optInMessage?: Maybe<Scalars['String']>;
  user: User;
};

/** Fields which affect the menu category listing */
export type MenuCategoriesInput = {
  orderingType?: Maybe<OrderingType>;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
};

export type MenuCategory = {
  __typename?: 'MenuCategory';
  hideMenuWhenClosed: Scalars['Boolean'];
  hours?: Maybe<TimeBlocks>;
  id: Scalars['String'];
  image?: Maybe<CdnImage>;
  isClosed: Scalars['Boolean'];
  menuCategoryToMenuSection: Array<MenuCategoryToMenuSection>;
  menuCategoryToVenue: Array<VenueToMenuCategory>;
  menuCategoryType: MenuCategoryType;
  menuItem: MenuItem;
  name: Scalars['String'];
  orderingType?: Maybe<Array<OrderingType>>;
  slug: Scalars['String'];
  tableGroupToMenuCategories: Array<TableGroupToMenuCategory>;
};


export type MenuCategoryImageArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type MenuCategoryMenuItemArgs = {
  menuItemId: Scalars['String'];
};

export type MenuCategoryAvailabilityInput = {
  orderingType?: Maybe<OrderingType>;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
};

export type MenuCategoryToMenuSection = {
  __typename?: 'MenuCategoryToMenuSection';
  id: Scalars['String'];
  menuCategory: MenuCategory;
  menuCategoryId: Scalars['String'];
  menuSection: MenuSection;
  menuSectionId: Scalars['String'];
  position: Scalars['Float'];
  sectionWaitTime?: Maybe<WaitTimeDto>;
};

export enum MenuCategoryType {
  Bar = 'BAR',
  Kitchen = 'KITCHEN'
}

export type MenuItem = {
  __typename?: 'MenuItem';
  allergens?: Maybe<Array<Allergens>>;
  available: Scalars['Boolean'];
  batchingGroup?: Maybe<BatchingGroup>;
  category: MenuItemCategory;
  cdnImage?: Maybe<CdnImage>;
  /** Description of the item in markdown. */
  description?: Maybe<Scalars['String']>;
  /** Description of the item in plain text. */
  descriptionPlain?: Maybe<Scalars['String']>;
  /** Description in German for the item. */
  descriptionde?: Maybe<Scalars['String']>;
  /** Description in Greek for the item. */
  descriptionel?: Maybe<Scalars['String']>;
  /** Description in Spanish for the item. */
  descriptiones?: Maybe<Scalars['String']>;
  /** Description in French for the item. */
  descriptionfr?: Maybe<Scalars['String']>;
  /** Description in Italian for the item. */
  descriptionit?: Maybe<Scalars['String']>;
  /** Description in Mandarin for the item. */
  descriptionzhCN?: Maybe<Scalars['String']>;
  /** Dietary descriptors. */
  dietaryDescriptors?: Maybe<Scalars['String']>;
  /** Dietary tags. */
  dietaryTags?: Maybe<Array<Scalars['String']>>;
  externalPosId?: Maybe<Scalars['String']>;
  externalPosPriceInCents?: Maybe<Scalars['Float']>;
  /** Dietary filters. */
  filterTags?: Maybe<Array<Scalars['String']>>;
  hide: Scalars['Boolean'];
  hideFromMenu: Scalars['Boolean'];
  /** Id of the menu item. */
  id: Scalars['String'];
  /** Image credit */
  imageCredit?: Maybe<Scalars['String']>;
  includeInSmartSuggestions: Scalars['Boolean'];
  inventoryCount: Scalars['Float'];
  inventoryEnabled: Scalars['Boolean'];
  isAvailable: Scalars['Boolean'];
  isAvailableForOrdering: Scalars['Boolean'];
  isLive: Scalars['Boolean'];
  isPopular: Scalars['Boolean'];
  isTaxExempt: Scalars['Boolean'];
  isUnavailableUntil: Scalars['Boolean'];
  maxQuantity?: Maybe<Scalars['Float']>;
  menuItemToMenuSection: Array<MenuItemToMenuSection>;
  menuItemToModifierGroups: Array<MenuItemToModifierGroup>;
  menuItemToUpgradeGroup: Array<MenuItemToItemUpsellGroup>;
  menuItemToUpsellGroup: Array<MenuItemToItemUpsellGroup>;
  menuItemUpgradeGroup?: Maybe<MenuItemUpgradeGroup>;
  minQuantity: Scalars['Float'];
  modifierGroups?: Maybe<Array<MenuItemModifierGroup>>;
  name?: Maybe<Scalars['String']>;
  /** Name in German for the item. */
  namede?: Maybe<Scalars['String']>;
  /** Name in Greek for the item. */
  nameel?: Maybe<Scalars['String']>;
  /** Name in Spanish for the item. */
  namees?: Maybe<Scalars['String']>;
  /** Name in French for the item. */
  namefr?: Maybe<Scalars['String']>;
  /** Name in Italian for the item. */
  nameit?: Maybe<Scalars['String']>;
  /** Name in Mandarin for the item. */
  namezhCN?: Maybe<Scalars['String']>;
  /** Price of the item. */
  price?: Maybe<Scalars['String']>;
  priceData: PriceData;
  /** Price in cents. */
  priceInCents?: Maybe<Scalars['Float']>;
  priceLevels?: Maybe<Array<PriceLevel>>;
  printerGroup?: Maybe<PrinterGroup>;
  shortName?: Maybe<Scalars['String']>;
  /** Simplified description of the item. */
  simpleDescription?: Maybe<Scalars['String']>;
  /** Name of the item. */
  simpleName?: Maybe<Scalars['String']>;
  /** Item slug. */
  slug: Scalars['String'];
  taxRate?: Maybe<Scalars['Float']>;
  /** Item type. */
  type?: Maybe<Scalars['String']>;
  unavailableUntil?: Maybe<Scalars['DateTime']>;
  virtual: Scalars['Boolean'];
};


export type MenuItemCdnImageArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type MenuItemIsAvailableForOrderingArgs = {
  input?: Maybe<MenuItemAvailabilityInput>;
};


export type MenuItemMenuItemToModifierGroupsArgs = {
  upgradeId?: Maybe<Scalars['String']>;
};


export type MenuItemModifierGroupsArgs = {
  upgradeId?: Maybe<Scalars['String']>;
};


export type MenuItemPriceDataArgs = {
  orderingWindowStartDate?: Maybe<Scalars['DateTime']>;
};

/** Fields which affect menu item availability */
export type MenuItemAvailabilityInput = {
  orderingType?: Maybe<OrderingType>;
  orderingWindowStartDate?: Maybe<Scalars['DateTime']>;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
};

export enum MenuItemCategory {
  AlcoholicDrink = 'ALCOHOLIC_DRINK',
  Dessert = 'DESSERT',
  Drink = 'DRINK',
  Food = 'FOOD',
  Kid = 'KID',
  Main = 'MAIN',
  Merchandise = 'MERCHANDISE',
  NonAlcoholicDrink = 'NON_ALCOHOLIC_DRINK',
  Other = 'OTHER',
  Retail = 'RETAIL',
  SidesStarterAppetizer = 'SIDES_STARTER_APPETIZER'
}

export type MenuItemModifier = {
  __typename?: 'MenuItemModifier';
  available: Scalars['Boolean'];
  externalPosGroupId?: Maybe<Scalars['String']>;
  externalPosGroupName?: Maybe<Scalars['String']>;
  externalPosId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isTaxExempt: Scalars['Boolean'];
  maxQuantity?: Maybe<Scalars['Int']>;
  modifierToModifierGroup: Array<ModifierToModifierGroup>;
  name: Scalars['String'];
  price?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Float'];
  priceLevels?: Maybe<Array<PriceLevel>>;
  shortName?: Maybe<Scalars['String']>;
  taxRate?: Maybe<Scalars['Float']>;
  venue: Venue;
};

export type MenuItemModifierGroup = {
  __typename?: 'MenuItemModifierGroup';
  available: Scalars['Boolean'];
  /** Display view options for modifiers */
  displayViewRequirement: DisplayViewSelectRequirement;
  /** if true, the first item of the upsells should be preselected on the UI */
  hasPreselectedOption: Scalars['Boolean'];
  id: Scalars['String'];
  isModifierGroupSynced?: Maybe<Scalars['Boolean']>;
  maxQuantity?: Maybe<Scalars['Float']>;
  menuItem?: Maybe<MenuItem>;
  menuItemToModifierGroups: Array<MenuItemToModifierGroup>;
  minQuantity: Scalars['Float'];
  modifierGroupToModifier?: Maybe<Array<ModifierToModifierGroup>>;
  name: Scalars['String'];
  orderingType?: Maybe<Array<OrderingType>>;
  position: Scalars['Float'];
  selectRequirement: MenuItemSelectRequirement;
  selectType: MenuItemSelectType;
  venueId?: Maybe<Scalars['String']>;
};

export enum MenuItemSelectRequirement {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export enum MenuItemSelectType {
  Multi = 'MULTI',
  Single = 'SINGLE'
}

export type MenuItemToItemUpsellGroup = {
  __typename?: 'MenuItemToItemUpsellGroup';
  id: Scalars['String'];
  menuItem: MenuItem;
  position: Scalars['Float'];
  upsellGroup: MenuItemUpsellGroup;
};

export type MenuItemToMenuSection = {
  __typename?: 'MenuItemToMenuSection';
  id: Scalars['String'];
  menuItem: MenuItem;
  menuSection: MenuSection;
  position: Scalars['Float'];
};

export type MenuItemToModifierGroup = {
  __typename?: 'MenuItemToModifierGroup';
  id: Scalars['String'];
  menuItem: MenuItem;
  modifierGroup: MenuItemModifierGroup;
  position: Scalars['Float'];
};

export type MenuItemUpgrade = {
  __typename?: 'MenuItemUpgrade';
  available: Scalars['Boolean'];
  groupId: Scalars['String'];
  id: Scalars['String'];
  menuItem: MenuItem;
  menuItemId: Scalars['String'];
  name: Scalars['String'];
  position: Scalars['Float'];
  price?: Maybe<Scalars['String']>;
  showFullPrice: Scalars['Boolean'];
};


export type MenuItemUpgradePriceArgs = {
  orderingWindowStartDate?: Maybe<Scalars['DateTime']>;
};

export type MenuItemUpgradeGroup = {
  __typename?: 'MenuItemUpgradeGroup';
  available: Scalars['Boolean'];
  hasPreselectedOption: Scalars['Boolean'];
  id: Scalars['String'];
  maxQuantity?: Maybe<Scalars['Float']>;
  minQuantity: Scalars['Float'];
  name: Scalars['String'];
  orderingType?: Maybe<Array<OrderingType>>;
  respectCartQuantity: Scalars['Boolean'];
  selectRequirement: MenuItemSelectRequirement;
  selectType: MenuItemSelectType;
  upgrades?: Maybe<Array<MenuItemUpgrade>>;
};

export type MenuItemUpsell = {
  __typename?: 'MenuItemUpsell';
  available: Scalars['Boolean'];
  id: Scalars['String'];
  menuItem: MenuItem;
  name: Scalars['String'];
  position: Scalars['Float'];
  price?: Maybe<Scalars['String']>;
  showFullPrice: Scalars['Boolean'];
};


export type MenuItemUpsellPriceArgs = {
  orderingWindowStartDate?: Maybe<Scalars['DateTime']>;
};

export type MenuItemUpsellGroup = {
  __typename?: 'MenuItemUpsellGroup';
  available: Scalars['Boolean'];
  /** Display view options for upsells */
  displayViewRequirement: DisplayViewSelectRequirement;
  /** @deprecated upgrades are now in separate table */
  groupType: MenuUpsellGroupType;
  hasPreselectedOption: Scalars['Boolean'];
  id: Scalars['String'];
  isDynamic?: Maybe<Scalars['Boolean']>;
  linkedMenuItems?: Maybe<Array<Scalars['String']>>;
  maxQuantity?: Maybe<Scalars['Float']>;
  minQuantity: Scalars['Float'];
  name: Scalars['String'];
  orderingType?: Maybe<Array<OrderingType>>;
  respectCartQuantity: Scalars['Boolean'];
  selectRequirement: MenuItemSelectRequirement;
  selectType: MenuItemSelectType;
  upsellGroupToMenuItem?: Maybe<Array<MenuItemToItemUpsellGroup>>;
  upsells?: Maybe<Array<MenuItemUpsell>>;
};

export type MenuSection = {
  __typename?: 'MenuSection';
  id: Scalars['String'];
  menuSectionToMenuCategory: Array<MenuCategoryToMenuSection>;
  menuSectionToMenuItem: Array<MenuItemToMenuSection>;
  name: Scalars['String'];
  slug: Scalars['String'];
  subSection?: Maybe<Scalars['String']>;
};

export enum MenuUpsellGroupType {
  Upgrade = 'UPGRADE',
  Upsell = 'UPSELL'
}

export type MenuWaitTime = {
  __typename?: 'MenuWaitTime';
  id: Scalars['String'];
  menuCategory: MenuCategory;
  menuSection?: Maybe<MenuSection>;
  waitTimeEndAt?: Maybe<Scalars['DateTime']>;
  waitTimeEstimate: WaitTimeEstimateType;
  waitTimeExpiry: WaitTimeExpiryType;
  waitTimeMilliseconds?: Maybe<Scalars['Int']>;
};

export type ModifierToModifierGroup = {
  __typename?: 'ModifierToModifierGroup';
  id: Scalars['String'];
  modifier: MenuItemModifier;
  modifierGroup: MenuItemModifierGroup;
  position: Scalars['Float'];
};

export type MslTokenPayload = {
  __typename?: 'MslTokenPayload';
  token: Scalars['String'];
};

export type MultiVendorInvoicePayload = {
  __typename?: 'MultiVendorInvoicePayload';
  multiVendorOrder: MultiVendorOrder;
  orders: Array<Order>;
};

export type MultiVendorOrder = {
  __typename?: 'MultiVendorOrder';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  orders: Array<Order>;
  totalInCents: Scalars['Int'];
  userId?: Maybe<Scalars['ID']>;
  venue: Venue;
  venueId: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addGuestMembership: AddGuestMembershipPayload;
  addOrUpdateLocationOnCart: Cart;
  addOrUpdateNotesOnCart: Cart;
  addOrUpdateOptionsOnCart: Cart;
  addOrUpdateTableNumberOnCart: Cart;
  addOrUpdateWindowOnCart: Cart;
  addToCart: Cart;
  applyCartClubMembershipSurcount: Cart;
  applyCartDiscount: Cart;
  applyCartEonxDetails: Cart;
  applyCartLoyaltyDiscount: Cart;
  applyCartTip: Cart;
  authenticateSwiftPosMember?: Maybe<MslTokenPayload>;
  chargeSharedPayment: ChargeSharedPaymentPayload;
  closeTab: Scalars['String'];
  confirmMember: ConfirmSocialTabMemberResponse;
  createCart: Cart;
  createOrder: OrderCreateResponse;
  createRegistryGuest: RegistryGuest;
  eonxCheckInGuest: User;
  findOrCreateSharedPayment: FindOrCreateSharedPaymentPayload;
  getPaymentIntent?: Maybe<StripePaymentIntent>;
  optInToLoyalty: OptInToLoyaltyPayload;
  redeemOrderWinnings?: Maybe<Order>;
  refreshCartPrices?: Maybe<Cart>;
  removeCartDiscount: Cart;
  removeCartDiscountByCode: Cart;
  removeCartServiceCharge: Cart;
  removeItemFromCart: Cart;
  removeUnavailableItems?: Maybe<Cart>;
  reorder: Cart;
  repositionModifierGroup: MenuItemModifierGroup;
  setSocialTabLimit: SocialTab;
  startTab: StartTabResponse;
  touchCart?: Maybe<Scalars['Boolean']>;
  updateCart: Cart;
  updateCartItemQuantity: Cart;
  updateMarketingOptIn: User;
  validateDoordashOrderDelivery: ValidateDoordashDeliveryResponse;
  login: LoginPayload;
  loginAsAnonymousGuest: LoginPayload;
  loginAsTestGuest: LoginAsTestGuestPayload;
  refreshSession: RefreshSessionPayload;
  sendOneTimePasswordSMS: SendOneTimePasswordSmsPayload;
  addToFlexibleGuestOrders: AddFlexibleGuestOrdersPayload;
  charge: ChargeActionRequired;
  createPaymentIntent: CreatePaymentIntentResponse;
  createPaymentMethod: UserActionRequired;
  createReview: Review;
  updateCurrentCustomer: User;
  updateCustomerDetails?: Maybe<User>;
  updateCustomerDetailsAndSendReceipt?: Maybe<User>;
  updateReview: Review;
};


export type MutationAddGuestMembershipArgs = {
  input: AddGuestMembershipInput;
};


export type MutationAddOrUpdateLocationOnCartArgs = {
  input: CartLocationInput;
};


export type MutationAddOrUpdateNotesOnCartArgs = {
  input: CartNotesInput;
};


export type MutationAddOrUpdateOptionsOnCartArgs = {
  input: CartOptionsInput;
};


export type MutationAddOrUpdateTableNumberOnCartArgs = {
  input: CartTableNumberInput;
};


export type MutationAddOrUpdateWindowOnCartArgs = {
  input: CartOrderingWindowInput;
};


export type MutationAddToCartArgs = {
  input: CartItemInput;
};


export type MutationApplyCartClubMembershipSurcountArgs = {
  input: CartClubMembershipSurcountApplyInput;
};


export type MutationApplyCartDiscountArgs = {
  input: CartDiscountApplyInput;
};


export type MutationApplyCartEonxDetailsArgs = {
  venueSlug: Scalars['String'];
};


export type MutationApplyCartLoyaltyDiscountArgs = {
  input: CartLoyaltyDiscountApplyInput;
};


export type MutationApplyCartTipArgs = {
  input: CartTipApplyInput;
};


export type MutationAuthenticateSwiftPosMemberArgs = {
  code: Scalars['String'];
  venueSlug: Scalars['String'];
};


export type MutationChargeSharedPaymentArgs = {
  order: ChargeSharedPaymentInput;
};


export type MutationCloseTabArgs = {
  tabId: Scalars['String'];
};


export type MutationConfirmMemberArgs = {
  tabId: Scalars['String'];
};


export type MutationCreateCartArgs = {
  googlePlaceId?: Maybe<Scalars['String']>;
  orderingType: OrderingType;
  revalidate?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
};


export type MutationCreateOrderArgs = {
  order: CreateOrderInput;
};


export type MutationCreateRegistryGuestArgs = {
  data: GuestCreateInput;
};


export type MutationEonxCheckInGuestArgs = {
  id: Scalars['String'];
  venueSlug: Scalars['String'];
};


export type MutationFindOrCreateSharedPaymentArgs = {
  input: FindOrCreateSharedPaymentInput;
};


export type MutationGetPaymentIntentArgs = {
  amount: Scalars['Int'];
  cartId?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  customerId?: Maybe<Scalars['String']>;
  isSocialTabPreAuth?: Maybe<Scalars['Boolean']>;
  sharedPaymentId?: Maybe<Scalars['String']>;
  venueSlug?: Maybe<Scalars['String']>;
};


export type MutationOptInToLoyaltyArgs = {
  input: OptInToLoyaltyInput;
};


export type MutationRedeemOrderWinningsArgs = {
  orderId: Scalars['String'];
  venueSlug: Scalars['String'];
};


export type MutationRefreshCartPricesArgs = {
  input: CartInputBase;
};


export type MutationRemoveCartDiscountArgs = {
  input: CartDiscountRemove;
};


export type MutationRemoveCartDiscountByCodeArgs = {
  input: CartDiscountRemoveByCode;
};


export type MutationRemoveCartServiceChargeArgs = {
  input: CartServiceChargeRemove;
};


export type MutationRemoveItemFromCartArgs = {
  input: CartItemsRemove;
};


export type MutationRemoveUnavailableItemsArgs = {
  input: CartInputBase;
};


export type MutationReorderArgs = {
  orderId: Scalars['String'];
  venueSlug: Scalars['String'];
};


export type MutationRepositionModifierGroupArgs = {
  menuItemId?: Maybe<Scalars['String']>;
  modifierGroupId: Scalars['String'];
  position: Scalars['Float'];
  venueId: Scalars['String'];
};


export type MutationSetSocialTabLimitArgs = {
  maxSpendInCents: Scalars['Float'];
  tabId: Scalars['String'];
};


export type MutationStartTabArgs = {
  data: StartTabInput;
};


export type MutationUpdateCartArgs = {
  checkMembership?: Maybe<Scalars['Boolean']>;
  orderingType: OrderingType;
  revalidate?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};


export type MutationUpdateCartItemQuantityArgs = {
  input: CartItemQuantityUpdate;
};


export type MutationUpdateMarketingOptInArgs = {
  input: UpdateMarketingOptInInput;
};


export type MutationValidateDoordashOrderDeliveryArgs = {
  doordash: ValidateDoordashOrderDeliveryInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginAsTestGuestArgs = {
  input: LoginAsTestGuestInput;
};


export type MutationRefreshSessionArgs = {
  input: RefreshSessionInput;
};


export type MutationSendOneTimePasswordSmsArgs = {
  input: SendOneTimePasswordSmsInput;
};


export type MutationAddToFlexibleGuestOrdersArgs = {
  input: AddToFlexibleGuestOrdersInput;
  isError?: Maybe<Scalars['Boolean']>;
};


export type MutationChargeArgs = {
  input: ChargeInput;
};


export type MutationCreatePaymentIntentArgs = {
  input: CreatePaymentIntentInput;
};


export type MutationCreatePaymentMethodArgs = {
  input: CreatePaymentMethodInput;
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationUpdateCurrentCustomerArgs = {
  input: UpdateCurrentCustomerInput;
};


export type MutationUpdateCustomerDetailsArgs = {
  customerId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  isOver18?: Maybe<Scalars['Boolean']>;
  marketingUserOptIn?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  savePaymentDetails?: Maybe<Scalars['Boolean']>;
  venueSlug?: Maybe<Scalars['String']>;
};


export type MutationUpdateCustomerDetailsAndSendReceiptArgs = {
  receiptEmail: Scalars['String'];
  venueSlug: Scalars['String'];
};


export type MutationUpdateReviewArgs = {
  input: UpdateReviewInput;
};

export type MvoSearchResult = {
  __typename?: 'MvoSearchResult';
  categoryId: Scalars['String'];
  categoryName: Scalars['String'];
  categorySlug: Scalars['String'];
  extendedWaitTime?: Maybe<GuestWaitTime>;
  image?: Maybe<GuestImage>;
  isClosed: Scalars['Boolean'];
  menuCategoryType: MenuCategoryType;
  menuItems: Array<GuestMenuItem>;
  mvoFeatured?: Maybe<Scalars['Boolean']>;
  orderingType?: Maybe<Array<OrderingType>>;
  position?: Maybe<Scalars['Int']>;
};

export type Oauth2Token = {
  __typename?: 'Oauth2Token';
  authType: Scalars['String'];
};

export type OptInToLoyaltyInput = {
  venueSlug: Scalars['String'];
};

export type OptInToLoyaltyPayload = {
  __typename?: 'OptInToLoyaltyPayload';
  /** Was the guest opted-in to loyalty? */
  success: Scalars['Boolean'];
};

export type Order = {
  __typename?: 'Order';
  batchId: Scalars['String'];
  batchPosDisplayIds?: Maybe<Array<Scalars['String']>>;
  batches: Array<OrderBatch>;
  boomerangRedemptionReferenceId?: Maybe<Scalars['String']>;
  clubMembershipNumber?: Maybe<Scalars['String']>;
  commissionRate: Scalars['Float'];
  coverCount?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  deliveryOption?: Maybe<Scalars['String']>;
  /** @deprecated replace by order notes */
  dineInNotes?: Maybe<Scalars['String']>;
  /** @deprecated Moved to surcountsSnapshots, will be removed after migration */
  discounts?: Maybe<Array<OrderDiscount>>;
  disputeStatus?: Maybe<OrderDisputeStatus>;
  doordashDelivery?: Maybe<DoordashDelivery>;
  driveYelloOrderId?: Maybe<Scalars['Float']>;
  expectedReadyAt?: Maybe<Scalars['DateTime']>;
  hasBeenRefunded: Scalars['Boolean'];
  id: Scalars['String'];
  isTaxInclusive: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  lineItems: Array<LineItem>;
  lineItemsCount: Scalars['Float'];
  localCreatedAt: Scalars['LocalDate'];
  location?: Maybe<Location>;
  locationId: Scalars['String'];
  longitude?: Maybe<Scalars['Float']>;
  orderNotes?: Maybe<Scalars['String']>;
  orderingType: OrderingType;
  orderingWindowEndDate?: Maybe<Scalars['LocalDate']>;
  orderingWindowStartDate?: Maybe<Scalars['LocalDate']>;
  paymentConfirmed?: Maybe<Scalars['Boolean']>;
  paymentProcessor?: Maybe<Scalars['String']>;
  paymentTransactionId?: Maybe<Scalars['String']>;
  payoutId?: Maybe<Scalars['String']>;
  pickupOption?: Maybe<Scalars['String']>;
  pointsAcquired: Scalars['Float'];
  pointsUsed: Scalars['Float'];
  posDisplayId?: Maybe<Scalars['String']>;
  posError?: Maybe<Scalars['String']>;
  posOrderId?: Maybe<Scalars['String']>;
  posStatus?: Maybe<OrderPosStatus>;
  refundReason?: Maybe<OrderRefundReason>;
  refundReasonText?: Maybe<Scalars['String']>;
  refundTransactionId?: Maybe<Scalars['String']>;
  roomName?: Maybe<Scalars['String']>;
  roomNumber?: Maybe<Scalars['String']>;
  sharedPaymentId?: Maybe<Scalars['String']>;
  socialTab?: Maybe<SocialTab>;
  socialTabId?: Maybe<Scalars['String']>;
  status: OrderStatus;
  statusColor: OrderStatusColor;
  surcountsSnapshots?: Maybe<Array<OrderSurcountSnapshot>>;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
  totalExternalPaymentsInCents: Scalars['Int'];
  totalGratuityInCents: Scalars['Float'];
  totalInCents: Scalars['Float'];
  totalTaxInCents?: Maybe<Scalars['Float']>;
  user: User;
  userId: Scalars['String'];
  venue: Venue;
  venueId: Scalars['String'];
};

export type OrderBatch = {
  __typename?: 'OrderBatch';
  batchId: Scalars['String'];
  batchingGroupId: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  orderId: Scalars['String'];
  orderingType: OrderingType;
  orderingWindowStartDate: Scalars['DateTime'];
  posDisplayId?: Maybe<Scalars['String']>;
  posError?: Maybe<Scalars['String']>;
  posOrder: PosOrder;
  posOrderId?: Maybe<Scalars['String']>;
  posProcessTime?: Maybe<Scalars['DateTime']>;
  posStatus: OrderPosStatus;
  statusColor: OrderStatusColor;
  venueId: Scalars['String'];
};

export type OrderCreateInputValidation = {
  __typename?: 'OrderCreateInputValidation';
  error?: Maybe<Scalars['String']>;
  valid: Scalars['Boolean'];
};

export type OrderCreateResponse = {
  __typename?: 'OrderCreateResponse';
  customerId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  multiVendorOrder?: Maybe<Scalars['Boolean']>;
  orderId?: Maybe<Scalars['String']>;
  orderPaymentCapture?: Maybe<PaymentTransactionCapture>;
  orderPaymentChallenge?: Maybe<PaymentTransactionChallenge>;
  orderPaymentRedirect?: Maybe<PaymentTransactionRedirect>;
  /** @deprecated Shared Payment is deprecated. */
  sharedPaymentId?: Maybe<Scalars['ID']>;
  socialTabId?: Maybe<Scalars['String']>;
  validation?: Maybe<OrderCreateInputValidation>;
};

export type OrderDiscount = {
  __typename?: 'OrderDiscount';
  amount: Scalars['Float'];
  code: Scalars['String'];
  description: Scalars['String'];
  isAutoGenerated: Scalars['Boolean'];
  name: Scalars['String'];
  pointsUsed: Scalars['Float'];
  posDiscountId: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['Float'];
};

export enum OrderDisputeStatus {
  ChargeRefunded = 'CHARGE_REFUNDED',
  Lost = 'LOST',
  NeedsResponse = 'NEEDS_RESPONSE',
  UnderReview = 'UNDER_REVIEW',
  WarningClosed = 'WARNING_CLOSED',
  WarningNeedsResponse = 'WARNING_NEEDS_RESPONSE',
  WarningUnderReview = 'WARNING_UNDER_REVIEW',
  Won = 'WON'
}

export type OrderForReceipt = {
  __typename?: 'OrderForReceipt';
  items?: Maybe<Array<FlexibleItem>>;
  taxInCents: Scalars['Float'];
  totalInCents: Scalars['Float'];
};

export type OrderHistory = {
  __typename?: 'OrderHistory';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  info?: Maybe<Scalars['String']>;
  localCreatedAt: Scalars['DateTime'];
  receiptId?: Maybe<Scalars['String']>;
  totalInCents: Scalars['Float'];
  type: OrderHistoryType;
};

export enum OrderHistoryType {
  ClosedTabManager = 'CLOSED_TAB_MANAGER',
  MultiVendor = 'MULTI_VENDOR',
  OpenTabManager = 'OPEN_TAB_MANAGER',
  Order = 'ORDER',
  SharedPayment = 'SHARED_PAYMENT',
  TabMember = 'TAB_MEMBER'
}

export enum OrderPosStatus {
  PosAcceptedOrder = 'POS_ACCEPTED_ORDER',
  PosCancelledDueToTimeout = 'POS_CANCELLED_DUE_TO_TIMEOUT',
  PosFailedToCancel = 'POS_FAILED_TO_CANCEL',
  PosRejectedOrder = 'POS_REJECTED_ORDER',
  PosSentFailed = 'POS_SENT_FAILED',
  PosSentPending = 'POS_SENT_PENDING',
  PosStatusUnknown = 'POS_STATUS_UNKNOWN',
  PosUnacknowledgedOrder = 'POS_UNACKNOWLEDGED_ORDER'
}

export enum OrderRefundReason {
  CustomerError = 'CUSTOMER_ERROR',
  CustomerServiceIssue = 'CUSTOMER_SERVICE_ISSUE',
  ItemOutOfStock = 'ITEM_OUT_OF_STOCK',
  MealOrDrinkQuality = 'MEAL_OR_DRINK_QUALITY',
  Other = 'OTHER',
  StaffError = 'STAFF_ERROR',
  TechnicalIssue = 'TECHNICAL_ISSUE',
  WaitTime = 'WAIT_TIME'
}

export enum OrderStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  DrinksReadyForPickup = 'DRINKS_READY_FOR_PICKUP',
  FoodReadyForPickup = 'FOOD_READY_FOR_PICKUP',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Refunded = 'REFUNDED',
  Rejected = 'REJECTED'
}

export enum OrderStatusColor {
  Accent = 'accent',
  Negative = 'negative',
  Neutral = 'neutral',
  Positive = 'positive',
  Warning = 'warning'
}

export type OrderSurcountSnapshot = {
  __typename?: 'OrderSurcountSnapshot';
  amountInCents: Scalars['Float'];
  chargeType: ChargeType;
  code?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['String'];
  isAutoGenerated: Scalars['Boolean'];
  name: Scalars['String'];
  pointsUsed: Scalars['Float'];
  posDiscountId?: Maybe<Scalars['String']>;
  surcountPercentage?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
};

/** OrderingType eg: dine-in */
export enum OrderingType {
  BillPay = 'BILL_PAY',
  Catering = 'CATERING',
  Counter = 'COUNTER',
  Delivery = 'DELIVERY',
  DineIn = 'DINE_IN',
  InVenue = 'IN_VENUE',
  Menu = 'MENU',
  PickUp = 'PICK_UP'
}

export type OrderingTypeSetting = {
  __typename?: 'OrderingTypeSetting';
  coverCountFieldRequirement: VenueFieldRequirement;
  deliveryFee: Scalars['Float'];
  emailFieldRequirement: VenueFieldRequirement;
  enabled?: Maybe<Scalars['Boolean']>;
  hasNotes: Scalars['Boolean'];
  hasTableNumber?: Maybe<VenueFieldRequirement>;
  id: Scalars['ID'];
  isAvailable: Scalars['Boolean'];
  landingText?: Maybe<Scalars['String']>;
  maxTableNumber?: Maybe<Scalars['Int']>;
  minOrderValue: Scalars['Float'];
  minOrderValueToWaiveFee: Scalars['Float'];
  minTableNumber?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notesFieldRequirement: VenueFieldRequirement;
  notesText: Scalars['String'];
  options?: Maybe<Array<Scalars['String']>>;
  optionsText: Scalars['String'];
  orderingType: OrderingType;
  orderingWindow?: Maybe<OrderingWindowSettings>;
  postcodes?: Maybe<Array<Scalars['String']>>;
  tableAreaText: Scalars['String'];
  tableAreas?: Maybe<Array<Scalars['String']>>;
  tableNumberValidation?: Maybe<TableNumberValidation>;
  tablePromptText: Scalars['String'];
  tableShortText: Scalars['String'];
  tableText: Scalars['String'];
  usingTableGroups: Scalars['Boolean'];
};

export type OrderingWindow = {
  __typename?: 'OrderingWindow';
  /** How many minutes before window start time do windows become unavailable. Can be negative (-15 = 15 minutes after start time) */
  buffer: Scalars['Float'];
  /** Day to stop accepting orders on */
  cutOffDaysBefore?: Maybe<Scalars['Float']>;
  /** Time to stop accepting orders */
  cutOffTime?: Maybe<Scalars['String']>;
  dayOfTheWeek: Scalars['String'];
  endTime: Scalars['String'];
  maxOrders: Scalars['Float'];
  startTime: Scalars['String'];
  unlimitedOrders: Scalars['Boolean'];
  id: Scalars['String'];
  orderingWindowSettingsId: Scalars['String'];
};

export type OrderingWindowSettings = {
  __typename?: 'OrderingWindowSettings';
  asapWindowEnabled: Scalars['Boolean'];
  availableOrderingWindows: Array<AvailableSlot>;
  enabled: Scalars['Boolean'];
  futureDays: Scalars['Float'];
  id: Scalars['String'];
  windows: Array<OrderingWindow>;
  /** @deprecated Set buffer on the ordering window instead */
  buffer: Scalars['Float'];
  orderingType: OrderingType;
  venueId: Scalars['String'];
};

export type Organization = {
  __typename?: 'Organization';
  contactEmail?: Maybe<Scalars['String']>;
  contactMobile?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  hubspotCompanyId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isVoucherifyEnabled: Scalars['Boolean'];
  loyaltyMetadata?: Maybe<LoyaltyMetadata>;
  /** @deprecated Moved to Oauth2Token */
  myGuestListAuthenticationToken?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  oauth2Tokens?: Maybe<Array<Oauth2Token>>;
  organizationReport?: Maybe<OrganizationReport>;
  userLoyalties: UserLoyalty;
  venues?: Maybe<Array<Venue>>;
  voucherifyApplicationId?: Maybe<Scalars['String']>;
  voucherifyLoyaltyId?: Maybe<Scalars['String']>;
  voucherifySecretKey?: Maybe<Scalars['String']>;
  yumpingoApiKey?: Maybe<Scalars['String']>;
};

export type OrganizationReport = {
  __typename?: 'OrganizationReport';
  dataProcessors?: Maybe<Array<DataProcessorType>>;
  ftpStorage?: Maybe<Array<FtpStorage>>;
  id: Scalars['String'];
  isLive: Scalars['Boolean'];
  lineItemReportFields?: Maybe<Array<LineItemReportDataFieldType>>;
  venueReportFields?: Maybe<Array<VenueReportDataFieldType>>;
};

/** POSIntegrationType pos integration type */
export enum PosIntegrationType {
  Abacus = 'ABACUS',
  Access = 'ACCESS',
  Bepoz = 'BEPOZ',
  BillPayDemo = 'BILL_PAY_DEMO',
  Chowly = 'CHOWLY',
  Comtrex = 'COMTREX',
  Deliverect = 'DELIVERECT',
  Devpos = 'DEVPOS',
  DirectPrinting = 'DIRECT_PRINTING',
  Doshii = 'DOSHII',
  Eposnow = 'EPOSNOW',
  Gaap = 'GAAP',
  Givex = 'GIVEX',
  Hldirect = 'HLDIRECT',
  Hldirectv2 = 'HLDIRECTV2',
  Hubster = 'HUBSTER',
  Idealpos = 'IDEALPOS',
  Ikentoo = 'IKENTOO',
  Kounta = 'KOUNTA',
  Lightspeedk = 'LIGHTSPEEDK',
  Lotus = 'LOTUS',
  MaitreD = 'MAITRE_D',
  MpowerMsl = 'MPOWER_MSL',
  Pilot = 'PILOT',
  PosConnector = 'POS_CONNECTOR',
  PosConnectorAlphaPartner = 'POS_CONNECTOR_ALPHA_PARTNER',
  PosConnectorHiopos = 'POS_CONNECTOR_HIOPOS',
  PosConnectorTyro = 'POS_CONNECTOR_TYRO',
  Redcat = 'REDCAT',
  Revel = 'REVEL',
  Saidealpos = 'SAIDEALPOS',
  Shiji = 'SHIJI',
  Square = 'SQUARE',
  Starrpos = 'STARRPOS',
  SwiftPos = 'SWIFT_POS',
  SwiftPosV2 = 'SWIFT_POS_V2',
  Tablet = 'TABLET',
  Tevalis = 'TEVALIS',
  Toast = 'TOAST',
  Triniteq = 'TRINITEQ',
  Tyro = 'TYRO',
  Upserve = 'UPSERVE',
  Voucherify = 'VOUCHERIFY',
  Wizbang = 'WIZBANG',
  Wizbangv2 = 'WIZBANGV2',
  Zonal = 'ZONAL'
}

export type PosLineItem = {
  __typename?: 'POSLineItem';
  category: MenuItemCategory;
  children?: Maybe<Array<PosLineItem>>;
  description?: Maybe<Scalars['String']>;
  externalPosGroupId?: Maybe<Scalars['String']>;
  externalPosId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  kind: LineItemKind;
  menuItemId?: Maybe<Scalars['String']>;
  menuItemModifierId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Discounts won't be modifying the price */
  originalPriceInCents: Scalars['Float'];
  parentId?: Maybe<Scalars['String']>;
  paymentTransactionId?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Float'];
  quantity: Scalars['Float'];
  shortName?: Maybe<Scalars['String']>;
  taxAmountInCents?: Maybe<Scalars['Int']>;
  taxRate: Scalars['Float'];
  type: LineItemType;
};

export type PosOrder = {
  __typename?: 'POSOrder';
  /** @deprecated Moved to surcounts */
  discounts?: Maybe<Array<OrderDiscount>>;
  lineItems?: Maybe<Array<PosLineItem>>;
  surcounts?: Maybe<Array<OrderSurcountSnapshot>>;
  totalInCents: Scalars['Float'];
  totalTaxInCents: Scalars['Float'];
};

export type PaginatedSocialTabOrderResponse = {
  __typename?: 'PaginatedSocialTabOrderResponse';
  items: Array<SocialTabOrder>;
  limit: Scalars['Float'];
  skip: Scalars['Float'];
  total: Scalars['Float'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brand: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  expiryMonth: Scalars['Float'];
  expiryYear: Scalars['Float'];
  id: Scalars['String'];
  last4: Scalars['String'];
};

export type PaymentProcessor = {
  __typename?: 'PaymentProcessor';
  /** Commission rate */
  commissionRate: Scalars['Float'];
  currentConnectedAccountId?: Maybe<Scalars['String']>;
  eonxPartnersApiKey?: Maybe<Scalars['String']>;
  /** Id of the record. */
  id: Scalars['String'];
  payoutSchedule: PayoutSchedule;
  payoutStartTime?: Maybe<Scalars['String']>;
  payoutType: PayoutType;
  skipCharge: Scalars['Boolean'];
  types: Array<PaymentProcessorType>;
  /** Label used for optional unpaid processorType */
  unpaidProcessorTypeLabel?: Maybe<Scalars['String']>;
};

export enum PaymentProcessorType {
  Afterpay = 'AFTERPAY',
  Braintree = 'BRAINTREE',
  Cash = 'CASH',
  ChargeToRoom = 'CHARGE_TO_ROOM',
  Eonx = 'EONX',
  Loke = 'LOKE',
  Paystack = 'PAYSTACK',
  Peach = 'PEACH',
  SharedPayment = 'SHARED_PAYMENT',
  Snapscan = 'SNAPSCAN',
  Stripe = 'STRIPE',
  Unpaid = 'UNPAID',
  UnspecifiedPosPayment = 'UNSPECIFIED_POS_PAYMENT',
  Wallet = 'WALLET'
}

export type PaymentResponse = {
  __typename?: 'PaymentResponse';
  amount: Scalars['Float'];
  id: Scalars['String'];
  paymentStatus: Scalars['String'];
  paymentTarget: Scalars['String'];
  paymentTargetId: Scalars['String'];
  processor: Scalars['String'];
  processorTransactionId?: Maybe<Scalars['String']>;
};

export type PaymentTransactionCapture = {
  __typename?: 'PaymentTransactionCapture';
  intentApiKey?: Maybe<Scalars['String']>;
  intentId?: Maybe<Scalars['String']>;
};

export type PaymentTransactionChallenge = {
  __typename?: 'PaymentTransactionChallenge';
  returnUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PaymentTransactionRedirect = {
  __typename?: 'PaymentTransactionRedirect';
  actionToken?: Maybe<Scalars['String']>;
  redirectCheckoutUrl?: Maybe<Scalars['String']>;
};

export enum PayoutSchedule {
  Fast = 'FAST',
  NextDay = 'NEXT_DAY',
  Normal = 'NORMAL'
}

export enum PayoutType {
  Airwallex = 'AIRWALLEX',
  Hyperwallet = 'HYPERWALLET',
  Manual = 'MANUAL',
  Stripe = 'STRIPE'
}

export type PaystackCard = {
  __typename?: 'PaystackCard';
  brand: Scalars['String'];
  expiry: Scalars['String'];
  last4: Scalars['String'];
  paymentMethodId: Scalars['String'];
};

export type PosIntegration = {
  __typename?: 'PosIntegration';
  /** Id of the record. */
  id?: Maybe<Scalars['String']>;
  isLive: Scalars['Boolean'];
  isSyncEnabled: Scalars['Boolean'];
  loyaltyVenueId: Scalars['String'];
  posCancelTimeout?: Maybe<Scalars['Float']>;
  posLastSyncDate?: Maybe<Scalars['DateTime']>;
  posTimeout: Scalars['Float'];
  printOnDirectPrinter: Scalars['Boolean'];
  sendOrderToPosWhenConfirmed: Scalars['Boolean'];
  sendUnmaskedMobileToPos: Scalars['Boolean'];
  type: PosIntegrationType;
};

export type PosReferrer = {
  __typename?: 'PosReferrer';
  id: Scalars['String'];
  referrerName: Scalars['String'];
};

export type PriceData = {
  __typename?: 'PriceData';
  displayPrice?: Maybe<Scalars['String']>;
  hasPriceOverride: Scalars['Boolean'];
  originalDisplayPrice?: Maybe<Scalars['String']>;
  originalPriceInCents?: Maybe<Scalars['Float']>;
  priceInCents?: Maybe<Scalars['Float']>;
};

export type PriceLevel = {
  __typename?: 'PriceLevel';
  level: Scalars['String'];
  priceInCents: Scalars['Float'];
};

export type Printer = {
  __typename?: 'Printer';
  MAC?: Maybe<Scalars['String']>;
  cloudPrintEndpoint: Scalars['String'];
  groups?: Maybe<Array<PrinterGroup>>;
  id: Scalars['String'];
  isPreviouslyOnline: Scalars['Boolean'];
  name: Scalars['String'];
  offline: Scalars['Boolean'];
  printerHealth?: Maybe<PrinterHealth>;
  statusCode?: Maybe<Scalars['String']>;
};

export type PrinterGroup = {
  __typename?: 'PrinterGroup';
  id: Scalars['String'];
  name: Scalars['String'];
  position: Scalars['Float'];
  printers?: Maybe<Array<Printer>>;
};

export type PrinterHealth = {
  __typename?: 'PrinterHealth';
  BlackMarkError: Scalars['Boolean'];
  CompulsionSwitch: Scalars['Boolean'];
  CoverOpen: Scalars['Boolean'];
  CutterError: Scalars['Boolean'];
  MechanicalError: Scalars['Boolean'];
  Online: Scalars['Boolean'];
  OverTemperature: Scalars['Boolean'];
  PaperEmpty: Scalars['Boolean'];
  PaperLow: Scalars['Boolean'];
  PresenterPaperJam: Scalars['Boolean'];
  ReceiveBufferOverflow: Scalars['Boolean'];
  Recoverable: Scalars['Boolean'];
  VoltageError: Scalars['Boolean'];
};

export type Promotion = {
  __typename?: 'Promotion';
  chance: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  name: Scalars['String'];
  redemptionLimit?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};

export type Query = {
  __typename?: 'Query';
  guestMenuCategories: Array<GuestMenuCategory>;
  guestMenuCategory: GuestMenuCategory;
  guestMenuItem: GuestMenuItem;
  guestVenue?: Maybe<GuestVenue>;
  mvoItemSearch: Array<MvoSearchResult>;
  mvoVendorSearch: Array<GuestMenuCategory>;
  startWithDrinks: Array<GuestMenuItem>;
  computePointsToUse?: Maybe<ComputePointsToUsePayload>;
  cuisines: Array<Cuisine>;
  directoryVenueCollections: Array<VenueCollection>;
  eonxCustomerCard: EonxPaymentMethod;
  existingMarketingOptIn?: Maybe<MarketingOptIn>;
  fetchAuraMembership: AuraMembershipPayload;
  fetchAuraOAuthConfig: RewardAuraOAuthPayload;
  getAfterpayConfiguration: AfterpayConfiguration;
  /** @deprecated Replaced by getCartV2 and/or createCart, updateCart mutations */
  getCart?: Maybe<Cart>;
  getCartV2?: Maybe<Cart>;
  getGuestMembership?: Maybe<GetGuestMembershipPayload>;
  getMSLAuthSettings?: Maybe<MslAuthSettings>;
  getWinningItems?: Maybe<Array<WinningPromotions>>;
  isSnapscanPaymentSuccessful: SnapscanSuccessfulPaymentReponse;
  lastOrderByUserByVenueSlug?: Maybe<Order>;
  loyaltyDetails?: Maybe<LoyaltyDetailsPayload>;
  menuItem: MenuItem;
  menuItems: Array<MenuItem>;
  modifierGroups: Array<MenuItemModifierGroup>;
  multiVendorInvoice: MultiVendorInvoicePayload;
  paystackCard?: Maybe<PaystackCard>;
  sharedPayment: SharedPayment;
  sharedPaymentInvoice: SharedPaymentInvoicePayload;
  snapscanPaymentQrUrl: SnapscanPaymentQrUrlReponse;
  stripeCard?: Maybe<StripeCard>;
  swiftPosMemberLoggedInCheckV2: Scalars['Boolean'];
  swiftposMemberPriceLevel?: Maybe<Scalars['String']>;
  tableRule: TableRule;
  /** @deprecated Replaced by guestVenue */
  venue?: Maybe<Venue>;
  venueCollectionBySlug: VenueCollection;
  venueCollectionRegion: Scalars['String'];
  getSession: GuestSession;
  currentUser?: Maybe<User>;
  findPaymentByTargetId?: Maybe<PaymentResponse>;
  flexibleGuestOrders?: Maybe<FlexibleGuestOrderPayload>;
  flexibleOrderReceiptForGuest?: Maybe<FlexibleOrderReceiptForGuestPayload>;
  flexibleOrderReceiptForTable?: Maybe<FlexibleOrderReceiptForTablePayload>;
  getOrderHistoryV3: Array<OrderHistory>;
  getPayment?: Maybe<PaymentResponse>;
  getPayments?: Maybe<Array<PaymentResponse>>;
  getReview?: Maybe<Review>;
  getTab: RunningSocialTab;
  getTabGuestConfirmation: RunningSocialTabGuestConfirmation;
  getTabMeta: SocialTabMeta;
  getTabOrders: PaginatedSocialTabOrderResponse;
  guestOrderById?: Maybe<Order>;
  guestOrderByPaymentTxnId?: Maybe<Order>;
  invoice: Order;
  listPaymentMethods?: Maybe<Array<PaymentMethod>>;
  listPaymentProcessors?: Maybe<Array<SupportedPaymentProcessor>>;
  tabInvoice: Array<Order>;
  verifyCharge?: Maybe<VerifyCharge>;
  verifyPaymentMethod?: Maybe<VerifyPaymentMethod>;
};


export type QueryGuestMenuCategoriesArgs = {
  orderingType: OrderingType;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
  venueSlug: Scalars['String'];
};


export type QueryGuestMenuCategoryArgs = {
  categorySlug: Scalars['String'];
  orderingType: OrderingType;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  priceLevel?: Maybe<Scalars['String']>;
  venueSlug: Scalars['String'];
};


export type QueryGuestMenuItemArgs = {
  itemSlug: Scalars['String'];
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  priceLevel?: Maybe<Scalars['String']>;
  venueSlug: Scalars['String'];
};


export type QueryGuestVenueArgs = {
  slug: Scalars['String'];
};


export type QueryMvoItemSearchArgs = {
  orderingType: OrderingType;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  searchQuery: Scalars['String'];
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
  venueSlug: Scalars['String'];
};


export type QueryMvoVendorSearchArgs = {
  orderingType: OrderingType;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  searchQuery: Scalars['String'];
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
  venueSlug: Scalars['String'];
};


export type QueryStartWithDrinksArgs = {
  orderingType: OrderingType;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
  venueSlug: Scalars['String'];
};


export type QueryComputePointsToUseArgs = {
  input: ComputePointsToUseInput;
};


export type QueryDirectoryVenueCollectionsArgs = {
  vcPrefix: Scalars['String'];
  vcSlug?: Maybe<Scalars['String']>;
};


export type QueryEonxCustomerCardArgs = {
  venueSlug: Scalars['String'];
};


export type QueryExistingMarketingOptInArgs = {
  mobile: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryFetchAuraMembershipArgs = {
  code: Scalars['String'];
  venueId: Scalars['String'];
};


export type QueryFetchAuraOAuthConfigArgs = {
  venueId: Scalars['String'];
};


export type QueryGetCartArgs = {
  checkMembership?: Maybe<Scalars['Boolean']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  orderingType: OrderingType;
  revalidate?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
};


export type QueryGetCartV2Args = {
  orderingType: OrderingType;
  slug: Scalars['String'];
};


export type QueryGetGuestMembershipArgs = {
  input: GetGuestMembershipInput;
};


export type QueryGetMslAuthSettingsArgs = {
  slug: Scalars['String'];
};


export type QueryGetWinningItemsArgs = {
  orderId: Scalars['String'];
};


export type QueryIsSnapscanPaymentSuccessfulArgs = {
  cartId: Scalars['String'];
};


export type QueryLastOrderByUserByVenueSlugArgs = {
  venueSlug: Scalars['String'];
};


export type QueryLoyaltyDetailsArgs = {
  input: LoyaltyDetailsInput;
};


export type QueryMenuItemArgs = {
  id: Scalars['String'];
};


export type QueryMenuItemsArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryModifierGroupsArgs = {
  venueId: Scalars['String'];
};


export type QueryMultiVendorInvoiceArgs = {
  orderId: Scalars['String'];
};


export type QueryPaystackCardArgs = {
  currency: Scalars['String'];
  customerId: Scalars['String'];
};


export type QuerySharedPaymentArgs = {
  id: Scalars['ID'];
};


export type QuerySharedPaymentInvoiceArgs = {
  sharedPaymentLineItemId: Scalars['String'];
};


export type QuerySnapscanPaymentQrUrlArgs = {
  input: SnapscanPaymentQrUrlInput;
};


export type QueryStripeCardArgs = {
  currency: Scalars['String'];
  customerId: Scalars['String'];
};


export type QuerySwiftPosMemberLoggedInCheckV2Args = {
  venueSlug: Scalars['String'];
};


export type QuerySwiftposMemberPriceLevelArgs = {
  venueSlug: Scalars['String'];
};


export type QueryTableRuleArgs = {
  area?: Maybe<Scalars['String']>;
  number: Scalars['String'];
};


export type QueryVenueArgs = {
  slug: Scalars['String'];
};


export type QueryVenueCollectionBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryFindPaymentByTargetIdArgs = {
  paymentTargetId: Scalars['String'];
};


export type QueryFlexibleGuestOrdersArgs = {
  guestId: Scalars['String'];
};


export type QueryFlexibleOrderReceiptForGuestArgs = {
  tableNumber: Scalars['String'];
};


export type QueryFlexibleOrderReceiptForTableArgs = {
  tableArea?: Maybe<Scalars['String']>;
  tableNumber: Scalars['String'];
};


export type QueryGetOrderHistoryV3Args = {
  slug: Scalars['String'];
};


export type QueryGetPaymentArgs = {
  paymentId: Scalars['String'];
};


export type QueryGetPaymentsArgs = {
  paymentTargetId: Scalars['String'];
};


export type QueryGetReviewArgs = {
  orderId: Scalars['String'];
};


export type QueryGetTabArgs = {
  tabId: Scalars['String'];
};


export type QueryGetTabGuestConfirmationArgs = {
  tabId: Scalars['String'];
};


export type QueryGetTabMetaArgs = {
  tabId: Scalars['String'];
};


export type QueryGetTabOrdersArgs = {
  limit: Scalars['Float'];
  skip: Scalars['Float'];
  tabId: Scalars['String'];
};


export type QueryGuestOrderByIdArgs = {
  orderId: Scalars['String'];
};


export type QueryGuestOrderByPaymentTxnIdArgs = {
  paymentTransactionId: Scalars['String'];
};


export type QueryInvoiceArgs = {
  orderId: Scalars['String'];
};


export type QueryListPaymentMethodsArgs = {
  currency: Scalars['String'];
};


export type QueryListPaymentProcessorsArgs = {
  orderingType: Scalars['String'];
  venueSlug: Scalars['String'];
};


export type QueryTabInvoiceArgs = {
  tabId: Scalars['String'];
};


export type QueryVerifyChargeArgs = {
  currency: Scalars['String'];
  verificationId: Scalars['String'];
};


export type QueryVerifyPaymentMethodArgs = {
  currency: Scalars['String'];
  verificationId: Scalars['String'];
};

export type RefreshSessionInput = {
  orderingType?: Maybe<OrderingType>;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['String']>;
};

export type RefreshSessionPayload = {
  __typename?: 'RefreshSessionPayload';
  createdAt: Scalars['DateTime'];
};

export type RegistryGuest = {
  __typename?: 'RegistryGuest';
  addressOrEmail?: Maybe<Scalars['String']>;
  ageRequirement?: Maybe<Scalars['Boolean']>;
  correctDeclaration?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idNumber?: Maybe<Scalars['String']>;
  localCreatedAt: Scalars['LocalDate'];
  marketingOptInEnabled: Scalars['Boolean'];
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  symptomsConfirmation?: Maybe<Scalars['Boolean']>;
  tableNumber?: Maybe<Scalars['String']>;
  temperature?: Maybe<Scalars['String']>;
};

export type Review = {
  __typename?: 'Review';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  rating: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
};

export type RewardAuraOAuthPayload = {
  __typename?: 'RewardAuraOAuthPayload';
  programName: Scalars['String'];
  url: Scalars['String'];
};

export type RunningSocialTab = {
  __typename?: 'RunningSocialTab';
  id?: Maybe<Scalars['String']>;
  maxSpendInCents?: Maybe<Scalars['Float']>;
  members?: Maybe<Array<RunningSocialTabMember>>;
  orderingType?: Maybe<OrderingType>;
  startTime?: Maybe<Scalars['LocalDate']>;
  status?: Maybe<SocialTabStatus>;
  tabName?: Maybe<Scalars['String']>;
  tabSpendInCents?: Maybe<Scalars['Float']>;
  validation?: Maybe<Array<SocialTabValidationError>>;
  venue?: Maybe<Venue>;
};

export type RunningSocialTabGuestConfirmation = {
  __typename?: 'RunningSocialTabGuestConfirmation';
  id?: Maybe<Scalars['String']>;
  orderingType?: Maybe<OrderingType>;
  tabName?: Maybe<Scalars['String']>;
  validation?: Maybe<Array<SocialTabValidationError>>;
  venue?: Maybe<Venue>;
};

export type RunningSocialTabMember = {
  __typename?: 'RunningSocialTabMember';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  orders?: Maybe<Array<Order>>;
};

export type SalesAgent = {
  __typename?: 'SalesAgent';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SendOneTimePasswordSmsInput = {
  /** Mobile phone number in international format */
  mobile: Scalars['String'];
  /** Cloudflare Turnstile Token */
  turnstileToken?: Maybe<Scalars['String']>;
};

export type SendOneTimePasswordSmsPayload = {
  __typename?: 'SendOneTimePasswordSMSPayload';
  mobile: Scalars['String'];
  result: SendOneTimePasswordSmsResult;
  retryAfter: Scalars['DateTime'];
};

export enum SendOneTimePasswordSmsResult {
  ErrorForbidden = 'ERROR_FORBIDDEN',
  ErrorRateLimited = 'ERROR_RATE_LIMITED',
  Succeeded = 'SUCCEEDED'
}

export type SharedPayment = {
  __typename?: 'SharedPayment';
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  guestCart?: Maybe<Cart>;
  id: Scalars['ID'];
  orderDetails?: Maybe<SharedPaymentOrderDetails>;
  remainingTotalInCents: Scalars['Int'];
  sharedLineItems: Array<SharedPaymentLineItem>;
  updatedAt: Scalars['DateTime'];
};

export type SharedPaymentGuest = {
  __typename?: 'SharedPaymentGuest';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type SharedPaymentInvoicePayload = {
  __typename?: 'SharedPaymentInvoicePayload';
  gratuityInCents: Scalars['Int'];
  id: Scalars['ID'];
  order: Order;
  paymentProcessor: PaymentProcessorType;
  totalInCents: Scalars['Int'];
  totalReversalInCents: Scalars['Int'];
  totalTaxInCents: Scalars['Int'];
  user: User;
};

export type SharedPaymentLineItem = {
  __typename?: 'SharedPaymentLineItem';
  createdAt: Scalars['DateTime'];
  gratuityInCents: Scalars['Int'];
  id: Scalars['ID'];
  kind: Scalars['String'];
  payer?: Maybe<SharedPaymentGuest>;
  paymentProcessor: PaymentProcessorType;
  posStatus?: Maybe<SharedPaymentLineItemPosStatus>;
  source: SharedPaymentLineItemSource;
  subTotalInCents: Scalars['Int'];
  totalInCents: Scalars['Int'];
  totalTaxInCents: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  venueId?: Maybe<Scalars['ID']>;
};

export enum SharedPaymentLineItemPosStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum SharedPaymentLineItemSource {
  Mryum = 'MRYUM',
  Pos = 'POS'
}

export type SharedPaymentOrderDetails = {
  __typename?: 'SharedPaymentOrderDetails';
  id: Scalars['ID'];
  userId?: Maybe<Scalars['String']>;
};

export type SnapscanPaymentQrUrlInput = {
  cardToken?: Maybe<Scalars['String']>;
  paymentProcessorType?: Scalars['String'];
  socialTabId?: Maybe<Scalars['String']>;
  type?: Maybe<OrderingType>;
  venueSlug?: Maybe<Scalars['String']>;
};

export type SnapscanPaymentQrUrlReponse = {
  __typename?: 'SnapscanPaymentQrUrlReponse';
  cartId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  validation?: Maybe<OrderCreateInputValidation>;
};

export type SnapscanSuccessfulPaymentReponse = {
  __typename?: 'SnapscanSuccessfulPaymentReponse';
  cart?: Maybe<Cart>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderingType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SocialTab = {
  __typename?: 'SocialTab';
  closeTime?: Maybe<Scalars['DateTime']>;
  finalSpendInCents: Scalars['Float'];
  id: Scalars['String'];
  isPaid: Scalars['Boolean'];
  managers: Array<User>;
  maxSpendInCents: Scalars['Float'];
  members: Array<User>;
  orderingType?: Maybe<OrderingType>;
  orders: Array<Order>;
  spendInCents: Scalars['Float'];
  startTime: Scalars['DateTime'];
  status: SocialTabStatus;
  tabName: Scalars['String'];
};

export type SocialTabMeta = {
  __typename?: 'SocialTabMeta';
  id: Scalars['String'];
  managers?: Maybe<Array<User>>;
  tabName: Scalars['String'];
  venue?: Maybe<Venue>;
};

export type SocialTabOrder = {
  __typename?: 'SocialTabOrder';
  date: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  totalInCents: Scalars['Float'];
};

export enum SocialTabStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export enum SocialTabValidationError {
  CannotJoinTabTwice = 'CANNOT_JOIN_TAB_TWICE',
  TabClosed = 'TAB_CLOSED',
  TabMaxSpendReached = 'TAB_MAX_SPEND_REACHED',
  TabOnlyAccessibleByManager = 'TAB_ONLY_ACCESSIBLE_BY_MANAGER'
}

export type SourceUrl = {
  __typename?: 'SourceUrl';
  /** height of the image */
  height: Scalars['Float'];
  /** CDN path */
  url: Scalars['String'];
  /** width of the image */
  width: Scalars['Float'];
};

export type StartTabInput = {
  cardToken?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  idempotencyKey?: Maybe<Scalars['String']>;
  newPaymentMethod?: Maybe<Scalars['Boolean']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentProcessorType?: PaymentProcessorType;
  savePaymentDetails?: Maybe<Scalars['Boolean']>;
  socialTabId?: Maybe<Scalars['String']>;
  startNewSocialTab?: Maybe<Scalars['Boolean']>;
  venueSlug?: Maybe<Scalars['String']>;
  walletPaymentProcessor?: Maybe<PaymentProcessorType>;
};

export type StartTabResponse = {
  __typename?: 'StartTabResponse';
  customerId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderPaymentChallenge?: Maybe<PaymentTransactionChallenge>;
  orderPaymentRedirect?: Maybe<PaymentTransactionRedirect>;
  socialTabId?: Maybe<Scalars['String']>;
  validation?: Maybe<OrderCreateInputValidation>;
};

export type StripeCard = {
  __typename?: 'StripeCard';
  brand: Scalars['String'];
  expiry: Scalars['String'];
  last4: Scalars['String'];
  paymentMethodId: Scalars['String'];
};

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  customerId?: Maybe<Scalars['String']>;
  paymentIntentId: Scalars['String'];
};

export type SupportedPaymentProcessor = {
  __typename?: 'SupportedPaymentProcessor';
  name: Scalars['String'];
};

export type TableGroup = {
  __typename?: 'TableGroup';
  externalPosId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  numbers: Array<Scalars['String']>;
  tableGroupToMenuCategory: TableGroupToMenuCategory;
  venue: Venue;
};

export type TableGroupToMenuCategory = {
  __typename?: 'TableGroupToMenuCategory';
  id: Scalars['String'];
  menuCategory: MenuCategory;
  tableGroup: TableGroup;
};

export enum TableNumberValidation {
  Any = 'ANY',
  Number = 'NUMBER',
  TableGroup = 'TABLE_GROUP'
}

export type TableRule = {
  __typename?: 'TableRule';
  area?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  status: Scalars['String'];
};

export type TimeBlocks = {
  __typename?: 'TimeBlocks';
  fri?: Maybe<Array<TimeSlot>>;
  id: Scalars['String'];
  mon?: Maybe<Array<TimeSlot>>;
  name: Scalars['String'];
  sat?: Maybe<Array<TimeSlot>>;
  sun?: Maybe<Array<TimeSlot>>;
  thu?: Maybe<Array<TimeSlot>>;
  tue?: Maybe<Array<TimeSlot>>;
  wed?: Maybe<Array<TimeSlot>>;
  externalPosId: Scalars['String'];
  isEffective: Scalars['Boolean'];
  timeBlocksType: TimeBlocksType;
};

export enum TimeBlocksType {
  Default = 'DEFAULT',
  Discount = 'DISCOUNT',
  HideFromMenuOverride = 'HIDE_FROM_MENU_OVERRIDE',
  PriceOverride = 'PRICE_OVERRIDE'
}

export type TimeFrame = {
  __typename?: 'TimeFrame';
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type TimeSlot = {
  __typename?: 'TimeSlot';
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type UpdateCurrentCustomerInput = {
  customerId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  isOver18?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  savePaymentDetails?: Maybe<Scalars['Boolean']>;
};

export type UpdateMarketingOptInInput = {
  marketingUserOptIn: Scalars['Boolean'];
  venueSlug: Scalars['String'];
};

export type UpdateReviewInput = {
  notes?: Maybe<Scalars['String']>;
  rating: Scalars['Float'];
  reviewId: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  banReason?: Maybe<UserBanReason>;
  customerId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isOver18?: Maybe<Scalars['Boolean']>;
  locations?: Maybe<Array<Location>>;
  managedTabs?: Maybe<Array<SocialTab>>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizations?: Maybe<Array<Organization>>;
  receiptEmail?: Maybe<Scalars['String']>;
  role: UserRole;
  savePaymentDetails?: Maybe<Scalars['Boolean']>;
  tabs?: Maybe<Array<SocialTab>>;
  threeDSecureStatus: User3dsStatus;
};


export type UserManagedTabsArgs = {
  venueSlug?: Maybe<Scalars['String']>;
};


export type UserTabsArgs = {
  venueSlug?: Maybe<Scalars['String']>;
};

/** status when user does 3DS */
export enum User3dsStatus {
  Challenged = 'CHALLENGED',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export type UserActionRequired = {
  __typename?: 'UserActionRequired';
  nextAction: Scalars['String'];
  verificationUrl?: Maybe<Scalars['String']>;
};

/** If set, why this user is banned from ordering */
export enum UserBanReason {
  FraudManual = 'FRAUD_MANUAL',
  FraudOtp = 'FRAUD_OTP'
}

export type UserLoyalty = {
  __typename?: 'UserLoyalty';
  isOptedIn: Scalars['Boolean'];
  loyaltyCard?: Maybe<Scalars['String']>;
  points: Scalars['Float'];
};

/** The role of the user */
export enum UserRole {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  DeliveryStaff = 'DELIVERY_STAFF',
  MenuBuilder = 'MENU_BUILDER',
  Owner = 'OWNER',
  User = 'USER',
  VenueStaff = 'VENUE_STAFF'
}

export enum VctvType {
  Venue = 'Venue',
  VenueCollection = 'VenueCollection'
}

export type ValidateDoordashDeliveryResponse = {
  __typename?: 'ValidateDoordashDeliveryResponse';
  /** Validation error */
  error?: Maybe<Scalars['String']>;
  /** Whether validation was successful */
  success: Scalars['Boolean'];
};

export type ValidateDoordashOrderDeliveryInput = {
  /** Customer email address */
  email?: Maybe<Scalars['String']>;
  /** Customer full name */
  fullName: Scalars['String'];
  locationId?: Maybe<Scalars['String']>;
  orderingType?: Maybe<Scalars['String']>;
  /** Customer unit number */
  unitNumber?: Maybe<Scalars['String']>;
  /** Venue id */
  venueId: Scalars['String'];
};

export type Venue = {
  __typename?: 'Venue';
  /** @deprecated replaced by accountEmails */
  accountEmail?: Maybe<Scalars['String']>;
  accountEmails?: Maybe<Array<Scalars['String']>>;
  accountManager?: Maybe<AccountManager>;
  accountManagerId?: Maybe<Scalars['String']>;
  additionalInvoiceInformation?: Maybe<Scalars['String']>;
  ageRestrictionText?: Maybe<Scalars['String']>;
  airshipVenueId?: Maybe<Scalars['Float']>;
  airwallexBeneficiaryId?: Maybe<Scalars['String']>;
  alwaysChargeDeliveryFee: Scalars['Boolean'];
  alwaysShowVisualMenu: Scalars['Boolean'];
  banner?: Maybe<CdnImage>;
  /** @deprecated Use Flexible Wait Times */
  barBusyUntil?: Maybe<Scalars['DateTime']>;
  batchingGroups?: Maybe<Array<BatchingGroup>>;
  /** Booking link */
  bookingLink?: Maybe<Scalars['String']>;
  brandingAccent?: Maybe<Scalars['String']>;
  brandingAccentText?: Maybe<Scalars['String']>;
  brandingEnabled: Scalars['Boolean'];
  brandingPrimary?: Maybe<Scalars['String']>;
  brandingPrimaryText?: Maybe<Scalars['String']>;
  canSkipGratuity: Scalars['Boolean'];
  cardSurcharge: Scalars['Float'];
  cardSurchargeExternalPosId?: Maybe<Scalars['String']>;
  cardSurchargeName?: Maybe<Scalars['String']>;
  churnReason?: Maybe<ChurnReason>;
  churnStatus?: Maybe<ChurnStatus>;
  clubMembershipsEnabled: Scalars['Boolean'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  cuisines?: Maybe<Array<Cuisine>>;
  currency: Scalars['String'];
  currentDiscount?: Maybe<Discount>;
  customGratuityText?: Maybe<Scalars['String']>;
  defaultBatchingGroupId?: Maybe<Scalars['String']>;
  defaultOrderingType?: Maybe<OrderingType>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deliveryExpectedReadySMS?: Maybe<Scalars['String']>;
  deliveryFee: Scalars['Float'];
  deliveryFeeExternalPosId?: Maybe<Scalars['String']>;
  /** @deprecated transferred to orderingTypeSettings */
  deliveryOptions?: Maybe<Array<Scalars['String']>>;
  deliveryOrderAcceptedSMS?: Maybe<Scalars['String']>;
  deliveryOrderingWindow?: Maybe<OrderingWindowSettings>;
  /** @deprecated moved to order type settings */
  deliveryOrderingWindowId?: Maybe<Scalars['String']>;
  deliveryPostcodes?: Maybe<Array<Scalars['String']>>;
  deliveryWindowSendOrderBeforeMs: Scalars['Float'];
  dineInOrderAcceptedSMS?: Maybe<Scalars['String']>;
  dineInOrderCustomerNotFoundSMS?: Maybe<Scalars['String']>;
  discounts?: Maybe<Array<Discount>>;
  driveYelloStoreReference?: Maybe<Scalars['String']>;
  /** @deprecated replaced by escalationEmails */
  escalationEmail?: Maybe<Scalars['String']>;
  escalationEmails?: Maybe<Array<Scalars['String']>>;
  facebookAccessToken?: Maybe<Scalars['String']>;
  facebookPixelId?: Maybe<Scalars['String']>;
  flexibleGratuityEnabled: Scalars['Boolean'];
  googleTagManagerId?: Maybe<Scalars['String']>;
  gratuityEnabled: Scalars['Boolean'];
  gratuityExternalPosId?: Maybe<Scalars['String']>;
  gratuityOptions?: Maybe<Array<Scalars['Float']>>;
  gratuityRate: Scalars['Float'];
  gstRegistrationNumber?: Maybe<Scalars['String']>;
  guestRegistrationEnabled: Scalars['Boolean'];
  guestRegistrySettings?: Maybe<GuestRegistrySettings>;
  hasDoordashEnabled: Scalars['Boolean'];
  hasOrderingWindow: Scalars['Boolean'];
  hours?: Maybe<TimeBlocks>;
  hubspotCompanyId?: Maybe<Scalars['String']>;
  hyperwalletUser?: Maybe<HyperwalletUser>;
  id: Scalars['String'];
  isAvc: Scalars['Boolean'];
  isClosed: Scalars['Boolean'];
  /** @deprecated transferred to orderingTypeSettings */
  isDeliveryAvailable: Scalars['Boolean'];
  /** @deprecated transferred to orderingTypeSettings */
  isDineInAvailable: Scalars['Boolean'];
  isDynamicUpsellEnabled?: Maybe<Scalars['Boolean']>;
  /** Booking link will open in an iframe by default. */
  isIframe: Scalars['Boolean'];
  isLive: Scalars['Boolean'];
  isOrderingAvailable: Scalars['Boolean'];
  /** @deprecated transferred to orderingTypeSettings */
  isPickUpAvailable: Scalars['Boolean'];
  isPinEnabled: Scalars['Boolean'];
  isTaxInclusive: Scalars['Boolean'];
  /** @deprecated Use Flexible Wait Times */
  kitchenBusyUntil?: Maybe<Scalars['DateTime']>;
  landingCallToActionText?: Maybe<Scalars['String']>;
  landingCallToActionUrl?: Maybe<Scalars['String']>;
  landingWelcomeText?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  logo?: Maybe<CdnImage>;
  loyaltyMetadata?: Maybe<LoyaltyMetadata>;
  marketingOptInDefault: Scalars['Boolean'];
  marketingOptInEnabled: Scalars['Boolean'];
  marketingOptInMessage?: Maybe<Scalars['String']>;
  /** @deprecated transferred to orderingTypeSettings */
  maxTableNumber?: Maybe<Scalars['Float']>;
  /** Venue menu categories available to customer on ordering type */
  menuCategories: Array<MenuCategory>;
  minDeliveryOrderValue: Scalars['Float'];
  minOrderValueForFreeDelivery: Scalars['Float'];
  /** @deprecated transferred to orderingTypeSettings */
  minTableNumber?: Maybe<Scalars['Float']>;
  mobileBanner?: Maybe<CdnImage>;
  modifiers?: Maybe<Array<MenuItemModifier>>;
  multiVendorEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  ogImage?: Maybe<CdnImage>;
  /** @deprecated replaced by orderNotificationMobiles */
  orderNotificationMobile?: Maybe<Scalars['String']>;
  orderNotificationMobiles?: Maybe<Array<Scalars['String']>>;
  /** Support ordering */
  ordering: Scalars['Boolean'];
  /** @deprecated transferred to orderingTypeSettings as enabled field */
  orderingType?: Maybe<Array<OrderingType>>;
  orderingTypeSettings?: Maybe<VenueOrderingTypeSetting>;
  orderingTypeSettingsV2?: Maybe<VenueOrderingTypeSetting>;
  orders?: Maybe<Array<Order>>;
  organization?: Maybe<Organization>;
  paymentProcessor?: Maybe<PaymentProcessor>;
  pickUpOrderAcceptedSMS?: Maybe<Scalars['String']>;
  pickUpOrderReadySMS?: Maybe<Scalars['String']>;
  pickupExpectedReadySMS?: Maybe<Scalars['String']>;
  /** @deprecated transferred to orderingTypeSettings */
  pickupOptions?: Maybe<Array<Scalars['String']>>;
  pickupOrderingWindow?: Maybe<OrderingWindowSettings>;
  /** @deprecated moved to order type settings */
  pickupOrderingWindowId?: Maybe<Scalars['String']>;
  /**
   * Table number field for pickup orders
   * @deprecated transferred to orderingTypeSettings
   */
  pickupTableNumber: VenueFieldRequirement;
  pickupWindowSendOrderBeforeMs: Scalars['Float'];
  pinCode?: Maybe<Scalars['String']>;
  popupNotificationImage?: Maybe<CdnImage>;
  popupNotificationText?: Maybe<Scalars['String']>;
  posIntegration?: Maybe<PosIntegration>;
  posReferrer?: Maybe<PosReferrer>;
  posReferrerId?: Maybe<Scalars['String']>;
  qvcStoreId?: Maybe<Scalars['String']>;
  salesAgent?: Maybe<SalesAgent>;
  salesAgentId?: Maybe<Scalars['String']>;
  seatedTapNo: Scalars['String'];
  seatedTapYes: Scalars['String'];
  sendDoordashOrderingWindowStartAs: Scalars['String'];
  shortDescription?: Maybe<Scalars['String']>;
  showCategoryListViewOnLandingPage: Scalars['Boolean'];
  showOrderingTypePicker: Scalars['Boolean'];
  skipTableNumberModal: Scalars['Boolean'];
  slug: Scalars['String'];
  squareThumb?: Maybe<CdnImage>;
  supportEmail?: Maybe<Scalars['String']>;
  supportPhone?: Maybe<Scalars['String']>;
  surveyLink?: Maybe<Scalars['String']>;
  /** @deprecated transferred to orderingTypeSettings */
  tableAreas?: Maybe<Array<Scalars['String']>>;
  tableGroups?: Maybe<Array<TableGroup>>;
  /** @deprecated transferred to orderingTypeSettings */
  tableNumberValidation: TableNumberValidation;
  /** @deprecated transferred to orderingTypeSettings */
  tableText: Scalars['String'];
  tabsEnabled: Scalars['Boolean'];
  taxRate: Scalars['Float'];
  timeBlocks?: Maybe<Array<TimeBlocks>>;
  timezone?: Maybe<Scalars['String']>;
  /** @deprecated replaced by unavailableListEmails */
  unavailableListEmail?: Maybe<Scalars['String']>;
  unavailableListEmails?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
  venueBoomerang?: Maybe<VenueBoomerang>;
  venueCategory?: Maybe<VenueCategory>;
  venueCategoryId?: Maybe<Scalars['String']>;
  venueOrderingTypeSettings: Array<VenueOrderingTypeSetting>;
  venueToMenuCategory?: Maybe<Array<VenueToMenuCategory>>;
  venueTypes: Array<VenueType>;
  venueWideDiscounts: Array<Discount>;
  yumpingoReviewSMS?: Maybe<Scalars['String']>;
  yumpingoVenueId?: Maybe<Scalars['String']>;
};


export type VenueBannerArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type VenueLogoArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type VenueMenuCategoriesArgs = {
  input?: Maybe<MenuCategoriesInput>;
};


export type VenueMobileBannerArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type VenueOgImageArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type VenueOrderingTypeSettingsArgs = {
  orderingType: Scalars['String'];
};


export type VenueOrderingTypeSettingsV2Args = {
  orderingType: OrderingType;
};


export type VenuePopupNotificationImageArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type VenueSquareThumbArgs = {
  transform?: Maybe<Scalars['String']>;
};


export type VenueVenueWideDiscountsArgs = {
  includeInactive?: Maybe<Scalars['Boolean']>;
};

export type VenueBoomerang = {
  __typename?: 'VenueBoomerang';
  isVoucherifyEnabled: Scalars['Boolean'];
  voucherifyApplicationId?: Maybe<Scalars['String']>;
  voucherifyLoyaltyId?: Maybe<Scalars['String']>;
  voucherifySecretKey?: Maybe<Scalars['String']>;
};

export type VenueCategory = {
  __typename?: 'VenueCategory';
  categoryName: Scalars['String'];
  id: Scalars['String'];
};

export type VenueCollection = {
  __typename?: 'VenueCollection';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  venueCollectionToVenue?: Maybe<Array<VenueCollectionToVenue>>;
};


export type VenueCollectionVenueCollectionToVenueArgs = {
  shuffleVenues?: Maybe<Scalars['Boolean']>;
};

export type VenueCollectionToVenue = {
  __typename?: 'VenueCollectionToVenue';
  childrenCollection?: Maybe<VenueCollection>;
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  orderingType?: Maybe<OrderingType>;
  type: VctvType;
  venue?: Maybe<Venue>;
  vlpImage?: Maybe<CdnImage>;
};


export type VenueCollectionToVenueVlpImageArgs = {
  transform?: Maybe<Scalars['String']>;
};

export enum VenueFieldRequirement {
  Hidden = 'Hidden',
  Optional = 'Optional',
  Required = 'Required'
}

export type VenueOrderingTypeSetting = {
  __typename?: 'VenueOrderingTypeSetting';
  autocompleteEnabled?: Maybe<Scalars['Boolean']>;
  autocompleteOnDoubleReady: Scalars['Boolean'];
  cartTableTimeout: Scalars['Float'];
  /** Cover Count Field setting for customer detail */
  coverCountFieldRequirement: VenueFieldRequirement;
  deliveryRadius: Scalars['Float'];
  drinksReadySMS?: Maybe<Scalars['String']>;
  /** Email Field setting for customer detail */
  emailFieldRequirement: VenueFieldRequirement;
  enableDoubleReadySMS: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  expectedReadySMS?: Maybe<Scalars['String']>;
  fee: Scalars['Float'];
  foodReadySMS?: Maybe<Scalars['String']>;
  hasNotes: Scalars['Boolean'];
  /** Table number field requirement for orders */
  hasTableNumber: VenueFieldRequirement;
  id: Scalars['String'];
  isAvailable: Scalars['Boolean'];
  isAvailableForOrdering: Scalars['Boolean'];
  landingText?: Maybe<Scalars['String']>;
  maxTableNumber?: Maybe<Scalars['Float']>;
  minOrderValue: Scalars['Float'];
  minOrderValueToWaiveFee: Scalars['Float'];
  minTableNumber?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  /** Notes field setting */
  notesFieldRequirement: VenueFieldRequirement;
  notesText: Scalars['String'];
  options?: Maybe<Array<Scalars['String']>>;
  optionsText: Scalars['String'];
  orderAcceptedSMS?: Maybe<Scalars['String']>;
  orderCustomerNotFoundSMS?: Maybe<Scalars['String']>;
  orderReadySMS?: Maybe<Scalars['String']>;
  orderingType: OrderingType;
  orderingWindow?: Maybe<OrderingWindowSettings>;
  orderingWindowId?: Maybe<Scalars['String']>;
  postcodes?: Maybe<Array<Scalars['String']>>;
  tableAreaText: Scalars['String'];
  tableAreas?: Maybe<Array<Scalars['String']>>;
  tableNumberValidation?: Maybe<TableNumberValidation>;
  tablePromptText: Scalars['String'];
  tableShortText: Scalars['String'];
  tableText: Scalars['String'];
  usingTableGroups: Scalars['Boolean'];
  windowSendOrderBeforeMs: Scalars['Float'];
};

/** VenueReportDataFieldType available fields to customize */
export enum VenueReportDataFieldType {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME',
  Slug = 'SLUG',
  Timezone = 'TIMEZONE'
}

export type VenueToMenuCategory = {
  __typename?: 'VenueToMenuCategory';
  categoryWaitTime?: Maybe<WaitTimeDto>;
  id: Scalars['String'];
  menuCategory?: Maybe<MenuCategory>;
  menuCategoryId: Scalars['String'];
  menuWaitTime?: Maybe<MenuWaitTime>;
  mvoChildVenue?: Maybe<Venue>;
  mvoChildVenueId?: Maybe<Scalars['String']>;
  position: Scalars['Float'];
  venue: Venue;
  venueId: Scalars['String'];
};

export enum VenueType {
  Arcade = 'ARCADE',
  Bar = 'BAR',
  BowlingAlley = 'BOWLING_ALLEY',
  Brunch = 'BRUNCH',
  Cafe = 'CAFE',
  CocktailBar = 'COCKTAIL_BAR',
  Coffee = 'COFFEE',
  Drinks = 'DRINKS',
  Food = 'FOOD',
  Function = 'FUNCTION',
  MiniGolf = 'MINI_GOLF',
  Pub = 'PUB',
  Restaurant = 'RESTAURANT',
  Takeaway = 'TAKEAWAY',
  Venue = 'VENUE'
}

export type VerifyCharge = {
  __typename?: 'VerifyCharge';
  verificationId: Scalars['String'];
  verificationResult: Scalars['String'];
};

export type VerifyPaymentMethod = {
  __typename?: 'VerifyPaymentMethod';
  verificationId: Scalars['String'];
  verificationResult: Scalars['String'];
};

export type WaitTimeDto = {
  __typename?: 'WaitTimeDto';
  endTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  waitTimeInMinutes?: Maybe<Scalars['Int']>;
};

export enum WaitTimeEstimateType {
  EstimateInMilliseconds = 'ESTIMATE_IN_MILLISECONDS',
  ExtendedNoEstimate = 'EXTENDED_NO_ESTIMATE'
}

export enum WaitTimeExpiryType {
  ExpireAtEndTime = 'EXPIRE_AT_END_TIME',
  NoExpiry = 'NO_EXPIRY'
}

export type WinningLineItem = {
  __typename?: 'WinningLineItem';
  id: Scalars['String'];
  menuItemId: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
};

export type WinningPromotions = {
  __typename?: 'WinningPromotions';
  lineItems: Array<WinningLineItem>;
  promotion: Promotion;
};

export type AddGuestMembershipInput = {
  organizationId: Scalars['String'];
};

export type AddGuestMembershipPayload = {
  __typename?: 'addGuestMembershipPayload';
  success: Scalars['Boolean'];
};

export type GetGuestMembershipInput = {
  venueSlug: Scalars['String'];
};

export type GetGuestMembershipPayload = {
  __typename?: 'getGuestMembershipPayload';
  email?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  mobile: Scalars['String'];
  tier?: Maybe<Scalars['String']>;
};

export type AddOrUpdateNotesOnCartMutationVariables = Exact<{
  input: CartNotesInput;
}>;


export type AddOrUpdateNotesOnCartMutation = (
  { __typename?: 'Mutation' }
  & { addOrUpdateNotesOnCart: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type AddOrUpdateOptionsOnCartMutationVariables = Exact<{
  input: CartOptionsInput;
}>;


export type AddOrUpdateOptionsOnCartMutation = (
  { __typename?: 'Mutation' }
  & { addOrUpdateOptionsOnCart: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type AddOrUpdateWindowOnCartMutationVariables = Exact<{
  input: CartOrderingWindowInput;
}>;


export type AddOrUpdateWindowOnCartMutation = (
  { __typename?: 'Mutation' }
  & { addOrUpdateWindowOnCart: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'id' | 'orderingWindowStartDate' | 'orderingWindowEndDate'>
  ) }
);

export type AddToCartMutationVariables = Exact<{
  input: CartItemInput;
}>;


export type AddToCartMutation = (
  { __typename?: 'Mutation' }
  & { addToCart: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type ApplyCartClubMembershipSurcountMutationVariables = Exact<{
  input: CartClubMembershipSurcountApplyInput;
}>;


export type ApplyCartClubMembershipSurcountMutation = (
  { __typename?: 'Mutation' }
  & { applyCartClubMembershipSurcount: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type ApplyCartDiscountMutationVariables = Exact<{
  input: CartDiscountApplyInput;
}>;


export type ApplyCartDiscountMutation = (
  { __typename?: 'Mutation' }
  & { applyCartDiscount: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type CartLandingQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
  revalidate?: Maybe<Scalars['Boolean']>;
  checkMembership?: Maybe<Scalars['Boolean']>;
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
}>;


export type CartLandingQuery = (
  { __typename?: 'Query' }
  & { getCart?: Maybe<(
    { __typename?: 'Cart' }
    & Pick<Cart, 'id' | 'cartValidationErrors' | 'tableNumber' | 'tableArea' | 'orderingWindowStartDate' | 'orderingWindowEndDate' | 'orderingType'>
    & { cartValidationErrorsV2: Array<(
      { __typename?: 'CartValidationErrorV2' }
      & Pick<CartValidationErrorV2, 'type' | 'message'>
    )>, currentLocation?: Maybe<(
      { __typename?: 'Location' }
      & CurrentLocationPartsFragment
    )>, total: (
      { __typename?: 'CartTotal' }
      & Pick<CartTotal, 'minDeliveryThresholdNotReached' | 'minFreeDeliveryThresholdNotReached'>
    ), cartItems: Array<(
      { __typename?: 'CartItem' }
      & Pick<CartItem, 'id' | 'quantity'>
      & { cartUpsells?: Maybe<Array<(
        { __typename?: 'CartItem' }
        & Pick<CartItem, 'id' | 'quantity'>
      )>> }
    )> }
  )> }
);

export type CartMenuItemQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
  revalidate?: Maybe<Scalars['Boolean']>;
  checkMembership?: Maybe<Scalars['Boolean']>;
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
}>;


export type CartMenuItemQuery = (
  { __typename?: 'Query' }
  & { getCart?: Maybe<(
    { __typename?: 'Cart' }
    & Pick<Cart, 'id' | 'tableNumber' | 'tableArea' | 'orderingWindowStartDate'>
  )> }
);

export type CartMenuQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
  revalidate?: Maybe<Scalars['Boolean']>;
  checkMembership?: Maybe<Scalars['Boolean']>;
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
}>;


export type CartMenuQuery = (
  { __typename?: 'Query' }
  & { getCart?: Maybe<(
    { __typename?: 'Cart' }
    & Pick<Cart, 'id' | 'tableNumber' | 'tableArea' | 'orderingWindowStartDate'>
    & { cartItems: Array<(
      { __typename?: 'CartItem' }
      & Pick<CartItem, 'id' | 'quantity'>
      & { cartUpsells?: Maybe<Array<(
        { __typename?: 'CartItem' }
        & Pick<CartItem, 'id' | 'quantity'>
      )>> }
    )> }
  )> }
);

export type CartPageQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
  revalidate?: Maybe<Scalars['Boolean']>;
  checkMembership?: Maybe<Scalars['Boolean']>;
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
}>;


export type CartPageQuery = (
  { __typename?: 'Query' }
  & { getCart?: Maybe<(
    { __typename?: 'Cart' }
    & CartPartsFragment
  )> }
);

export type CartPaymentQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
  revalidate?: Maybe<Scalars['Boolean']>;
  checkMembership?: Maybe<Scalars['Boolean']>;
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
}>;


export type CartPaymentQuery = (
  { __typename?: 'Query' }
  & { getCart?: Maybe<(
    { __typename?: 'Cart' }
    & CartPartsFragment
  )> }
);

export type CartTableInfoQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
}>;


export type CartTableInfoQuery = (
  { __typename?: 'Query' }
  & { getCart?: Maybe<(
    { __typename?: 'Cart' }
    & Pick<Cart, 'tableNumber' | 'tableArea' | 'orderingWindowStartDate'>
  )> }
);

export type CreateCartMutationVariables = Exact<{
  googlePlaceId?: Maybe<Scalars['String']>;
  orderingType: OrderingType;
  revalidate?: Maybe<Scalars['Boolean']>;
  venueSlug: Scalars['String'];
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
}>;


export type CreateCartMutation = (
  { __typename?: 'Mutation' }
  & { createCart: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'tableNumber' | 'tableArea' | 'id'>
  ) }
);

export type RefreshCartPricesMutationVariables = Exact<{
  input: CartInputBase;
}>;


export type RefreshCartPricesMutation = (
  { __typename?: 'Mutation' }
  & { refreshCartPrices?: Maybe<(
    { __typename?: 'Cart' }
    & CartPartsFragment
  )> }
);

export type RemoveCartDiscountByCodeMutationVariables = Exact<{
  input: CartDiscountRemoveByCode;
}>;


export type RemoveCartDiscountByCodeMutation = (
  { __typename?: 'Mutation' }
  & { removeCartDiscountByCode: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type RemoveCartDiscountMutationVariables = Exact<{
  input: CartDiscountRemove;
}>;


export type RemoveCartDiscountMutation = (
  { __typename?: 'Mutation' }
  & { removeCartDiscount: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type RemoveCartServiceChargeMutationVariables = Exact<{
  input: CartServiceChargeRemove;
}>;


export type RemoveCartServiceChargeMutation = (
  { __typename?: 'Mutation' }
  & { removeCartServiceCharge: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type RemoveItemFromCartMutationVariables = Exact<{
  input: CartItemsRemove;
}>;


export type RemoveItemFromCartMutation = (
  { __typename?: 'Mutation' }
  & { removeItemFromCart: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type RemoveUnavailableItemsMutationVariables = Exact<{
  input: CartInputBase;
}>;


export type RemoveUnavailableItemsMutation = (
  { __typename?: 'Mutation' }
  & { removeUnavailableItems?: Maybe<(
    { __typename?: 'Cart' }
    & CartPartsFragment
  )> }
);

export type UpdateCartItemQuantityMutationVariables = Exact<{
  input: CartItemQuantityUpdate;
}>;


export type UpdateCartItemQuantityMutation = (
  { __typename?: 'Mutation' }
  & { updateCartItemQuantity: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type VenueDetailsQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
}>;


export type VenueDetailsQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'gratuityRate' | 'gratuityOptions' | 'gratuityEnabled' | 'canSkipGratuity' | 'flexibleGratuityEnabled' | 'customGratuityText' | 'tipjarUrl'>
    & { orderingType?: Maybe<(
      { __typename?: 'OrderingTypeSetting' }
      & Pick<OrderingTypeSetting, 'id' | 'name' | 'orderingType' | 'notesText' | 'notesFieldRequirement' | 'tableText' | 'tableShortText'>
    )>, posIntegration?: Maybe<(
      { __typename?: 'GuestVenuePosIntegration' }
      & Pick<GuestVenuePosIntegration, 'id' | 'type'>
    )> }
  )> }
);

export type MultiVendorConfirmationQueryVariables = Exact<{
  multiVendorOrderId: Scalars['String'];
}>;


export type MultiVendorConfirmationQuery = (
  { __typename?: 'Query' }
  & { multiVendorInvoice: (
    { __typename?: 'MultiVendorInvoicePayload' }
    & { multiVendorOrder: (
      { __typename?: 'MultiVendorOrder' }
      & Pick<MultiVendorOrder, 'id' | 'createdAt' | 'totalInCents'>
    ) }
  ) }
);

export type OrderConfirmationQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type OrderConfirmationQuery = (
  { __typename?: 'Query' }
  & { guestOrderById?: Maybe<(
    { __typename?: 'Order' }
    & OrderConfirmationPartsFragment
  )> }
);

export type VenueConfirmationQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
}>;


export type VenueConfirmationQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & GuestVenueConfirmationPartsFragment
  )> }
);

export type DirectoryVenueCollectionsQueryVariables = Exact<{
  vcPrefix: Scalars['String'];
  vcSlug?: Maybe<Scalars['String']>;
}>;


export type DirectoryVenueCollectionsQuery = (
  { __typename?: 'Query' }
  & { allCollections: Array<(
    { __typename?: 'VenueCollection' }
    & Pick<VenueCollection, 'id' | 'name' | 'slug'>
  )>, directoryVenueCollections: Array<(
    { __typename?: 'VenueCollection' }
    & Pick<VenueCollection, 'id' | 'name' | 'slug'>
    & { venueCollectionToVenue?: Maybe<Array<(
      { __typename?: 'VenueCollectionToVenue' }
      & DirectoryVenuePartsFragment
    )>> }
  )> }
);

export type ApplyCartEonxDetailsMutationVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type ApplyCartEonxDetailsMutation = (
  { __typename?: 'Mutation' }
  & { applyCartEonxDetails: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type EonxCheckInGuestMutationVariables = Exact<{
  id: Scalars['String'];
  venueSlug: Scalars['String'];
}>;


export type EonxCheckInGuestMutation = (
  { __typename?: 'Mutation' }
  & { eonxCheckInGuest: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'name' | 'email' | 'mobile'>
  ) }
);

export type VenueForMenuCategoryFragment = (
  { __typename?: 'GuestVenue' }
  & Pick<GuestVenue, 'id' | 'countryCode' | 'name' | 'slug' | 'ordering' | 'isClosed' | 'isLive' | 'facebookPixelId' | 'popupNotificationText' | 'isOrderingAvailable' | 'isBarBusy' | 'isKitchenBusy'>
  & { venueId: GuestVenue['id'] }
  & { hours?: Maybe<(
    { __typename?: 'TimeBlocks' }
    & TimeBlocksPartsFragment
  )>, location?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'formattedAddress' | 'locality' | 'adminArea2' | 'adminArea1'>
    & { id: Location['googlePlaceId'], state: Location['adminArea1'] }
  )>, orderingTypes: Array<(
    { __typename?: 'OrderingTypeSetting' }
    & Pick<OrderingTypeSetting, 'id' | 'orderingType' | 'enabled' | 'landingText' | 'isAvailable' | 'usingTableGroups'>
    & { orderingWindow?: Maybe<(
      { __typename?: 'OrderingWindowSettings' }
      & Pick<OrderingWindowSettings, 'id' | 'enabled'>
    )> }
  )> }
);

export type BasicInvoicePartsFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'id' | 'createdAt' | 'orderingType' | 'deliveryOption' | 'pickupOption' | 'orderingWindowStartDate' | 'isTaxInclusive' | 'totalTaxInCents' | 'totalInCents' | 'batchPosDisplayIds' | 'orderNotes' | 'paymentProcessor'>
  & { location?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'formattedAddress' | 'unitNumber'>
    & { id: Location['googlePlaceId'] }
  )>, venue: (
    { __typename?: 'Venue' }
    & VenueInvoicePartsFragment
  ), user: (
    { __typename?: 'User' }
    & UserInvoicePartsFragment
  ), lineItems: Array<(
    { __typename?: 'LineItem' }
    & LineItemPartsFragment
  )> }
);

export type CartPartsFragment = (
  { __typename?: 'Cart' }
  & Pick<Cart, 'id' | 'cartValidationErrors' | 'currency' | 'tableNumber' | 'tableArea' | 'coverCount' | 'orderingWindowStartDate' | 'orderingWindowEndDate' | 'orderingWindowEnabled' | 'notes' | 'deliveryOption' | 'pickupOption' | 'orderingType' | 'skipCardSurcharge'>
  & { cartValidationErrorsV2: Array<(
    { __typename?: 'CartValidationErrorV2' }
    & Pick<CartValidationErrorV2, 'type' | 'message'>
  )>, currentLocation?: Maybe<(
    { __typename?: 'Location' }
    & CurrentLocationPartsFragment
  )>, total: (
    { __typename?: 'CartTotal' }
    & Pick<CartTotal, 'isTaxInclusive' | 'totalInCents' | 'totalTaxInCents' | 'taxName' | 'subTotalInCents' | 'cardSurchargeInCents' | 'deliveryFeeInCents' | 'gratuityInCents' | 'minDeliveryThresholdNotReached' | 'minDeliveryOrderValueInCents' | 'minOrderValueForFreeDeliveryInCents' | 'cardSurchargeName' | 'minFreeDeliveryThresholdNotReached'>
    & { cartDiscounts?: Maybe<Array<(
      { __typename?: 'CartDiscount' }
      & Pick<CartDiscount, 'discountInCents' | 'discountName' | 'discountRate' | 'itemId' | 'quantity' | 'externalVoucherType' | 'discountType' | 'isRemovable' | 'code' | 'chargeType'>
    )>>, cartServiceCharge?: Maybe<(
      { __typename?: 'CartServiceCharge' }
      & Pick<CartServiceCharge, 'chargeInCents' | 'chargeName' | 'isRemovable'>
    )> }
  ), itemValidation: Array<(
    { __typename?: 'ItemValidation' }
    & Pick<ItemValidation, 'canDecrement' | 'canIncrement' | 'id'>
    & { itemsDeleted: Array<(
      { __typename?: 'CartItem' }
      & Pick<CartItem, 'id' | 'name' | 'quantity'>
    )> }
  )>, cartItems: Array<(
    { __typename?: 'CartItem' }
    & CartItemPartsFragment
  )> }
);

export type CartItemPartsFragment = (
  { __typename?: 'CartItem' }
  & Pick<CartItem, 'id' | 'totalInCents' | 'name' | 'type' | 'quantity' | 'isFree'>
  & { item?: Maybe<(
    { __typename?: 'MenuItem' }
    & Pick<MenuItem, 'id' | 'slug' | 'name' | 'price' | 'minQuantity' | 'maxQuantity' | 'isPopular' | 'description' | 'dietaryTags' | 'filterTags'>
    & { priceData: (
      { __typename?: 'PriceData' }
      & Pick<PriceData, 'displayPrice' | 'hasPriceOverride'>
    ), cdnImage?: Maybe<(
      { __typename?: 'CdnImage' }
      & Pick<CdnImage, 'defaultImage' | 'srcSet' | 'id' | 'originalImagePath' | 'originalImageUrl'>
    )> }
  )>, cartModifiers?: Maybe<Array<(
    { __typename?: 'CartItem' }
    & Pick<CartItem, 'id' | 'name' | 'quantity'>
  )>>, cartUpsells?: Maybe<Array<(
    { __typename?: 'CartItem' }
    & Pick<CartItem, 'id' | 'name' | 'quantity'>
  )>> }
);

export type CurrentLocationPartsFragment = (
  { __typename?: 'Location' }
  & Pick<Location, 'id' | 'googlePlaceId' | 'unitNumber' | 'formattedAddress' | 'latitude' | 'longitude' | 'postalCode'>
);

export type DirectoryVenuePartsFragment = (
  { __typename?: 'VenueCollectionToVenue' }
  & Pick<VenueCollectionToVenue, 'id' | 'name' | 'enabled'>
  & { venue?: Maybe<(
    { __typename?: 'Venue' }
    & Pick<Venue, 'id' | 'slug' | 'orderingType' | 'name' | 'isClosed'>
    & { ogImage?: Maybe<(
      { __typename?: 'CdnImage' }
      & Pick<CdnImage, 'id' | 'srcSet' | 'defaultImage'>
    )>, image?: Maybe<(
      { __typename?: 'CdnImage' }
      & Pick<CdnImage, 'id' | 'originalImageUrl'>
    )> }
  )> }
);

export type EonxCardPartsFragment = (
  { __typename?: 'EonxPaymentMethod' }
  & Pick<EonxPaymentMethod, 'brand' | 'last4' | 'expiry'>
);

export type GuestInfoPartsFragment = (
  { __typename?: 'RegistryGuest' }
  & Pick<RegistryGuest, 'id' | 'name' | 'email' | 'mobile' | 'addressOrEmail' | 'postcode' | 'tableNumber' | 'temperature' | 'idNumber' | 'ageRequirement' | 'correctDeclaration' | 'symptomsConfirmation' | 'marketingOptInEnabled' | 'createdAt'>
);

export type GuestVenueConfirmationPartsFragment = (
  { __typename?: 'GuestVenue' }
  & Pick<GuestVenue, 'id' | 'name' | 'slug' | 'currency' | 'surveyLink' | 'yumpingoVenueId' | 'availableOrderingType' | 'tipjarUrl'>
  & { banner?: Maybe<(
    { __typename?: 'GuestImage' }
    & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
  )>, mobileBanner?: Maybe<(
    { __typename?: 'GuestImage' }
    & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
  )>, location?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id' | 'unitNumber' | 'formattedAddress'>
  )>, orderingType?: Maybe<(
    { __typename?: 'OrderingTypeSetting' }
    & Pick<OrderingTypeSetting, 'tableShortText'>
  )> }
);

export type LineItemPartsFragment = (
  { __typename?: 'LineItem' }
  & Pick<LineItem, 'id' | 'parentId' | 'name' | 'quantity' | 'originalPriceInCents' | 'priceInCents' | 'kind' | 'type'>
);

export type MenuCategoryPartsFragment = (
  { __typename?: 'GuestMenuCategory' }
  & Pick<GuestMenuCategory, 'id' | 'slug' | 'name' | 'isClosed' | 'menuCategoryType' | 'orderingType' | 'position' | 'mvoFeatured'>
  & { image?: Maybe<(
    { __typename?: 'GuestImage' }
    & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
  )> }
);

export type MenuItemDetailsFragment = (
  { __typename?: 'GuestMenuItem' }
  & Pick<GuestMenuItem, 'id' | 'slug' | 'type' | 'name' | 'namefr' | 'nameel' | 'namees' | 'nameit' | 'namede' | 'namezhCN' | 'isPopular' | 'description' | 'descriptionPlain' | 'descriptionfr' | 'descriptionel' | 'descriptiones' | 'descriptionit' | 'descriptionzhCN' | 'descriptionde' | 'dietaryTags' | 'filterTags' | 'allergens' | 'minQuantity' | 'maxQuantity' | 'inventoryEnabled' | 'inventoryCount'>
  & { image?: Maybe<(
    { __typename?: 'GuestImage' }
    & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
  )>, priceData: (
    { __typename?: 'GuestPriceData' }
    & Pick<GuestPriceData, 'displayPrice' | 'priceInCents' | 'originalDisplayPrice' | 'hasPriceOverride' | 'isMembershipPricing'>
  ), rewardPrice?: Maybe<(
    { __typename?: 'GuestRewardPrice' }
    & Pick<GuestRewardPrice, 'originalAmountInCents' | 'originalDisplayAmount'>
  )>, priceLevels?: Maybe<Array<(
    { __typename?: 'PriceLevel' }
    & Pick<PriceLevel, 'priceInCents' | 'level'>
  )>>, extendedWaitTime?: Maybe<(
    { __typename?: 'GuestWaitTime' }
    & Pick<GuestWaitTime, 'id' | 'estimate' | 'estimateInMilliseconds' | 'expiry' | 'expiryEndTime'>
  )> }
);

export type MenuItemWithMenuCategoryFragment = (
  { __typename?: 'GuestMenuItem' }
  & Pick<GuestMenuItem, 'id' | 'slug' | 'type' | 'name' | 'category' | 'isAvailable'>
  & { image?: Maybe<(
    { __typename?: 'GuestImage' }
    & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
  )>, priceData: (
    { __typename?: 'GuestPriceData' }
    & Pick<GuestPriceData, 'displayPrice' | 'priceInCents' | 'originalDisplayPrice' | 'hasPriceOverride' | 'isMembershipPricing'>
  ), rewardPrice?: Maybe<(
    { __typename?: 'GuestRewardPrice' }
    & Pick<GuestRewardPrice, 'originalAmountInCents' | 'originalDisplayAmount'>
  )>, menuCategories?: Maybe<Array<(
    { __typename?: 'GuestMenuCategory' }
    & Pick<GuestMenuCategory, 'slug'>
  )>> }
);

export type MultiVendorInvoicePartsFragment = (
  { __typename?: 'MultiVendorOrder' }
  & Pick<MultiVendorOrder, 'id' | 'createdAt' | 'totalInCents'>
  & { venue: (
    { __typename?: 'Venue' }
    & VenueInvoicePartsFragment
  ) }
);

export type MvoSearchResultMenuItemFragment = (
  { __typename?: 'GuestMenuItem' }
  & Pick<GuestMenuItem, 'id' | 'slug' | 'name' | 'type' | 'isLive' | 'isPopular' | 'inventoryEnabled' | 'isAvailable'>
  & { image?: Maybe<(
    { __typename?: 'GuestImage' }
    & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
  )>, priceData: (
    { __typename?: 'GuestPriceData' }
    & Pick<GuestPriceData, 'displayPrice' | 'priceInCents' | 'originalDisplayPrice' | 'hasPriceOverride' | 'isMembershipPricing'>
  ), rewardPrice?: Maybe<(
    { __typename?: 'GuestRewardPrice' }
    & Pick<GuestRewardPrice, 'originalAmountInCents' | 'originalDisplayAmount'>
  )> }
);

export type OrderConfirmationPartsFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'id' | 'orderingType' | 'createdAt' | 'totalInCents' | 'paymentProcessor' | 'orderingWindowStartDate' | 'orderingWindowEndDate' | 'socialTabId' | 'tableArea' | 'tableNumber'>
  & { location?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id' | 'unitNumber' | 'formattedAddress'>
  )> }
);

export type OrderHistoryPartsFragment = (
  { __typename?: 'OrderHistory' }
  & Pick<OrderHistory, 'id' | 'totalInCents' | 'createdAt' | 'type' | 'receiptId' | 'info'>
);

export type PaystackCardPartsFragment = (
  { __typename?: 'PaystackCard' }
  & Pick<PaystackCard, 'brand' | 'last4' | 'expiry' | 'paymentMethodId'>
);

export type SocialTabPartsFragment = (
  { __typename?: 'SocialTab' }
  & Pick<SocialTab, 'id' | 'tabName'>
);

export type StripeCardPartsFragment = (
  { __typename?: 'StripeCard' }
  & Pick<StripeCard, 'brand' | 'last4' | 'expiry' | 'paymentMethodId'>
);

export type TimeBlocksPartsFragment = (
  { __typename?: 'TimeBlocks' }
  & Pick<TimeBlocks, 'id' | 'name'>
  & { sun?: Maybe<Array<(
    { __typename?: 'TimeSlot' }
    & TimeSlotPartsFragment
  )>>, mon?: Maybe<Array<(
    { __typename?: 'TimeSlot' }
    & TimeSlotPartsFragment
  )>>, tue?: Maybe<Array<(
    { __typename?: 'TimeSlot' }
    & TimeSlotPartsFragment
  )>>, wed?: Maybe<Array<(
    { __typename?: 'TimeSlot' }
    & TimeSlotPartsFragment
  )>>, thu?: Maybe<Array<(
    { __typename?: 'TimeSlot' }
    & TimeSlotPartsFragment
  )>>, fri?: Maybe<Array<(
    { __typename?: 'TimeSlot' }
    & TimeSlotPartsFragment
  )>>, sat?: Maybe<Array<(
    { __typename?: 'TimeSlot' }
    & TimeSlotPartsFragment
  )>> }
);

export type TimeSlotPartsFragment = (
  { __typename?: 'TimeSlot' }
  & Pick<TimeSlot, 'startTime' | 'endTime'>
);

export type UserInvoicePartsFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'name' | 'email' | 'mobile'>
);

export type UserPartsFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'name' | 'email' | 'receiptEmail' | 'customerId' | 'isOver18' | 'mobile' | 'savePaymentDetails'>
);

export type VenueInvoicePartsFragment = (
  { __typename?: 'Venue' }
  & Pick<Venue, 'id' | 'slug' | 'name' | 'timezone' | 'supportEmail' | 'supportPhone' | 'currency' | 'taxRate' | 'gstRegistrationNumber' | 'additionalInvoiceInformation'>
  & { location?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'formattedAddress'>
    & { id: Location['googlePlaceId'] }
  )> }
);

export type VenueLandingFragment = (
  { __typename?: 'GuestVenue' }
  & Pick<GuestVenue, 'id' | 'countryCode' | 'name' | 'slug' | 'ordering' | 'isClosed' | 'isLive' | 'facebookPixelId' | 'popupNotificationText' | 'isOrderingAvailable' | 'isBarBusy' | 'isKitchenBusy' | 'timezone' | 'tabsEnabled' | 'landingCallToActionText' | 'landingCallToActionUrl' | 'alwaysShowVisualMenu' | 'skipTableNumberModal' | 'showOrderingTypePicker' | 'showCategoryListViewOnLandingPage' | 'startTabAvailable' | 'multiVendorEnabled'>
  & { venueId: GuestVenue['id'] }
  & { orderingTypes: Array<(
    { __typename?: 'OrderingTypeSetting' }
    & Pick<OrderingTypeSetting, 'id' | 'name' | 'landingText' | 'orderingType' | 'isAvailable' | 'tablePromptText' | 'tableShortText' | 'usingTableGroups'>
    & { orderingWindow?: Maybe<(
      { __typename?: 'OrderingWindowSettings' }
      & Pick<OrderingWindowSettings, 'id' | 'enabled'>
    )> }
  )>, hours?: Maybe<(
    { __typename?: 'TimeBlocks' }
    & TimeBlocksPartsFragment
  )>, location?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'formattedAddress' | 'locality' | 'adminArea2' | 'adminArea1'>
    & { id: Location['googlePlaceId'], state: Location['adminArea1'] }
  )>, logo?: Maybe<(
    { __typename?: 'GuestImage' }
    & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
  )>, banner?: Maybe<(
    { __typename?: 'GuestImage' }
    & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
  )>, mobileBanner?: Maybe<(
    { __typename?: 'GuestImage' }
    & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
  )>, posIntegration?: Maybe<(
    { __typename?: 'GuestVenuePosIntegration' }
    & Pick<GuestVenuePosIntegration, 'id' | 'type'>
  )> }
);

export type VenueLandingMenuCategoryFragment = (
  { __typename?: 'GuestMenuCategory' }
  & Pick<GuestMenuCategory, 'id' | 'name' | 'slug' | 'menuCategoryType' | 'orderingType' | 'isClosed' | 'position' | 'mvoFeatured'>
  & { image?: Maybe<(
    { __typename?: 'GuestImage' }
    & Pick<GuestImage, 'id' | 'originalImageUrl' | 'originalImagePath'>
  )>, extendedWaitTime?: Maybe<(
    { __typename?: 'GuestWaitTime' }
    & Pick<GuestWaitTime, 'id' | 'estimate' | 'estimateInMilliseconds' | 'expiry' | 'expiryEndTime'>
  )> }
);

export type WindowPartsFragment = (
  { __typename?: 'OrderingWindowSettings' }
  & Pick<OrderingWindowSettings, 'id' | 'enabled' | 'futureDays' | 'asapWindowEnabled'>
  & { availableOrderingWindows: Array<(
    { __typename?: 'AvailableSlot' }
    & Pick<AvailableSlot, 'id' | 'startTime' | 'endTime' | 'orderingWindowStartDate' | 'unlimitedOrders' | 'windows' | 'isPast'>
  )> }
);

export type CreateReviewMutationVariables = Exact<{
  input: CreateReviewInput;
}>;


export type CreateReviewMutation = (
  { __typename?: 'Mutation' }
  & { createReview: (
    { __typename?: 'Review' }
    & Pick<Review, 'id' | 'notes' | 'rating' | 'createdAt' | 'updatedAt'>
  ) }
);

export type GetReviewQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type GetReviewQuery = (
  { __typename?: 'Query' }
  & { getReview?: Maybe<(
    { __typename?: 'Review' }
    & Pick<Review, 'id' | 'notes' | 'rating' | 'createdAt' | 'updatedAt'>
  )> }
);

export type UpdateReviewMutationVariables = Exact<{
  input: UpdateReviewInput;
}>;


export type UpdateReviewMutation = (
  { __typename?: 'Mutation' }
  & { updateReview: (
    { __typename?: 'Review' }
    & Pick<Review, 'id' | 'notes' | 'rating' | 'createdAt' | 'updatedAt'>
  ) }
);

export type HamburgerMenuAdditionalQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type HamburgerMenuAdditionalQuery = (
  { __typename?: 'Query' }
  & { currentUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { managedTabs?: Maybe<Array<(
      { __typename?: 'SocialTab' }
      & Pick<SocialTab, 'id' | 'tabName'>
    )>> }
  )>, lastOrderByUserByVenueSlug?: Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'paymentProcessor' | 'orderingType'>
  )> }
);

export type HamburgerMenuQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type HamburgerMenuQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'name' | 'bookingLink' | 'surveyLink' | 'yumpingoVenueId' | 'ordering' | 'isOrderingAvailable' | 'landingCallToActionText' | 'landingCallToActionUrl' | 'isClosed' | 'startTabAvailable' | 'supportEmail' | 'supportPhone'>
    & { hours?: Maybe<(
      { __typename?: 'TimeBlocks' }
      & TimeBlocksPartsFragment
    )>, location?: Maybe<(
      { __typename?: 'Location' }
      & Pick<Location, 'formattedAddress'>
      & { id: Location['googlePlaceId'] }
    )>, logo?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )>, orderingTypes: Array<(
      { __typename?: 'OrderingTypeSetting' }
      & Pick<OrderingTypeSetting, 'id' | 'orderingType' | 'isAvailable'>
      & { orderingWindow?: Maybe<(
        { __typename?: 'OrderingWindowSettings' }
        & Pick<OrderingWindowSettings, 'id' | 'enabled'>
      )> }
    )> }
  )> }
);

export type BasicInvoiceQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type BasicInvoiceQuery = (
  { __typename?: 'Query' }
  & { invoice: (
    { __typename?: 'Order' }
    & BasicInvoicePartsFragment
  ) }
);

export type MultiVendorInvoiceQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type MultiVendorInvoiceQuery = (
  { __typename?: 'Query' }
  & { multiVendorInvoice: (
    { __typename?: 'MultiVendorInvoicePayload' }
    & { multiVendorOrder: (
      { __typename?: 'MultiVendorOrder' }
      & MultiVendorInvoicePartsFragment
    ), orders: Array<(
      { __typename?: 'Order' }
      & BasicInvoicePartsFragment
    )> }
  ) }
);

export type SharedPaymentInvoiceQueryVariables = Exact<{
  sharedPaymentLineItemId: Scalars['String'];
}>;


export type SharedPaymentInvoiceQuery = (
  { __typename?: 'Query' }
  & { sharedPaymentInvoice: (
    { __typename?: 'SharedPaymentInvoicePayload' }
    & Pick<SharedPaymentInvoicePayload, 'id' | 'totalInCents' | 'totalTaxInCents' | 'gratuityInCents'>
    & { order: (
      { __typename?: 'Order' }
      & BasicInvoicePartsFragment
    ), user: (
      { __typename?: 'User' }
      & UserInvoicePartsFragment
    ) }
  ) }
);

export type TabInvoiceQueryVariables = Exact<{
  tabId: Scalars['String'];
}>;


export type TabInvoiceQuery = (
  { __typename?: 'Query' }
  & { tabInvoice: Array<(
    { __typename?: 'Order' }
    & BasicInvoicePartsFragment
  )>, getTabMeta: (
    { __typename?: 'SocialTabMeta' }
    & Pick<SocialTabMeta, 'id'>
    & { managers?: Maybe<Array<(
      { __typename?: 'User' }
      & UserInvoicePartsFragment
    )>>, venue?: Maybe<(
      { __typename?: 'Venue' }
      & VenueInvoicePartsFragment
    )> }
  ) }
);

export type VenueCollectionBySlugQueryVariables = Exact<{
  vcslug: Scalars['String'];
}>;


export type VenueCollectionBySlugQuery = (
  { __typename?: 'Query' }
  & { venueCollectionBySlug: (
    { __typename?: 'VenueCollection' }
    & Pick<VenueCollection, 'id' | 'description' | 'name' | 'slug'>
    & { venueCollectionToVenue?: Maybe<Array<(
      { __typename?: 'VenueCollectionToVenue' }
      & Pick<VenueCollectionToVenue, 'id' | 'name' | 'type' | 'enabled' | 'orderingType'>
      & { venue?: Maybe<(
        { __typename?: 'Venue' }
        & Pick<Venue, 'id' | 'name' | 'slug'>
        & { squareThumb?: Maybe<(
          { __typename?: 'CdnImage' }
          & Pick<CdnImage, 'id' | 'defaultImage' | 'srcSet'>
        )> }
      )>, childrenCollection?: Maybe<(
        { __typename?: 'VenueCollection' }
        & Pick<VenueCollection, 'id' | 'name' | 'slug'>
      )>, vlpImage?: Maybe<(
        { __typename?: 'CdnImage' }
        & Pick<CdnImage, 'id' | 'defaultImage' | 'srcSet'>
      )>, image?: Maybe<(
        { __typename?: 'CdnImage' }
        & Pick<CdnImage, 'id' | 'originalImageUrl'>
      )> }
    )>> }
  ) }
);

export type VenueCollectionRegionQueryVariables = Exact<{ [key: string]: never; }>;


export type VenueCollectionRegionQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'venueCollectionRegion'>
);

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = (
  { __typename?: 'Query' }
  & { currentUser?: Maybe<(
    { __typename?: 'User' }
    & UserPartsFragment
  )> }
);

export type LoginMutationVariables = Exact<{
  mobile: Scalars['String'];
  otp: Scalars['String'];
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { login: (
    { __typename?: 'LoginPayload' }
    & Pick<LoginPayload, 'mobile'>
  ) }
);

export type LoginAsAnonymousGuestMutationVariables = Exact<{ [key: string]: never; }>;


export type LoginAsAnonymousGuestMutation = (
  { __typename?: 'Mutation' }
  & { loginAsAnonymousGuest: (
    { __typename?: 'LoginPayload' }
    & Pick<LoginPayload, 'mobile'>
  ) }
);

export type SendOneTimePasswordSmsMutationVariables = Exact<{
  mobile: Scalars['String'];
  turnstileToken?: Maybe<Scalars['String']>;
}>;


export type SendOneTimePasswordSmsMutation = (
  { __typename?: 'Mutation' }
  & { sendOneTimePasswordSMS: (
    { __typename?: 'SendOneTimePasswordSMSPayload' }
    & Pick<SendOneTimePasswordSmsPayload, 'mobile' | 'result' | 'retryAfter'>
  ) }
);

export type VenueCountryCodeQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueCountryCodeQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'countryCode' | 'currency'>
  )> }
);

export type AddGuestMembershipMutationVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type AddGuestMembershipMutation = (
  { __typename?: 'Mutation' }
  & { addGuestMembership: (
    { __typename?: 'addGuestMembershipPayload' }
    & Pick<AddGuestMembershipPayload, 'success'>
  ) }
);

export type LoyaltyMembershipQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  externalMemberId?: Maybe<Scalars['String']>;
}>;


export type LoyaltyMembershipQuery = (
  { __typename?: 'Query' }
  & { loyaltyDetails?: Maybe<(
    { __typename?: 'LoyaltyDetailsPayload' }
    & Pick<LoyaltyDetailsPayload, 'id'>
    & { guestData?: Maybe<(
      { __typename?: 'LoyaltyGuestDataPayload' }
      & Pick<LoyaltyGuestDataPayload, 'id' | 'isOptedIn'>
    )>, metadata?: Maybe<(
      { __typename?: 'LoyaltyMetadataPayload' }
      & Pick<LoyaltyMetadataPayload, 'id' | 'memberName' | 'introHeader' | 'introBody' | 'infoLink'>
    )> }
  )>, guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'organizationId'>
    & { venueId: GuestVenue['id'] }
  )>, getGuestMembership?: Maybe<(
    { __typename?: 'getGuestMembershipPayload' }
    & Pick<GetGuestMembershipPayload, 'id' | 'email'>
  )> }
);

export type AboutVenueQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type AboutVenueQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'ordering'>
  )> }
);

export type AddOrUpdateTableNumberOnCartMutationVariables = Exact<{
  input: CartTableNumberInput;
}>;


export type AddOrUpdateTableNumberOnCartMutation = (
  { __typename?: 'Mutation' }
  & { addOrUpdateTableNumberOnCart: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type MenuCategoriesQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
}>;


export type MenuCategoriesQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & VenueForMenuCategoryFragment
  )>, guestMenuCategories: Array<(
    { __typename?: 'GuestMenuCategory' }
    & Pick<GuestMenuCategory, 'id' | 'name' | 'slug' | 'menuCategoryType' | 'orderingType' | 'isClosed'>
    & { image?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImageUrl' | 'originalImagePath'>
    )> }
  )> }
);

export type MenuQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
  categorySlug: Scalars['String'];
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  priceLevel?: Maybe<Scalars['String']>;
}>;


export type MenuQuery = (
  { __typename?: 'Query' }
  & { guestMenuCategory: (
    { __typename?: 'GuestMenuCategory' }
    & Pick<GuestMenuCategory, 'id' | 'name' | 'slug'>
    & { image?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )>, extendedWaitTime?: Maybe<(
      { __typename?: 'GuestWaitTime' }
      & Pick<GuestWaitTime, 'id' | 'estimate' | 'estimateInMilliseconds' | 'expiry' | 'expiryEndTime'>
    )>, menuSections: Array<(
      { __typename?: 'GuestMenuSection' }
      & Pick<GuestMenuSection, 'id' | 'name' | 'slug' | 'subSection'>
      & { menuItems: Array<(
        { __typename?: 'GuestMenuItem' }
        & Pick<GuestMenuItem, 'id' | 'slug' | 'name' | 'type' | 'isAvailable' | 'isLive' | 'isPopular' | 'namefr' | 'imageCredit' | 'filterTags' | 'nameel' | 'namees' | 'nameit' | 'namezhCN' | 'namede' | 'description' | 'descriptionPlain' | 'descriptionfr' | 'descriptionel' | 'descriptiones' | 'descriptionit' | 'descriptionzhCN' | 'descriptionde' | 'dietaryTags'>
        & { image?: Maybe<(
          { __typename?: 'GuestImage' }
          & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
        )>, priceData: (
          { __typename?: 'GuestPriceData' }
          & Pick<GuestPriceData, 'displayPrice' | 'priceInCents' | 'originalDisplayPrice' | 'hasPriceOverride' | 'isMembershipPricing'>
        ), rewardPrice?: Maybe<(
          { __typename?: 'GuestRewardPrice' }
          & Pick<GuestRewardPrice, 'originalAmountInCents' | 'originalDisplayAmount'>
        )> }
      )>, extendedWaitTime?: Maybe<(
        { __typename?: 'GuestWaitTime' }
        & Pick<GuestWaitTime, 'id' | 'estimate' | 'estimateInMilliseconds' | 'expiry' | 'expiryEndTime'>
      )> }
    )> }
  ), guestMenuCategories: Array<(
    { __typename?: 'GuestMenuCategory' }
    & Pick<GuestMenuCategory, 'id' | 'name' | 'slug'>
    & { image?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )>, menuSections: Array<(
      { __typename?: 'GuestMenuSection' }
      & Pick<GuestMenuSection, 'id' | 'name' | 'slug' | 'subSection'>
    )>, extendedWaitTime?: Maybe<(
      { __typename?: 'GuestWaitTime' }
      & Pick<GuestWaitTime, 'id' | 'estimate' | 'estimateInMilliseconds' | 'expiry' | 'expiryEndTime'>
    )> }
  )> }
);

export type MenuVenueQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type MenuVenueQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'name' | 'slug' | 'facebookPixelId' | 'isIframe' | 'bookingLink' | 'currency' | 'isBarBusy' | 'isKitchenBusy' | 'ordering' | 'countryCode' | 'timezone' | 'tabsEnabled' | 'landingCallToActionText' | 'landingCallToActionUrl' | 'isClosed' | 'isLive' | 'isOrderingAvailable' | 'alwaysShowVisualMenu' | 'supportEmail' | 'supportPhone'>
    & { venueId: GuestVenue['id'] }
    & { hours?: Maybe<(
      { __typename?: 'TimeBlocks' }
      & TimeBlocksPartsFragment
    )>, logo?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )>, banner?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )>, mobileBanner?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )>, location?: Maybe<(
      { __typename?: 'Location' }
      & Pick<Location, 'googlePlaceId' | 'priceLevel' | 'name' | 'url' | 'formattedAddress' | 'streetAddress' | 'locality' | 'adminArea2' | 'adminArea1' | 'latitude' | 'longitude' | 'countryCode' | 'postalCode'>
      & { id: Location['googlePlaceId'], state: Location['adminArea1'] }
    )>, cuisines?: Maybe<Array<(
      { __typename?: 'Cuisine' }
      & Pick<Cuisine, 'name'>
    )>>, orderingTypes: Array<(
      { __typename?: 'OrderingTypeSetting' }
      & Pick<OrderingTypeSetting, 'id' | 'orderingType' | 'enabled' | 'landingText' | 'isAvailable' | 'usingTableGroups'>
      & { orderingWindow?: Maybe<(
        { __typename?: 'OrderingWindowSettings' }
        & Pick<OrderingWindowSettings, 'id' | 'enabled'>
      )> }
    )>, posIntegration?: Maybe<(
      { __typename?: 'GuestVenuePosIntegration' }
      & Pick<GuestVenuePosIntegration, 'id' | 'type'>
    )> }
  )> }
);

export type TableRuleQueryVariables = Exact<{
  number: Scalars['String'];
  area?: Maybe<Scalars['String']>;
}>;


export type TableRuleQuery = (
  { __typename?: 'Query' }
  & { tableRule: (
    { __typename?: 'TableRule' }
    & Pick<TableRule, 'area' | 'number' | 'status'>
  ) }
);

export type MenuItemDetailsQueryVariables = Exact<{
  itemSlug: Scalars['String'];
  categorySlug: Scalars['String'];
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  priceLevel?: Maybe<Scalars['String']>;
}>;


export type MenuItemDetailsQuery = (
  { __typename?: 'Query' }
  & { guestMenuItem: (
    { __typename?: 'GuestMenuItem' }
    & Pick<GuestMenuItem, 'isAvailable' | 'isAvailableForOrdering'>
    & MenuItemDetailsFragment
  ), guestMenuCategory: (
    { __typename?: 'GuestMenuCategory' }
    & Pick<GuestMenuCategory, 'id' | 'slug' | 'isClosed'>
  ) }
);

export type MenuItemDetailsVenueQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
}>;


export type MenuItemDetailsVenueQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'currency' | 'ordering' | 'isOrderingAvailable'>
    & { orderingType?: Maybe<(
      { __typename?: 'OrderingTypeSetting' }
      & Pick<OrderingTypeSetting, 'id' | 'isAvailable'>
    )>, posIntegration?: Maybe<(
      { __typename?: 'GuestVenuePosIntegration' }
      & Pick<GuestVenuePosIntegration, 'id' | 'type'>
    )> }
  )> }
);

export type ModifiersForMenuItemQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  itemSlug: Scalars['String'];
  orderingType: OrderingType;
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  priceLevel?: Maybe<Scalars['String']>;
}>;


export type ModifiersForMenuItemQuery = (
  { __typename?: 'Query' }
  & { guestMenuItem: (
    { __typename?: 'GuestMenuItem' }
    & { upgradeGroup?: Maybe<(
      { __typename?: 'GuestUpgradeGroup' }
      & Pick<GuestUpgradeGroup, 'id' | 'name' | 'available' | 'selectType' | 'orderingTypes' | 'selectRequirement' | 'minQuantity' | 'maxQuantity' | 'hasPreselectedOption'>
      & { upgrades: Array<(
        { __typename?: 'GuestUpgrade' }
        & Pick<GuestUpgrade, 'id' | 'name' | 'position' | 'available' | 'displayPrice' | 'showFullPrice'>
        & { menuItem: (
          { __typename?: 'GuestMenuItem' }
          & Pick<GuestMenuItem, 'id' | 'slug' | 'name' | 'isAvailableForOrdering' | 'inventoryEnabled' | 'inventoryCount' | 'minQuantity' | 'maxQuantity'>
          & { priceData: (
            { __typename?: 'GuestPriceData' }
            & Pick<GuestPriceData, 'displayPrice' | 'priceInCents' | 'originalDisplayPrice' | 'hasPriceOverride' | 'isMembershipPricing'>
          ), priceLevels?: Maybe<Array<(
            { __typename?: 'PriceLevel' }
            & Pick<PriceLevel, 'priceInCents' | 'level'>
          )>> }
          & MenuItemDetailsFragment
        ) }
      )> }
    )>, modifierGroups: Array<(
      { __typename?: 'GuestMenuItemModifierGroup' }
      & Pick<GuestMenuItemModifierGroup, 'id' | 'name' | 'selectType' | 'orderingTypes' | 'displayViewSelectRequirement' | 'hasPreselectedOption' | 'selectRequirement' | 'minQuantity' | 'maxQuantity'>
      & { modifiers: Array<(
        { __typename?: 'GuestModifier' }
        & Pick<GuestModifier, 'id' | 'name' | 'available' | 'displayPrice' | 'priceInCents' | 'maxQuantity' | 'position' | 'isTaxExempt'>
        & { priceData?: Maybe<(
          { __typename?: 'GuestPriceData' }
          & Pick<GuestPriceData, 'displayPrice' | 'priceInCents' | 'originalDisplayPrice' | 'hasPriceOverride' | 'isMembershipPricing'>
        )> }
      )> }
    )>, upsellGroups: Array<(
      { __typename?: 'GuestUpsellGroup' }
      & Pick<GuestUpsellGroup, 'id' | 'name' | 'available' | 'selectType' | 'orderingTypes' | 'selectRequirement' | 'minQuantity' | 'maxQuantity' | 'hasPreselectedOption' | 'displayViewSelectRequirement' | 'isDynamic' | 'respectCartQuantity'>
      & { upsells: Array<(
        { __typename?: 'GuestUpsell' }
        & Pick<GuestUpsell, 'id' | 'name' | 'position' | 'displayPrice' | 'available' | 'showFullPrice'>
        & { menuItem: (
          { __typename?: 'GuestMenuItem' }
          & Pick<GuestMenuItem, 'isLive' | 'isAvailable' | 'isAvailableForOrdering'>
          & { modifierGroups: Array<(
            { __typename?: 'GuestMenuItemModifierGroup' }
            & Pick<GuestMenuItemModifierGroup, 'id' | 'name' | 'selectType' | 'orderingTypes' | 'displayViewSelectRequirement' | 'hasPreselectedOption' | 'selectRequirement' | 'minQuantity' | 'maxQuantity'>
            & { modifiers: Array<(
              { __typename?: 'GuestModifier' }
              & Pick<GuestModifier, 'id' | 'name' | 'available' | 'displayPrice' | 'priceInCents' | 'maxQuantity' | 'position' | 'isTaxExempt'>
              & { priceData?: Maybe<(
                { __typename?: 'GuestPriceData' }
                & Pick<GuestPriceData, 'displayPrice' | 'priceInCents' | 'originalDisplayPrice' | 'hasPriceOverride' | 'isMembershipPricing'>
              )> }
            )> }
          )> }
          & MenuItemDetailsFragment
        ) }
      )> }
    )> }
  ) }
);

export type VenueMetaImageQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueMetaImageQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id'>
    & { ogImage?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )>, image?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImageUrl'>
    )> }
  )> }
);

export type OrderHistoryDataQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type OrderHistoryDataQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'name' | 'currency'>
  )>, currentUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'receiptEmail' | 'email'>
  )> }
);

export type OrderHistoryOrdersQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type OrderHistoryOrdersQuery = (
  { __typename?: 'Query' }
  & { getOrderHistoryV3: Array<(
    { __typename?: 'OrderHistory' }
    & OrderHistoryPartsFragment
  )> }
);

export type UpdateReceiptEmailMutationVariables = Exact<{
  receiptEmail: Scalars['String'];
  venueSlug: Scalars['String'];
}>;


export type UpdateReceiptEmailMutation = (
  { __typename?: 'Mutation' }
  & { updateCustomerDetailsAndSendReceipt?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'receiptEmail'>
  )> }
);

export type CreateEonxOrderIntentMutationVariables = Exact<{
  order: CreateOrderInput;
}>;


export type CreateEonxOrderIntentMutation = (
  { __typename?: 'Mutation' }
  & { createOrder: (
    { __typename?: 'OrderCreateResponse' }
    & { orderPaymentCapture?: Maybe<(
      { __typename?: 'PaymentTransactionCapture' }
      & Pick<PaymentTransactionCapture, 'intentId' | 'intentApiKey'>
    )> }
  ) }
);

export type CreateOrderMutationVariables = Exact<{
  options: CartOptionsInput;
  customer: UpdateCurrentCustomerInput;
  marketing: UpdateMarketingOptInInput;
  order: CreateOrderInput;
  doordashInput: ValidateDoordashOrderDeliveryInput;
}>;


export type CreateOrderMutation = (
  { __typename?: 'Mutation' }
  & { validateDoordashOrderDelivery: (
    { __typename?: 'ValidateDoordashDeliveryResponse' }
    & Pick<ValidateDoordashDeliveryResponse, 'success' | 'error'>
  ), addOrUpdateOptionsOnCart: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'id'>
  ), updateCurrentCustomer: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ), updateMarketingOptIn: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ), createOrder: (
    { __typename?: 'OrderCreateResponse' }
    & Pick<OrderCreateResponse, 'customerId' | 'orderId' | 'multiVendorOrder' | 'socialTabId'>
    & { validation?: Maybe<(
      { __typename?: 'OrderCreateInputValidation' }
      & Pick<OrderCreateInputValidation, 'valid' | 'error'>
    )>, orderPaymentChallenge?: Maybe<(
      { __typename?: 'PaymentTransactionChallenge' }
      & Pick<PaymentTransactionChallenge, 'type' | 'url' | 'returnUrl'>
    )>, orderPaymentRedirect?: Maybe<(
      { __typename?: 'PaymentTransactionRedirect' }
      & Pick<PaymentTransactionRedirect, 'actionToken' | 'redirectCheckoutUrl'>
    )>, orderPaymentCapture?: Maybe<(
      { __typename?: 'PaymentTransactionCapture' }
      & Pick<PaymentTransactionCapture, 'intentId' | 'intentApiKey'>
    )> }
  ) }
);

export type SaveOrderDetailsMutationVariables = Exact<{
  options: CartOptionsInput;
  customer: UpdateCurrentCustomerInput;
}>;


export type SaveOrderDetailsMutation = (
  { __typename?: 'Mutation' }
  & { addOrUpdateOptionsOnCart: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'id'>
  ), updateCurrentCustomer: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type ValidateOrderMutationVariables = Exact<{
  options: CartOptionsInput;
  customer: UpdateCurrentCustomerInput;
  marketing: UpdateMarketingOptInInput;
  doordashInput: ValidateDoordashOrderDeliveryInput;
}>;


export type ValidateOrderMutation = (
  { __typename?: 'Mutation' }
  & { validateDoordashOrderDelivery: (
    { __typename?: 'ValidateDoordashDeliveryResponse' }
    & Pick<ValidateDoordashDeliveryResponse, 'success' | 'error'>
  ), addOrUpdateOptionsOnCart: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'id'>
  ), updateCurrentCustomer: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ), updateMarketingOptIn: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type ExistingMarketingOptInQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  mobile: Scalars['String'];
}>;


export type ExistingMarketingOptInQuery = (
  { __typename?: 'Query' }
  & { existingMarketingOptIn?: Maybe<(
    { __typename?: 'MarketingOptIn' }
    & Pick<MarketingOptIn, 'id'>
  )> }
);

export type VenueOrderingWindowsQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
}>;


export type VenueOrderingWindowsQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'name' | 'slug' | 'timezone' | 'ordering' | 'countryCode'>
    & { logo?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )>, banner?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )>, mobileBanner?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )>, orderingTypes: Array<(
      { __typename?: 'OrderingTypeSetting' }
      & Pick<OrderingTypeSetting, 'id' | 'orderingType' | 'name' | 'tableAreaText' | 'usingTableGroups'>
    )>, location?: Maybe<(
      { __typename?: 'Location' }
      & { id: Location['googlePlaceId'], state: Location['adminArea1'] }
    )> }
  )>, venue?: Maybe<(
    { __typename?: 'Venue' }
    & Pick<Venue, 'id'>
    & { orderingTypeSettingsV2?: Maybe<(
      { __typename?: 'VenueOrderingTypeSetting' }
      & Pick<VenueOrderingTypeSetting, 'id'>
      & { orderingWindow?: Maybe<(
        { __typename?: 'OrderingWindowSettings' }
        & WindowPartsFragment
      )> }
    )> }
  )> }
);

export type GuestOrderByPaymentTxnIdQueryVariables = Exact<{
  paymentTransactionId: Scalars['String'];
}>;


export type GuestOrderByPaymentTxnIdQuery = (
  { __typename?: 'Query' }
  & { guestOrderByPaymentTxnId?: Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, 'id'>
  )> }
);

export type UpdateCustomerDetailsMutationVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  isOver18?: Maybe<Scalars['Boolean']>;
  savePaymentDetails?: Maybe<Scalars['Boolean']>;
  marketingUserOptIn?: Maybe<Scalars['Boolean']>;
  venueSlug?: Maybe<Scalars['String']>;
}>;


export type UpdateCustomerDetailsMutation = (
  { __typename?: 'Mutation' }
  & { updateCustomerDetails?: Maybe<(
    { __typename?: 'User' }
    & UserPartsFragment
  )> }
);

export type AfterpayConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type AfterpayConfigurationQuery = (
  { __typename?: 'Query' }
  & { getAfterpayConfiguration: (
    { __typename?: 'AfterpayConfiguration' }
    & { minimumAmount?: Maybe<(
      { __typename?: 'AfterpayAmount' }
      & Pick<AfterpayAmount, 'amount' | 'currency'>
    )>, maximumAmount?: Maybe<(
      { __typename?: 'AfterpayAmount' }
      & Pick<AfterpayAmount, 'amount' | 'currency'>
    )> }
  ) }
);

export type CurrentUserTabsQueryVariables = Exact<{
  venueSlug?: Maybe<Scalars['String']>;
}>;


export type CurrentUserTabsQuery = (
  { __typename?: 'Query' }
  & { currentUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { tabs?: Maybe<Array<(
      { __typename?: 'SocialTab' }
      & Pick<SocialTab, 'id' | 'tabName'>
    )>>, managedTabs?: Maybe<Array<(
      { __typename?: 'SocialTab' }
      & Pick<SocialTab, 'id' | 'tabName'>
    )>> }
  )> }
);

export type CustomerEonxCardQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type CustomerEonxCardQuery = (
  { __typename?: 'Query' }
  & { eonxCustomerCard: (
    { __typename?: 'EonxPaymentMethod' }
    & EonxCardPartsFragment
  ) }
);

export type CustomerPaystackCardQueryVariables = Exact<{
  currency: Scalars['String'];
  customerId: Scalars['String'];
}>;


export type CustomerPaystackCardQuery = (
  { __typename?: 'Query' }
  & { paystackCard?: Maybe<(
    { __typename?: 'PaystackCard' }
    & PaystackCardPartsFragment
  )> }
);

export type CustomerStripeCardQueryVariables = Exact<{
  currency: Scalars['String'];
  customerId: Scalars['String'];
}>;


export type CustomerStripeCardQuery = (
  { __typename?: 'Query' }
  & { stripeCard?: Maybe<(
    { __typename?: 'StripeCard' }
    & StripeCardPartsFragment
  )> }
);

export type IsSnapscanPaymentSuccessfulQueryVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type IsSnapscanPaymentSuccessfulQuery = (
  { __typename?: 'Query' }
  & { isSnapscanPaymentSuccessful: (
    { __typename?: 'SnapscanSuccessfulPaymentReponse' }
    & Pick<SnapscanSuccessfulPaymentReponse, 'id' | 'success' | 'slug' | 'orderingType' | 'orderId'>
    & { cart?: Maybe<(
      { __typename?: 'Cart' }
      & Pick<Cart, 'id'>
    )> }
  ) }
);

export type PaymentFormQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type PaymentFormQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'name' | 'slug' | 'currency' | 'marketingOptInEnabled' | 'marketingOptInDefault' | 'marketingOptInMessage' | 'ageRestrictionText' | 'tabsEnabled' | 'clubMembershipsEnabled' | 'gratuityEnabled' | 'customGratuityText' | 'multiVendorEnabled'>
    & { paymentProcessor?: Maybe<(
      { __typename?: 'GuestVenuePaymentProcessor' }
      & Pick<GuestVenuePaymentProcessor, 'types' | 'unpaidProcessorTypeLabel'>
    )>, orderingType?: Maybe<(
      { __typename?: 'OrderingTypeSetting' }
      & Pick<OrderingTypeSetting, 'name'>
    )>, orderingTypes: Array<(
      { __typename?: 'OrderingTypeSetting' }
      & Pick<OrderingTypeSetting, 'id' | 'orderingType' | 'emailFieldRequirement' | 'hasTableNumber' | 'optionsText' | 'options' | 'notesText' | 'notesFieldRequirement' | 'postcodes' | 'coverCountFieldRequirement'>
      & { orderingWindow?: Maybe<(
        { __typename?: 'OrderingWindowSettings' }
        & Pick<OrderingWindowSettings, 'id' | 'enabled'>
      )> }
    )>, posIntegration?: Maybe<(
      { __typename?: 'GuestVenuePosIntegration' }
      & Pick<GuestVenuePosIntegration, 'id' | 'type'>
    )> }
  )>, currentUser?: Maybe<(
    { __typename?: 'User' }
    & { tabs?: Maybe<Array<(
      { __typename?: 'SocialTab' }
      & SocialTabPartsFragment
    )>>, managedTabs?: Maybe<Array<(
      { __typename?: 'SocialTab' }
      & SocialTabPartsFragment
    )>> }
    & UserPartsFragment
  )> }
);

export type PaymentIntentMutationVariables = Exact<{
  currency: Scalars['String'];
  amount: Scalars['Int'];
  venueSlug?: Maybe<Scalars['String']>;
  cartId?: Maybe<Scalars['String']>;
  isSocialTabPreAuth?: Maybe<Scalars['Boolean']>;
}>;


export type PaymentIntentMutation = (
  { __typename?: 'Mutation' }
  & { getPaymentIntent?: Maybe<(
    { __typename?: 'StripePaymentIntent' }
    & Pick<StripePaymentIntent, 'paymentIntentId'>
  )> }
);

export type SnapscanPaymentQrUrlQueryVariables = Exact<{
  input: SnapscanPaymentQrUrlInput;
}>;


export type SnapscanPaymentQrUrlQuery = (
  { __typename?: 'Query' }
  & { snapscanPaymentQrUrl: (
    { __typename?: 'SnapscanPaymentQrUrlReponse' }
    & Pick<SnapscanPaymentQrUrlReponse, 'url' | 'cartId'>
  ) }
);

export type StartTabMutationVariables = Exact<{
  customer: UpdateCurrentCustomerInput;
  order: StartTabInput;
}>;


export type StartTabMutation = (
  { __typename?: 'Mutation' }
  & { updateCurrentCustomer: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ), startTab: (
    { __typename?: 'StartTabResponse' }
    & Pick<StartTabResponse, 'customerId' | 'socialTabId'>
    & { validation?: Maybe<(
      { __typename?: 'OrderCreateInputValidation' }
      & Pick<OrderCreateInputValidation, 'valid' | 'error'>
    )>, orderPaymentChallenge?: Maybe<(
      { __typename?: 'PaymentTransactionChallenge' }
      & Pick<PaymentTransactionChallenge, 'type' | 'url' | 'returnUrl'>
    )>, orderPaymentRedirect?: Maybe<(
      { __typename?: 'PaymentTransactionRedirect' }
      & Pick<PaymentTransactionRedirect, 'actionToken' | 'redirectCheckoutUrl'>
    )> }
  ) }
);

export type TouchCartMutationVariables = Exact<{ [key: string]: never; }>;


export type TouchCartMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'touchCart'>
);

export type UpdateBeforeAsyncOrderMutationVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  isOver18?: Maybe<Scalars['Boolean']>;
  savePaymentDetails?: Maybe<Scalars['Boolean']>;
  marketingUserOptIn?: Maybe<Scalars['Boolean']>;
  venueSlug?: Maybe<Scalars['String']>;
  options: CartOptionsInput;
}>;


export type UpdateBeforeAsyncOrderMutation = (
  { __typename?: 'Mutation' }
  & { addOrUpdateOptionsOnCart: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ), updateCustomerDetails?: Maybe<(
    { __typename?: 'User' }
    & UserPartsFragment
  )> }
);

export type ChargeMutationVariables = Exact<{
  input: ChargeInput;
}>;


export type ChargeMutation = (
  { __typename?: 'Mutation' }
  & { charge: (
    { __typename?: 'ChargeActionRequired' }
    & Pick<ChargeActionRequired, 'nextAction' | 'paymentIntentId' | 'processorReference' | 'verificationUrl'>
  ) }
);

export type CreatePaymentIntentMutationVariables = Exact<{
  input: CreatePaymentIntentInput;
}>;


export type CreatePaymentIntentMutation = (
  { __typename?: 'Mutation' }
  & { createPaymentIntent: (
    { __typename?: 'CreatePaymentIntentResponse' }
    & Pick<CreatePaymentIntentResponse, 'paymentIntentId' | 'processorReference'>
  ) }
);

export type CreatePaymentMethodMutationVariables = Exact<{
  input: CreatePaymentMethodInput;
}>;


export type CreatePaymentMethodMutation = (
  { __typename?: 'Mutation' }
  & { createPaymentMethod: (
    { __typename?: 'UserActionRequired' }
    & Pick<UserActionRequired, 'nextAction' | 'verificationUrl'>
  ) }
);

export type FindPaymentQueryVariables = Exact<{
  paymentTargetId: Scalars['String'];
}>;


export type FindPaymentQuery = (
  { __typename?: 'Query' }
  & { findPaymentByTargetId?: Maybe<(
    { __typename?: 'PaymentResponse' }
    & Pick<PaymentResponse, 'id' | 'paymentTargetId' | 'processorTransactionId'>
  )> }
);

export type GetPaymentQueryVariables = Exact<{
  paymentId: Scalars['String'];
}>;


export type GetPaymentQuery = (
  { __typename?: 'Query' }
  & { getPayment?: Maybe<(
    { __typename?: 'PaymentResponse' }
    & Pick<PaymentResponse, 'id' | 'paymentTargetId' | 'paymentStatus' | 'amount'>
  )> }
);

export type GetPaymentsQueryVariables = Exact<{
  paymentTargetId: Scalars['String'];
}>;


export type GetPaymentsQuery = (
  { __typename?: 'Query' }
  & { getPayments?: Maybe<Array<(
    { __typename?: 'PaymentResponse' }
    & Pick<PaymentResponse, 'id' | 'paymentTargetId' | 'paymentStatus'>
  )>> }
);

export type ListPaymentMethodsQueryVariables = Exact<{
  currency: Scalars['String'];
}>;


export type ListPaymentMethodsQuery = (
  { __typename?: 'Query' }
  & { listPaymentMethods?: Maybe<Array<(
    { __typename?: 'PaymentMethod' }
    & Pick<PaymentMethod, 'id' | 'brand' | 'last4' | 'expiryMonth' | 'expiryYear' | 'createdAt'>
  )>> }
);

export type PaymentV2MetaQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: Scalars['String'];
}>;


export type PaymentV2MetaQuery = (
  { __typename?: 'Query' }
  & { listPaymentProcessors?: Maybe<Array<(
    { __typename?: 'SupportedPaymentProcessor' }
    & Pick<SupportedPaymentProcessor, 'name'>
  )>> }
);

export type VerifyChargeQueryVariables = Exact<{
  currency: Scalars['String'];
  verificationId: Scalars['String'];
}>;


export type VerifyChargeQuery = (
  { __typename?: 'Query' }
  & { verifyCharge?: Maybe<(
    { __typename?: 'VerifyCharge' }
    & Pick<VerifyCharge, 'verificationResult'>
  )> }
);

export type VerifyPaymentMethodQueryVariables = Exact<{
  currency: Scalars['String'];
  verificationId: Scalars['String'];
}>;


export type VerifyPaymentMethodQuery = (
  { __typename?: 'Query' }
  & { verifyPaymentMethod?: Maybe<(
    { __typename?: 'VerifyPaymentMethod' }
    & Pick<VerifyPaymentMethod, 'verificationId' | 'verificationResult'>
  )> }
);

export type PopupNotificationModalQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type PopupNotificationModalQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'popupNotificationText'>
    & { popupNotificationImage?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )> }
  )> }
);

export type ComputePointsToUseQueryVariables = Exact<{
  rewardId: Scalars['String'];
}>;


export type ComputePointsToUseQuery = (
  { __typename?: 'Query' }
  & { computePointsToUse?: Maybe<(
    { __typename?: 'ComputePointsToUsePayload' }
    & Pick<ComputePointsToUsePayload, 'id' | 'pointsToRedeem' | 'amountInCents'>
  )> }
);

export type RedeemPointsMutationVariables = Exact<{
  input: CartLoyaltyDiscountApplyInput;
}>;


export type RedeemPointsMutation = (
  { __typename?: 'Mutation' }
  & { applyCartLoyaltyDiscount: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type ReorderMutationVariables = Exact<{
  venueSlug: Scalars['String'];
  orderId: Scalars['String'];
}>;


export type ReorderMutation = (
  { __typename?: 'Mutation' }
  & { reorder: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'id' | 'orderingType' | 'tableNumber' | 'tableArea'>
    & { total: (
      { __typename?: 'CartTotal' }
      & Pick<CartTotal, 'totalInCents'>
    ), cartItems: Array<(
      { __typename?: 'CartItem' }
      & CartItemPartsFragment
    )> }
  ) }
);

export type FetchAuraMembershipQueryVariables = Exact<{
  code: Scalars['String'];
  venueId: Scalars['String'];
}>;


export type FetchAuraMembershipQuery = (
  { __typename?: 'Query' }
  & { fetchAuraMembership: (
    { __typename?: 'AuraMembershipPayload' }
    & Pick<AuraMembershipPayload, 'id'>
  ) }
);

export type FetchAuraOAuthConfigQueryVariables = Exact<{
  venueId: Scalars['String'];
}>;


export type FetchAuraOAuthConfigQuery = (
  { __typename?: 'Query' }
  & { fetchAuraOAuthConfig: (
    { __typename?: 'RewardAuraOAuthPayload' }
    & Pick<RewardAuraOAuthPayload, 'programName' | 'url'>
  ) }
);

export type LoyaltyDetailsQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  externalMemberId?: Maybe<Scalars['String']>;
}>;


export type LoyaltyDetailsQuery = (
  { __typename?: 'Query' }
  & { loyaltyDetails?: Maybe<(
    { __typename?: 'LoyaltyDetailsPayload' }
    & Pick<LoyaltyDetailsPayload, 'id'>
    & { lastOrder?: Maybe<(
      { __typename?: 'LoyaltyLastOrderPayload' }
      & Pick<LoyaltyLastOrderPayload, 'id' | 'points'>
    )>, features: (
      { __typename?: 'LoyaltyFeaturesPayload' }
      & Pick<LoyaltyFeaturesPayload, 'id' | 'canSpendPoints' | 'canEarnPoints' | 'canSignUp' | 'canShowPointBalance' | 'canOptIn'>
    ), guestData?: Maybe<(
      { __typename?: 'LoyaltyGuestDataPayload' }
      & Pick<LoyaltyGuestDataPayload, 'id' | 'points' | 'isOptedIn'>
    )>, rewards?: Maybe<Array<(
      { __typename?: 'LoyaltyRewardPayload' }
      & Pick<LoyaltyRewardPayload, 'id' | 'rewardId' | 'name'>
    )>>, metadata?: Maybe<(
      { __typename?: 'LoyaltyMetadataPayload' }
      & Pick<LoyaltyMetadataPayload, 'id' | 'introBody' | 'pointName' | 'programName' | 'minimumPointsRequired' | 'infoLink'>
    )> }
  )> }
);

export type LoyaltyPointsQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  externalMemberId?: Maybe<Scalars['String']>;
}>;


export type LoyaltyPointsQuery = (
  { __typename?: 'Query' }
  & { loyaltyDetails?: Maybe<(
    { __typename?: 'LoyaltyDetailsPayload' }
    & Pick<LoyaltyDetailsPayload, 'id'>
    & { features: (
      { __typename?: 'LoyaltyFeaturesPayload' }
      & Pick<LoyaltyFeaturesPayload, 'id' | 'canShowPointBalance'>
    ), guestData?: Maybe<(
      { __typename?: 'LoyaltyGuestDataPayload' }
      & Pick<LoyaltyGuestDataPayload, 'id' | 'points' | 'isOptedIn'>
    )>, metadata?: Maybe<(
      { __typename?: 'LoyaltyMetadataPayload' }
      & Pick<LoyaltyMetadataPayload, 'id' | 'pointName'>
    )>, vouchers?: Maybe<Array<(
      { __typename?: 'GuestVoucher' }
      & Pick<GuestVoucher, 'id' | 'name' | 'description' | 'barcode' | 'imgSrc'>
    )>> }
  )> }
);

export type OptInToLoyaltyMutationVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type OptInToLoyaltyMutation = (
  { __typename?: 'Mutation' }
  & { optInToLoyalty: (
    { __typename?: 'OptInToLoyaltyPayload' }
    & Pick<OptInToLoyaltyPayload, 'success'>
  ) }
);

export type RewardMenuItemsQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  categorySlug?: Maybe<Scalars['String']>;
  orderingType?: Maybe<OrderingType>;
}>;


export type RewardMenuItemsQuery = (
  { __typename?: 'Query' }
  & { guestMenuCategory: (
    { __typename?: 'GuestMenuCategory' }
    & Pick<GuestMenuCategory, 'id'>
    & { menuSections: Array<(
      { __typename?: 'GuestMenuSection' }
      & Pick<GuestMenuSection, 'id'>
      & { menuItems: Array<(
        { __typename?: 'GuestMenuItem' }
        & Pick<GuestMenuItem, 'id' | 'name' | 'description'>
        & { image?: Maybe<(
          { __typename?: 'GuestImage' }
          & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
        )>, priceData: (
          { __typename?: 'GuestPriceData' }
          & Pick<GuestPriceData, 'displayPrice' | 'priceInCents'>
        ), rewardPrice?: Maybe<(
          { __typename?: 'GuestRewardPrice' }
          & Pick<GuestRewardPrice, 'originalAmountInCents' | 'originalDisplayAmount'>
        )> }
      )> }
    )> }
  ) }
);

export type CloseSocialTabMutationVariables = Exact<{
  tabId: Scalars['String'];
}>;


export type CloseSocialTabMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'closeTab'>
);

export type ConfirmMemberMutationVariables = Exact<{
  tabId: Scalars['String'];
}>;


export type ConfirmMemberMutation = (
  { __typename?: 'Mutation' }
  & { confirmMember: (
    { __typename?: 'ConfirmSocialTabMemberResponse' }
    & Pick<ConfirmSocialTabMemberResponse, 'success' | 'validation'>
  ) }
);

export type SetSocialTabLimitMutationVariables = Exact<{
  tabId: Scalars['String'];
  maxSpendInCents: Scalars['Float'];
}>;


export type SetSocialTabLimitMutation = (
  { __typename?: 'Mutation' }
  & { setSocialTabLimit: (
    { __typename?: 'SocialTab' }
    & Pick<SocialTab, 'id'>
  ) }
);

export type TabGuestConfirmationQueryVariables = Exact<{
  tabId: Scalars['String'];
}>;


export type TabGuestConfirmationQuery = (
  { __typename?: 'Query' }
  & { getTabGuestConfirmation: (
    { __typename?: 'RunningSocialTabGuestConfirmation' }
    & Pick<RunningSocialTabGuestConfirmation, 'id' | 'tabName' | 'orderingType' | 'validation'>
  ) }
);

export type TabMetaQueryVariables = Exact<{
  tabId: Scalars['String'];
}>;


export type TabMetaQuery = (
  { __typename?: 'Query' }
  & { getTabMeta: (
    { __typename?: 'SocialTabMeta' }
    & Pick<SocialTabMeta, 'id' | 'tabName'>
  ) }
);

export type TabOrdersQueryVariables = Exact<{
  tabId: Scalars['String'];
  skip: Scalars['Float'];
  limit: Scalars['Float'];
}>;


export type TabOrdersQuery = (
  { __typename?: 'Query' }
  & { getTabOrders: (
    { __typename?: 'PaginatedSocialTabOrderResponse' }
    & Pick<PaginatedSocialTabOrderResponse, 'total' | 'skip' | 'limit'>
    & { items: Array<(
      { __typename?: 'SocialTabOrder' }
      & Pick<SocialTabOrder, 'id' | 'name' | 'date' | 'totalInCents'>
    )> }
  ) }
);

export type TabQueryVariables = Exact<{
  tabId: Scalars['String'];
}>;


export type TabQuery = (
  { __typename?: 'Query' }
  & { getTab: (
    { __typename?: 'RunningSocialTab' }
    & Pick<RunningSocialTab, 'id' | 'tabName' | 'status' | 'startTime' | 'tabSpendInCents' | 'orderingType' | 'validation' | 'maxSpendInCents'>
    & { venue?: Maybe<(
      { __typename?: 'Venue' }
      & Pick<Venue, 'id' | 'name' | 'currency'>
    )> }
  ) }
);

export type AuthenticateSwiftPosMemberMutationVariables = Exact<{
  venueSlug: Scalars['String'];
  code: Scalars['String'];
}>;


export type AuthenticateSwiftPosMemberMutation = (
  { __typename?: 'Mutation' }
  & { authenticateSwiftPosMember?: Maybe<(
    { __typename?: 'MslTokenPayload' }
    & Pick<MslTokenPayload, 'token'>
  )> }
);

export type MslAuthSettingsQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type MslAuthSettingsQuery = (
  { __typename?: 'Query' }
  & { getMSLAuthSettings?: Maybe<(
    { __typename?: 'MSLAuthSettings' }
    & Pick<MslAuthSettings, 'id' | 'membershipAuthUrl'>
  )> }
);

export type SwiftPosMemberLoggedInCheckQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type SwiftPosMemberLoggedInCheckQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'swiftPosMemberLoggedInCheckV2'>
);

export type SwiftposMemberPriceLevelQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type SwiftposMemberPriceLevelQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'swiftposMemberPriceLevel'>
);

export type VenueTableNumberQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
}>;


export type VenueTableNumberQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'skipTableNumberModal' | 'ordering' | 'isOrderingAvailable'>
    & { orderingType?: Maybe<(
      { __typename?: 'OrderingTypeSetting' }
      & Pick<OrderingTypeSetting, 'id' | 'orderingType' | 'isAvailable' | 'tablePromptText' | 'tableText' | 'tableAreaText' | 'tableNumberValidation' | 'minTableNumber' | 'maxTableNumber' | 'hasTableNumber' | 'tableAreas' | 'usingTableGroups'>
      & { orderingWindow?: Maybe<(
        { __typename?: 'OrderingWindowSettings' }
        & Pick<OrderingWindowSettings, 'id' | 'enabled'>
      )> }
    )> }
  )> }
);

export type LoginAsTestGuestMutationVariables = Exact<{
  fresh: Scalars['Boolean'];
}>;


export type LoginAsTestGuestMutation = (
  { __typename?: 'Mutation' }
  & { loginAsTestGuest: (
    { __typename?: 'LoginAsTestGuestPayload' }
    & Pick<LoginAsTestGuestPayload, 'id' | 'mobile'>
  ) }
);

export type ApplyCartTipMutationVariables = Exact<{
  input: CartTipApplyInput;
}>;


export type ApplyCartTipMutation = (
  { __typename?: 'Mutation' }
  & { applyCartTip: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type InitialVenueQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type InitialVenueQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'availableOrderingType' | 'brandingAccent' | 'brandingAccentText' | 'brandingEnabled' | 'brandingPrimary' | 'brandingPrimaryText' | 'facebookPixelId' | 'googleTagManagerId' | 'organizationId' | 'showOrderingTypePicker' | 'currency'>
  )> }
);

export type VenueFacebookPixelIdQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueFacebookPixelIdQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'facebookPixelId'>
  )> }
);

export type VenueGoogleTagManagerIdQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueGoogleTagManagerIdQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'googleTagManagerId'>
  )> }
);

export type VenueInfoForTrackingQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueInfoForTrackingQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'organizationId'>
  )> }
);

export type MvoSearchQueryVariables = Exact<{
  searchQuery: Scalars['String'];
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  orderingType: OrderingType;
  venueSlug: Scalars['String'];
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
}>;


export type MvoSearchQuery = (
  { __typename?: 'Query' }
  & { mvoItemSearch: Array<(
    { __typename?: 'MvoSearchResult' }
    & Pick<MvoSearchResult, 'categoryId' | 'categoryName' | 'categorySlug' | 'isClosed' | 'menuCategoryType' | 'mvoFeatured' | 'orderingType' | 'position'>
    & { extendedWaitTime?: Maybe<(
      { __typename?: 'GuestWaitTime' }
      & Pick<GuestWaitTime, 'id' | 'estimate' | 'estimateInMilliseconds' | 'expiry' | 'expiryEndTime'>
    )>, image?: Maybe<(
      { __typename?: 'GuestImage' }
      & Pick<GuestImage, 'id' | 'originalImagePath' | 'originalImageUrl'>
    )>, menuItems: Array<(
      { __typename?: 'GuestMenuItem' }
      & MvoSearchResultMenuItemFragment
    )> }
  )>, mvoVendorSearch: Array<(
    { __typename?: 'GuestMenuCategory' }
    & VenueLandingMenuCategoryFragment
  )> }
);

export type RefreshSessionMutationVariables = Exact<{
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['String']>;
  orderingType?: Maybe<OrderingType>;
}>;


export type RefreshSessionMutation = (
  { __typename?: 'Mutation' }
  & { refreshSession: (
    { __typename?: 'RefreshSessionPayload' }
    & Pick<RefreshSessionPayload, 'createdAt'>
  ) }
);

export type StartWithDrinksQueryVariables = Exact<{
  orderingWindowStartDate?: Maybe<Scalars['String']>;
  orderingType: OrderingType;
  venueSlug: Scalars['String'];
  tableNumber?: Maybe<Scalars['String']>;
  tableArea?: Maybe<Scalars['String']>;
}>;


export type StartWithDrinksQuery = (
  { __typename?: 'Query' }
  & { startWithDrinks: Array<(
    { __typename?: 'GuestMenuItem' }
    & MenuItemWithMenuCategoryFragment
  )> }
);

export type VenueBookingQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueBookingQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'bookingLink'>
  )> }
);

export type VenueIndexQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueIndexQuery = (
  { __typename?: 'Query' }
  & { venueIndex?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'availableOrderingType' | 'showOrderingTypePicker'>
  )> }
);

export type VenueLandingAdditionalQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  externalMemberId?: Maybe<Scalars['String']>;
}>;


export type VenueLandingAdditionalQuery = (
  { __typename?: 'Query' }
  & { currentUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { managedTabs?: Maybe<Array<(
      { __typename?: 'SocialTab' }
      & Pick<SocialTab, 'id'>
    )>> }
  )>, lastOrderByUserByVenueSlug?: Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'orderingType'>
    & { lineItems: Array<(
      { __typename?: 'LineItem' }
      & Pick<LineItem, 'type' | 'category'>
    )> }
  )>, loyaltyDetails?: Maybe<(
    { __typename?: 'LoyaltyDetailsPayload' }
    & Pick<LoyaltyDetailsPayload, 'id'>
    & { metadata?: Maybe<(
      { __typename?: 'LoyaltyMetadataPayload' }
      & Pick<LoyaltyMetadataPayload, 'id' | 'memberName' | 'infoLink'>
    )> }
  )> }
);

export type VenueLandingQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueLandingQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & VenueLandingFragment
  )> }
);

export type VenueMenuCategoryQueryVariables = Exact<{
  venueSlug: Scalars['String'];
  orderingType: OrderingType;
  tableArea?: Maybe<Scalars['String']>;
  tableNumber?: Maybe<Scalars['String']>;
  orderingWindowStartDate?: Maybe<Scalars['String']>;
}>;


export type VenueMenuCategoryQuery = (
  { __typename?: 'Query' }
  & { guestMenuCategories: Array<(
    { __typename?: 'GuestMenuCategory' }
    & VenueLandingMenuCategoryFragment
  )> }
);

export type VenueBrandingColorsQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueBrandingColorsQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'brandingEnabled' | 'brandingPrimary' | 'brandingPrimaryText' | 'brandingAccent' | 'brandingAccentText'>
  )> }
);

export type AddOrUpdateLocationOnCartMutationVariables = Exact<{
  input: CartLocationInput;
}>;


export type AddOrUpdateLocationOnCartMutation = (
  { __typename?: 'Mutation' }
  & { addOrUpdateLocationOnCart: (
    { __typename?: 'Cart' }
    & CartPartsFragment
  ) }
);

export type VenueAddressValidationQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueAddressValidationQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'countryCode'>
    & { location?: Maybe<(
      { __typename?: 'Location' }
      & Pick<Location, 'latitude' | 'longitude'>
      & { id: Location['googlePlaceId'] }
    )>, orderingTypes: Array<(
      { __typename?: 'OrderingTypeSetting' }
      & Pick<OrderingTypeSetting, 'id' | 'orderingType' | 'postcodes'>
    )> }
  )> }
);

export type VenueCurrencyQueryVariables = Exact<{
  venueSlug: Scalars['String'];
}>;


export type VenueCurrencyQuery = (
  { __typename?: 'Query' }
  & { guestVenue?: Maybe<(
    { __typename?: 'GuestVenue' }
    & Pick<GuestVenue, 'id' | 'currency'>
  )> }
);

export const TimeSlotPartsFragmentDoc = gql`
    fragment TimeSlotParts on TimeSlot {
  startTime
  endTime
}
    `;
export const TimeBlocksPartsFragmentDoc = gql`
    fragment TimeBlocksParts on TimeBlocks {
  id
  name
  sun {
    ...TimeSlotParts
  }
  mon {
    ...TimeSlotParts
  }
  tue {
    ...TimeSlotParts
  }
  wed {
    ...TimeSlotParts
  }
  thu {
    ...TimeSlotParts
  }
  fri {
    ...TimeSlotParts
  }
  sat {
    ...TimeSlotParts
  }
}
    ${TimeSlotPartsFragmentDoc}`;
export const VenueForMenuCategoryFragmentDoc = gql`
    fragment VenueForMenuCategory on GuestVenue {
  id
  venueId: id
  countryCode
  name
  slug
  ordering
  isClosed
  isLive
  facebookPixelId
  popupNotificationText
  isOrderingAvailable
  isBarBusy
  isKitchenBusy
  hours {
    ...TimeBlocksParts
  }
  location {
    id: googlePlaceId
    formattedAddress
    state: adminArea1
    locality
    adminArea2
    adminArea1
  }
  orderingTypes {
    id
    orderingType
    enabled
    landingText
    isAvailable
    usingTableGroups
    orderingWindow {
      id
      enabled
    }
  }
}
    ${TimeBlocksPartsFragmentDoc}`;
export const VenueInvoicePartsFragmentDoc = gql`
    fragment VenueInvoiceParts on Venue {
  id
  slug
  name
  timezone
  supportEmail
  supportPhone
  currency
  taxRate
  gstRegistrationNumber
  location {
    id: googlePlaceId
    formattedAddress
  }
  additionalInvoiceInformation
}
    `;
export const UserInvoicePartsFragmentDoc = gql`
    fragment UserInvoiceParts on User {
  id
  name
  email
  mobile
}
    `;
export const LineItemPartsFragmentDoc = gql`
    fragment LineItemParts on LineItem {
  id
  parentId
  name
  quantity
  originalPriceInCents
  priceInCents
  kind
  type
}
    `;
export const BasicInvoicePartsFragmentDoc = gql`
    fragment BasicInvoiceParts on Order {
  id
  createdAt
  orderingType
  deliveryOption
  pickupOption
  orderingWindowStartDate
  isTaxInclusive
  totalTaxInCents
  totalInCents
  batchPosDisplayIds
  location {
    id: googlePlaceId
    formattedAddress
    unitNumber
  }
  orderNotes
  venue {
    ...VenueInvoiceParts
  }
  user {
    ...UserInvoiceParts
  }
  lineItems {
    ...LineItemParts
  }
  paymentProcessor
}
    ${VenueInvoicePartsFragmentDoc}
${UserInvoicePartsFragmentDoc}
${LineItemPartsFragmentDoc}`;
export const CurrentLocationPartsFragmentDoc = gql`
    fragment CurrentLocationParts on Location {
  id
  googlePlaceId
  unitNumber
  formattedAddress
  latitude
  longitude
  postalCode
}
    `;
export const CartItemPartsFragmentDoc = gql`
    fragment CartItemParts on CartItem {
  id
  totalInCents
  name
  type
  quantity
  isFree
  item {
    id
    slug
    name
    price
    minQuantity
    maxQuantity
    isPopular
    description
    dietaryTags
    filterTags
    priceData {
      displayPrice
      hasPriceOverride
    }
    cdnImage {
      defaultImage
      srcSet
      id
      originalImagePath
      originalImageUrl
    }
  }
  cartModifiers {
    id
    name
    quantity
  }
  cartUpsells {
    id
    name
    quantity
  }
}
    `;
export const CartPartsFragmentDoc = gql`
    fragment CartParts on Cart {
  id
  cartValidationErrors
  cartValidationErrorsV2 {
    type
    message
  }
  currency
  tableNumber
  tableArea
  coverCount
  orderingWindowStartDate
  orderingWindowEndDate
  orderingWindowEnabled
  notes
  deliveryOption
  pickupOption
  orderingType
  currentLocation {
    ...CurrentLocationParts
  }
  total {
    isTaxInclusive
    totalInCents
    totalTaxInCents
    taxName
    subTotalInCents
    cartDiscounts {
      discountInCents
      discountName
      discountRate
      itemId
      quantity
      externalVoucherType
      discountType
      isRemovable
      code
      chargeType
    }
    cartServiceCharge {
      chargeInCents
      chargeName
      isRemovable
    }
    cardSurchargeInCents
    deliveryFeeInCents
    gratuityInCents
    minDeliveryThresholdNotReached
    minDeliveryOrderValueInCents
    minOrderValueForFreeDeliveryInCents
    cardSurchargeName
    minFreeDeliveryThresholdNotReached
  }
  skipCardSurcharge
  itemValidation {
    canDecrement
    canIncrement
    id
    itemsDeleted {
      id
      name
      quantity
    }
  }
  cartItems {
    ...CartItemParts
  }
}
    ${CurrentLocationPartsFragmentDoc}
${CartItemPartsFragmentDoc}`;
export const DirectoryVenuePartsFragmentDoc = gql`
    fragment DirectoryVenueParts on VenueCollectionToVenue {
  id
  name
  enabled
  venue {
    id
    slug
    orderingType
    name
    isClosed
    ogImage(transform: "og") {
      id
      srcSet
      defaultImage
    }
    image: ogImage {
      id
      originalImageUrl
    }
  }
}
    `;
export const EonxCardPartsFragmentDoc = gql`
    fragment EonxCardParts on EonxPaymentMethod {
  brand
  last4
  expiry
}
    `;
export const GuestInfoPartsFragmentDoc = gql`
    fragment GuestInfoParts on RegistryGuest {
  id
  name
  email
  mobile
  addressOrEmail
  postcode
  tableNumber
  temperature
  idNumber
  ageRequirement
  correctDeclaration
  symptomsConfirmation
  marketingOptInEnabled
  createdAt
}
    `;
export const GuestVenueConfirmationPartsFragmentDoc = gql`
    fragment GuestVenueConfirmationParts on GuestVenue {
  id
  name
  slug
  currency
  surveyLink
  yumpingoVenueId
  availableOrderingType
  banner {
    id
    originalImagePath
    originalImageUrl
  }
  mobileBanner {
    id
    originalImagePath
    originalImageUrl
  }
  location {
    id
    unitNumber
    formattedAddress
  }
  orderingType(orderingType: $orderingType) {
    tableShortText
  }
  tipjarUrl
}
    `;
export const MenuCategoryPartsFragmentDoc = gql`
    fragment MenuCategoryParts on GuestMenuCategory {
  id
  slug
  name
  isClosed
  menuCategoryType
  orderingType
  image {
    id
    originalImagePath
    originalImageUrl
  }
  isClosed
  position
  mvoFeatured
}
    `;
export const MenuItemDetailsFragmentDoc = gql`
    fragment MenuItemDetails on GuestMenuItem {
  id
  slug
  type
  name
  namefr
  nameel
  namees
  nameit
  namede
  namezhCN
  namede
  isPopular
  image {
    id
    originalImagePath
    originalImageUrl
  }
  description
  descriptionPlain
  descriptionfr
  descriptionel
  descriptiones
  descriptionit
  descriptionzhCN
  descriptionde
  dietaryTags
  filterTags
  allergens
  minQuantity
  maxQuantity
  inventoryEnabled
  inventoryCount
  priceData {
    displayPrice
    priceInCents
    originalDisplayPrice
    hasPriceOverride
    isMembershipPricing
  }
  rewardPrice {
    originalAmountInCents
    originalDisplayAmount
  }
  priceLevels {
    priceInCents
    level
  }
  extendedWaitTime {
    id
    estimate
    estimateInMilliseconds
    expiry
    expiryEndTime
  }
}
    `;
export const MenuItemWithMenuCategoryFragmentDoc = gql`
    fragment MenuItemWithMenuCategory on GuestMenuItem {
  id
  slug
  type
  name
  category
  image {
    id
    originalImagePath
    originalImageUrl
  }
  priceData {
    displayPrice
    priceInCents
    originalDisplayPrice
    hasPriceOverride
    isMembershipPricing
  }
  rewardPrice {
    originalAmountInCents
    originalDisplayAmount
  }
  isAvailable(orderingWindowStartDate: $orderingWindowStartDate)
  menuCategories(
    input: {orderingWindowStartDate: $orderingWindowStartDate, orderingType: $orderingType, tableNumber: $tableNumber, tableArea: $tableArea}
  ) {
    slug
  }
}
    `;
export const MultiVendorInvoicePartsFragmentDoc = gql`
    fragment MultiVendorInvoiceParts on MultiVendorOrder {
  id
  createdAt
  totalInCents
  venue {
    ...VenueInvoiceParts
  }
}
    ${VenueInvoicePartsFragmentDoc}`;
export const MvoSearchResultMenuItemFragmentDoc = gql`
    fragment MvoSearchResultMenuItem on GuestMenuItem {
  id
  slug
  name
  type
  isLive
  isPopular
  inventoryEnabled
  image {
    id
    originalImagePath
    originalImageUrl
  }
  priceData {
    displayPrice
    priceInCents
    originalDisplayPrice
    hasPriceOverride
    isMembershipPricing
  }
  rewardPrice {
    originalAmountInCents
    originalDisplayAmount
  }
  isAvailable(orderingWindowStartDate: $orderingWindowStartDate)
}
    `;
export const OrderConfirmationPartsFragmentDoc = gql`
    fragment OrderConfirmationParts on Order {
  id
  orderingType
  createdAt
  totalInCents
  paymentProcessor
  orderingWindowStartDate
  orderingWindowEndDate
  socialTabId
  tableArea
  tableNumber
  location {
    id
    unitNumber
    formattedAddress
  }
}
    `;
export const OrderHistoryPartsFragmentDoc = gql`
    fragment OrderHistoryParts on OrderHistory {
  id
  totalInCents
  createdAt
  type
  receiptId
  info
}
    `;
export const PaystackCardPartsFragmentDoc = gql`
    fragment PaystackCardParts on PaystackCard {
  brand
  last4
  expiry
  paymentMethodId
}
    `;
export const SocialTabPartsFragmentDoc = gql`
    fragment SocialTabParts on SocialTab {
  id
  tabName
}
    `;
export const StripeCardPartsFragmentDoc = gql`
    fragment StripeCardParts on StripeCard {
  brand
  last4
  expiry
  paymentMethodId
}
    `;
export const UserPartsFragmentDoc = gql`
    fragment UserParts on User {
  id
  name
  email
  receiptEmail
  customerId
  isOver18
  mobile
  savePaymentDetails
}
    `;
export const VenueLandingFragmentDoc = gql`
    fragment VenueLanding on GuestVenue {
  id
  venueId: id
  countryCode
  name
  slug
  ordering
  isClosed
  isLive
  facebookPixelId
  popupNotificationText
  isOrderingAvailable
  isBarBusy
  isKitchenBusy
  countryCode
  timezone
  tabsEnabled
  landingCallToActionText
  landingCallToActionUrl
  isClosed
  isLive
  isOrderingAvailable
  alwaysShowVisualMenu
  skipTableNumberModal
  showOrderingTypePicker
  showCategoryListViewOnLandingPage
  orderingTypes {
    id
    name
    landingText
    orderingType
    isAvailable
    tablePromptText
    tableShortText
    usingTableGroups
    orderingWindow {
      id
      enabled
    }
  }
  hours {
    ...TimeBlocksParts
  }
  location {
    id: googlePlaceId
    formattedAddress
    state: adminArea1
    locality
    adminArea2
    adminArea1
  }
  logo {
    id
    originalImagePath
    originalImageUrl
  }
  banner {
    id
    originalImagePath
    originalImageUrl
  }
  mobileBanner {
    id
    originalImagePath
    originalImageUrl
  }
  startTabAvailable
  multiVendorEnabled
  posIntegration {
    id
    type
  }
}
    ${TimeBlocksPartsFragmentDoc}`;
export const VenueLandingMenuCategoryFragmentDoc = gql`
    fragment VenueLandingMenuCategory on GuestMenuCategory {
  id
  name
  slug
  menuCategoryType
  orderingType
  isClosed(
    tableArea: $tableArea
    tableNumber: $tableNumber
    orderingType: $orderingType
    orderingWindowStartDate: $orderingWindowStartDate
  )
  image {
    id
    originalImageUrl
    originalImagePath
  }
  position
  mvoFeatured
  extendedWaitTime {
    id
    estimate
    estimateInMilliseconds
    expiry
    expiryEndTime
  }
}
    `;
export const WindowPartsFragmentDoc = gql`
    fragment WindowParts on OrderingWindowSettings {
  id
  enabled
  futureDays
  asapWindowEnabled
  availableOrderingWindows {
    id
    startTime
    endTime
    orderingWindowStartDate
    unlimitedOrders
    windows
    isPast
  }
}
    `;
export const AddOrUpdateNotesOnCartDocument = gql`
    mutation addOrUpdateNotesOnCart($input: CartNotesInput!) {
  addOrUpdateNotesOnCart(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useAddOrUpdateNotesOnCartMutation() {
  return Urql.useMutation<AddOrUpdateNotesOnCartMutation, AddOrUpdateNotesOnCartMutationVariables>(AddOrUpdateNotesOnCartDocument);
};
export const AddOrUpdateOptionsOnCartDocument = gql`
    mutation addOrUpdateOptionsOnCart($input: CartOptionsInput!) {
  addOrUpdateOptionsOnCart(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useAddOrUpdateOptionsOnCartMutation() {
  return Urql.useMutation<AddOrUpdateOptionsOnCartMutation, AddOrUpdateOptionsOnCartMutationVariables>(AddOrUpdateOptionsOnCartDocument);
};
export const AddOrUpdateWindowOnCartDocument = gql`
    mutation addOrUpdateWindowOnCart($input: CartOrderingWindowInput!) {
  addOrUpdateWindowOnCart(input: $input) {
    id
    orderingWindowStartDate
    orderingWindowEndDate
  }
}
    `;

export function useAddOrUpdateWindowOnCartMutation() {
  return Urql.useMutation<AddOrUpdateWindowOnCartMutation, AddOrUpdateWindowOnCartMutationVariables>(AddOrUpdateWindowOnCartDocument);
};
export const AddToCartDocument = gql`
    mutation addToCart($input: CartItemInput!) {
  addToCart(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useAddToCartMutation() {
  return Urql.useMutation<AddToCartMutation, AddToCartMutationVariables>(AddToCartDocument);
};
export const ApplyCartClubMembershipSurcountDocument = gql`
    mutation applyCartClubMembershipSurcount($input: CartClubMembershipSurcountApplyInput!) {
  applyCartClubMembershipSurcount(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useApplyCartClubMembershipSurcountMutation() {
  return Urql.useMutation<ApplyCartClubMembershipSurcountMutation, ApplyCartClubMembershipSurcountMutationVariables>(ApplyCartClubMembershipSurcountDocument);
};
export const ApplyCartDiscountDocument = gql`
    mutation applyCartDiscount($input: CartDiscountApplyInput!) {
  applyCartDiscount(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useApplyCartDiscountMutation() {
  return Urql.useMutation<ApplyCartDiscountMutation, ApplyCartDiscountMutationVariables>(ApplyCartDiscountDocument);
};
export const CartLandingDocument = gql`
    query cartLanding($venueSlug: String!, $orderingType: OrderingType!, $revalidate: Boolean, $checkMembership: Boolean, $tableNumber: String, $tableArea: String, $googlePlaceId: String) {
  getCart(
    slug: $venueSlug
    orderingType: $orderingType
    revalidate: $revalidate
    checkMembership: $checkMembership
    tableNumber: $tableNumber
    tableArea: $tableArea
    googlePlaceId: $googlePlaceId
  ) {
    id
    cartValidationErrors
    cartValidationErrorsV2 {
      type
      message
    }
    tableNumber
    tableArea
    orderingWindowStartDate
    orderingWindowEndDate
    orderingType
    currentLocation {
      ...CurrentLocationParts
    }
    total {
      minDeliveryThresholdNotReached
      minFreeDeliveryThresholdNotReached
    }
    cartItems {
      id
      quantity
      cartUpsells {
        id
        quantity
      }
    }
  }
}
    ${CurrentLocationPartsFragmentDoc}`;

export function useCartLandingQuery(options: Omit<Urql.UseQueryArgs<CartLandingQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CartLandingQuery>({ query: CartLandingDocument, ...options });
};
export const CartMenuItemDocument = gql`
    query cartMenuItem($venueSlug: String!, $orderingType: OrderingType!, $revalidate: Boolean, $checkMembership: Boolean, $tableNumber: String, $tableArea: String, $googlePlaceId: String) {
  getCart(
    slug: $venueSlug
    orderingType: $orderingType
    revalidate: $revalidate
    checkMembership: $checkMembership
    tableNumber: $tableNumber
    tableArea: $tableArea
    googlePlaceId: $googlePlaceId
  ) {
    id
    tableNumber
    tableArea
    orderingWindowStartDate
  }
}
    `;

export function useCartMenuItemQuery(options: Omit<Urql.UseQueryArgs<CartMenuItemQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CartMenuItemQuery>({ query: CartMenuItemDocument, ...options });
};
export const CartMenuDocument = gql`
    query cartMenu($venueSlug: String!, $orderingType: OrderingType!, $revalidate: Boolean, $checkMembership: Boolean, $tableNumber: String, $tableArea: String, $googlePlaceId: String) {
  getCart(
    slug: $venueSlug
    orderingType: $orderingType
    revalidate: $revalidate
    checkMembership: $checkMembership
    tableNumber: $tableNumber
    tableArea: $tableArea
    googlePlaceId: $googlePlaceId
  ) {
    id
    tableNumber
    tableArea
    orderingWindowStartDate
    cartItems {
      id
      quantity
      cartUpsells {
        id
        quantity
      }
    }
  }
}
    `;

export function useCartMenuQuery(options: Omit<Urql.UseQueryArgs<CartMenuQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CartMenuQuery>({ query: CartMenuDocument, ...options });
};
export const CartPageDocument = gql`
    query cartPage($venueSlug: String!, $orderingType: OrderingType!, $revalidate: Boolean, $checkMembership: Boolean, $tableNumber: String, $tableArea: String, $googlePlaceId: String) {
  getCart(
    slug: $venueSlug
    orderingType: $orderingType
    revalidate: $revalidate
    checkMembership: $checkMembership
    tableNumber: $tableNumber
    tableArea: $tableArea
    googlePlaceId: $googlePlaceId
  ) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useCartPageQuery(options: Omit<Urql.UseQueryArgs<CartPageQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CartPageQuery>({ query: CartPageDocument, ...options });
};
export const CartPaymentDocument = gql`
    query cartPayment($venueSlug: String!, $orderingType: OrderingType!, $revalidate: Boolean, $checkMembership: Boolean, $tableNumber: String, $tableArea: String, $googlePlaceId: String) {
  getCart(
    slug: $venueSlug
    orderingType: $orderingType
    revalidate: $revalidate
    checkMembership: $checkMembership
    tableNumber: $tableNumber
    tableArea: $tableArea
    googlePlaceId: $googlePlaceId
  ) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useCartPaymentQuery(options: Omit<Urql.UseQueryArgs<CartPaymentQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CartPaymentQuery>({ query: CartPaymentDocument, ...options });
};
export const CartTableInfoDocument = gql`
    query cartTableInfo($venueSlug: String!, $orderingType: OrderingType!, $tableNumber: String, $tableArea: String, $googlePlaceId: String) {
  getCart(
    slug: $venueSlug
    orderingType: $orderingType
    tableNumber: $tableNumber
    tableArea: $tableArea
    googlePlaceId: $googlePlaceId
  ) {
    tableNumber
    tableArea
    orderingWindowStartDate
  }
}
    `;

export function useCartTableInfoQuery(options: Omit<Urql.UseQueryArgs<CartTableInfoQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CartTableInfoQuery>({ query: CartTableInfoDocument, ...options });
};
export const CreateCartDocument = gql`
    mutation createCart($googlePlaceId: String, $orderingType: OrderingType!, $revalidate: Boolean, $venueSlug: String!, $tableArea: String, $tableNumber: String) {
  createCart(
    googlePlaceId: $googlePlaceId
    orderingType: $orderingType
    revalidate: $revalidate
    slug: $venueSlug
    tableArea: $tableArea
    tableNumber: $tableNumber
  ) {
    tableNumber
    tableArea
    id
  }
}
    `;

export function useCreateCartMutation() {
  return Urql.useMutation<CreateCartMutation, CreateCartMutationVariables>(CreateCartDocument);
};
export const RefreshCartPricesDocument = gql`
    mutation refreshCartPrices($input: CartInputBase!) {
  refreshCartPrices(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useRefreshCartPricesMutation() {
  return Urql.useMutation<RefreshCartPricesMutation, RefreshCartPricesMutationVariables>(RefreshCartPricesDocument);
};
export const RemoveCartDiscountByCodeDocument = gql`
    mutation removeCartDiscountByCode($input: CartDiscountRemoveByCode!) {
  removeCartDiscountByCode(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useRemoveCartDiscountByCodeMutation() {
  return Urql.useMutation<RemoveCartDiscountByCodeMutation, RemoveCartDiscountByCodeMutationVariables>(RemoveCartDiscountByCodeDocument);
};
export const RemoveCartDiscountDocument = gql`
    mutation removeCartDiscount($input: CartDiscountRemove!) {
  removeCartDiscount(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useRemoveCartDiscountMutation() {
  return Urql.useMutation<RemoveCartDiscountMutation, RemoveCartDiscountMutationVariables>(RemoveCartDiscountDocument);
};
export const RemoveCartServiceChargeDocument = gql`
    mutation removeCartServiceCharge($input: CartServiceChargeRemove!) {
  removeCartServiceCharge(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useRemoveCartServiceChargeMutation() {
  return Urql.useMutation<RemoveCartServiceChargeMutation, RemoveCartServiceChargeMutationVariables>(RemoveCartServiceChargeDocument);
};
export const RemoveItemFromCartDocument = gql`
    mutation removeItemFromCart($input: CartItemsRemove!) {
  removeItemFromCart(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useRemoveItemFromCartMutation() {
  return Urql.useMutation<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(RemoveItemFromCartDocument);
};
export const RemoveUnavailableItemsDocument = gql`
    mutation removeUnavailableItems($input: CartInputBase!) {
  removeUnavailableItems(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useRemoveUnavailableItemsMutation() {
  return Urql.useMutation<RemoveUnavailableItemsMutation, RemoveUnavailableItemsMutationVariables>(RemoveUnavailableItemsDocument);
};
export const UpdateCartItemQuantityDocument = gql`
    mutation updateCartItemQuantity($input: CartItemQuantityUpdate!) {
  updateCartItemQuantity(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useUpdateCartItemQuantityMutation() {
  return Urql.useMutation<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>(UpdateCartItemQuantityDocument);
};
export const VenueDetailsDocument = gql`
    query venueDetails($venueSlug: String!, $orderingType: OrderingType!) {
  guestVenue(slug: $venueSlug) {
    id
    gratuityRate
    gratuityOptions
    gratuityEnabled
    canSkipGratuity
    flexibleGratuityEnabled
    customGratuityText
    orderingType(orderingType: $orderingType) {
      id
      name
      orderingType
      notesText
      notesFieldRequirement
      tableText
      tableShortText
    }
    posIntegration {
      id
      type
    }
    tipjarUrl
  }
}
    `;

export function useVenueDetailsQuery(options: Omit<Urql.UseQueryArgs<VenueDetailsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueDetailsQuery>({ query: VenueDetailsDocument, ...options });
};
export const MultiVendorConfirmationDocument = gql`
    query multiVendorConfirmation($multiVendorOrderId: String!) {
  multiVendorInvoice(orderId: $multiVendorOrderId) {
    multiVendorOrder {
      id
      createdAt
      totalInCents
    }
  }
}
    `;

export function useMultiVendorConfirmationQuery(options: Omit<Urql.UseQueryArgs<MultiVendorConfirmationQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MultiVendorConfirmationQuery>({ query: MultiVendorConfirmationDocument, ...options });
};
export const OrderConfirmationDocument = gql`
    query orderConfirmation($orderId: String!) {
  guestOrderById(orderId: $orderId) {
    ...OrderConfirmationParts
  }
}
    ${OrderConfirmationPartsFragmentDoc}`;

export function useOrderConfirmationQuery(options: Omit<Urql.UseQueryArgs<OrderConfirmationQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<OrderConfirmationQuery>({ query: OrderConfirmationDocument, ...options });
};
export const VenueConfirmationDocument = gql`
    query venueConfirmation($venueSlug: String!, $orderingType: OrderingType!) {
  guestVenue(slug: $venueSlug) {
    ...GuestVenueConfirmationParts
  }
}
    ${GuestVenueConfirmationPartsFragmentDoc}`;

export function useVenueConfirmationQuery(options: Omit<Urql.UseQueryArgs<VenueConfirmationQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueConfirmationQuery>({ query: VenueConfirmationDocument, ...options });
};
export const DirectoryVenueCollectionsDocument = gql`
    query directoryVenueCollections($vcPrefix: String!, $vcSlug: String) {
  allCollections: directoryVenueCollections(vcPrefix: $vcPrefix) {
    id
    name
    slug
  }
  directoryVenueCollections(vcPrefix: $vcPrefix, vcSlug: $vcSlug) {
    id
    name
    slug
    venueCollectionToVenue(shuffleVenues: true) {
      ...DirectoryVenueParts
    }
  }
}
    ${DirectoryVenuePartsFragmentDoc}`;

export function useDirectoryVenueCollectionsQuery(options: Omit<Urql.UseQueryArgs<DirectoryVenueCollectionsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<DirectoryVenueCollectionsQuery>({ query: DirectoryVenueCollectionsDocument, ...options });
};
export const ApplyCartEonxDetailsDocument = gql`
    mutation applyCartEonxDetails($venueSlug: String!) {
  applyCartEonxDetails(venueSlug: $venueSlug) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useApplyCartEonxDetailsMutation() {
  return Urql.useMutation<ApplyCartEonxDetailsMutation, ApplyCartEonxDetailsMutationVariables>(ApplyCartEonxDetailsDocument);
};
export const EonxCheckInGuestDocument = gql`
    mutation eonxCheckInGuest($id: String!, $venueSlug: String!) {
  eonxCheckInGuest(id: $id, venueSlug: $venueSlug) {
    id
    name
    email
    mobile
  }
}
    `;

export function useEonxCheckInGuestMutation() {
  return Urql.useMutation<EonxCheckInGuestMutation, EonxCheckInGuestMutationVariables>(EonxCheckInGuestDocument);
};
export const CreateReviewDocument = gql`
    mutation createReview($input: CreateReviewInput!) {
  createReview(input: $input) {
    id
    notes
    rating
    createdAt
    updatedAt
  }
}
    `;

export function useCreateReviewMutation() {
  return Urql.useMutation<CreateReviewMutation, CreateReviewMutationVariables>(CreateReviewDocument);
};
export const GetReviewDocument = gql`
    query getReview($orderId: String!) {
  getReview(orderId: $orderId) {
    id
    notes
    rating
    createdAt
    updatedAt
  }
}
    `;

export function useGetReviewQuery(options: Omit<Urql.UseQueryArgs<GetReviewQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetReviewQuery>({ query: GetReviewDocument, ...options });
};
export const UpdateReviewDocument = gql`
    mutation updateReview($input: UpdateReviewInput!) {
  updateReview(input: $input) {
    id
    notes
    rating
    createdAt
    updatedAt
  }
}
    `;

export function useUpdateReviewMutation() {
  return Urql.useMutation<UpdateReviewMutation, UpdateReviewMutationVariables>(UpdateReviewDocument);
};
export const HamburgerMenuAdditionalDocument = gql`
    query hamburgerMenuAdditional($venueSlug: String!) {
  currentUser {
    id
    managedTabs(venueSlug: $venueSlug) {
      id
      tabName
    }
  }
  lastOrderByUserByVenueSlug(venueSlug: $venueSlug) {
    id
    paymentProcessor
    orderingType
  }
}
    `;

export function useHamburgerMenuAdditionalQuery(options: Omit<Urql.UseQueryArgs<HamburgerMenuAdditionalQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HamburgerMenuAdditionalQuery>({ query: HamburgerMenuAdditionalDocument, ...options });
};
export const HamburgerMenuDocument = gql`
    query hamburgerMenu($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    name
    bookingLink
    surveyLink
    yumpingoVenueId
    ordering
    isOrderingAvailable
    landingCallToActionText
    landingCallToActionUrl
    isClosed
    startTabAvailable
    supportEmail
    supportPhone
    hours {
      ...TimeBlocksParts
    }
    location {
      id: googlePlaceId
      formattedAddress
    }
    logo(transform: "avatar") {
      id
      originalImagePath
      originalImageUrl
    }
    orderingTypes {
      id
      orderingType
      isAvailable
      orderingWindow {
        id
        enabled
      }
    }
  }
}
    ${TimeBlocksPartsFragmentDoc}`;

export function useHamburgerMenuQuery(options: Omit<Urql.UseQueryArgs<HamburgerMenuQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<HamburgerMenuQuery>({ query: HamburgerMenuDocument, ...options });
};
export const BasicInvoiceDocument = gql`
    query basicInvoice($orderId: String!) {
  invoice(orderId: $orderId) {
    ...BasicInvoiceParts
  }
}
    ${BasicInvoicePartsFragmentDoc}`;

export function useBasicInvoiceQuery(options: Omit<Urql.UseQueryArgs<BasicInvoiceQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<BasicInvoiceQuery>({ query: BasicInvoiceDocument, ...options });
};
export const MultiVendorInvoiceDocument = gql`
    query multiVendorInvoice($orderId: String!) {
  multiVendorInvoice(orderId: $orderId) {
    multiVendorOrder {
      ...MultiVendorInvoiceParts
    }
    orders {
      ...BasicInvoiceParts
    }
  }
}
    ${MultiVendorInvoicePartsFragmentDoc}
${BasicInvoicePartsFragmentDoc}`;

export function useMultiVendorInvoiceQuery(options: Omit<Urql.UseQueryArgs<MultiVendorInvoiceQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MultiVendorInvoiceQuery>({ query: MultiVendorInvoiceDocument, ...options });
};
export const SharedPaymentInvoiceDocument = gql`
    query sharedPaymentInvoice($sharedPaymentLineItemId: String!) {
  sharedPaymentInvoice(sharedPaymentLineItemId: $sharedPaymentLineItemId) {
    id
    order {
      ...BasicInvoiceParts
    }
    user {
      ...UserInvoiceParts
    }
    totalInCents
    totalTaxInCents
    gratuityInCents
  }
}
    ${BasicInvoicePartsFragmentDoc}
${UserInvoicePartsFragmentDoc}`;

export function useSharedPaymentInvoiceQuery(options: Omit<Urql.UseQueryArgs<SharedPaymentInvoiceQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SharedPaymentInvoiceQuery>({ query: SharedPaymentInvoiceDocument, ...options });
};
export const TabInvoiceDocument = gql`
    query tabInvoice($tabId: String!) {
  tabInvoice(tabId: $tabId) {
    ...BasicInvoiceParts
  }
  getTabMeta(tabId: $tabId) {
    id
    managers {
      ...UserInvoiceParts
    }
    venue {
      ...VenueInvoiceParts
    }
  }
}
    ${BasicInvoicePartsFragmentDoc}
${UserInvoicePartsFragmentDoc}
${VenueInvoicePartsFragmentDoc}`;

export function useTabInvoiceQuery(options: Omit<Urql.UseQueryArgs<TabInvoiceQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TabInvoiceQuery>({ query: TabInvoiceDocument, ...options });
};
export const VenueCollectionBySlugDocument = gql`
    query venueCollectionBySlug($vcslug: String!) {
  venueCollectionBySlug(slug: $vcslug) {
    id
    description
    name
    slug
    venueCollectionToVenue {
      id
      name
      type
      venue {
        id
        name
        slug
        squareThumb(transform: "square") {
          id
          defaultImage
          srcSet
        }
      }
      childrenCollection {
        id
        name
        slug
      }
      enabled
      orderingType
      vlpImage(transform: "vlp") {
        id
        defaultImage
        srcSet
      }
      image: vlpImage {
        id
        originalImageUrl
      }
    }
  }
}
    `;

export function useVenueCollectionBySlugQuery(options: Omit<Urql.UseQueryArgs<VenueCollectionBySlugQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueCollectionBySlugQuery>({ query: VenueCollectionBySlugDocument, ...options });
};
export const VenueCollectionRegionDocument = gql`
    query venueCollectionRegion {
  venueCollectionRegion
}
    `;

export function useVenueCollectionRegionQuery(options: Omit<Urql.UseQueryArgs<VenueCollectionRegionQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueCollectionRegionQuery>({ query: VenueCollectionRegionDocument, ...options });
};
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    ...UserParts
  }
}
    ${UserPartsFragmentDoc}`;

export function useCurrentUserQuery(options: Omit<Urql.UseQueryArgs<CurrentUserQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CurrentUserQuery>({ query: CurrentUserDocument, ...options });
};
export const LoginDocument = gql`
    mutation login($mobile: String!, $otp: String!) {
  login(input: {mobile: $mobile, otp: $otp}) {
    mobile
  }
}
    `;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
};
export const LoginAsAnonymousGuestDocument = gql`
    mutation loginAsAnonymousGuest {
  loginAsAnonymousGuest {
    mobile
  }
}
    `;

export function useLoginAsAnonymousGuestMutation() {
  return Urql.useMutation<LoginAsAnonymousGuestMutation, LoginAsAnonymousGuestMutationVariables>(LoginAsAnonymousGuestDocument);
};
export const SendOneTimePasswordSmsDocument = gql`
    mutation sendOneTimePasswordSMS($mobile: String!, $turnstileToken: String) {
  sendOneTimePasswordSMS(
    input: {mobile: $mobile, turnstileToken: $turnstileToken}
  ) {
    mobile
    result
    retryAfter
  }
}
    `;

export function useSendOneTimePasswordSmsMutation() {
  return Urql.useMutation<SendOneTimePasswordSmsMutation, SendOneTimePasswordSmsMutationVariables>(SendOneTimePasswordSmsDocument);
};
export const VenueCountryCodeDocument = gql`
    query venueCountryCode($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    countryCode
    currency
  }
}
    `;

export function useVenueCountryCodeQuery(options: Omit<Urql.UseQueryArgs<VenueCountryCodeQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueCountryCodeQuery>({ query: VenueCountryCodeDocument, ...options });
};
export const AddGuestMembershipDocument = gql`
    mutation addGuestMembership($organizationId: String!) {
  addGuestMembership(input: {organizationId: $organizationId}) {
    success
  }
}
    `;

export function useAddGuestMembershipMutation() {
  return Urql.useMutation<AddGuestMembershipMutation, AddGuestMembershipMutationVariables>(AddGuestMembershipDocument);
};
export const LoyaltyMembershipDocument = gql`
    query loyaltyMembership($venueSlug: String!, $externalMemberId: String) {
  loyaltyDetails(
    input: {venueSlug: $venueSlug, externalMemberId: $externalMemberId}
  ) {
    id
    guestData {
      id
      isOptedIn
    }
    metadata {
      id
      memberName
      introHeader
      introBody
      infoLink
    }
  }
  guestVenue(slug: $venueSlug) {
    id
    venueId: id
    organizationId
  }
  getGuestMembership(input: {venueSlug: $venueSlug}) {
    id
    email
  }
}
    `;

export function useLoyaltyMembershipQuery(options: Omit<Urql.UseQueryArgs<LoyaltyMembershipQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<LoyaltyMembershipQuery>({ query: LoyaltyMembershipDocument, ...options });
};
export const AboutVenueDocument = gql`
    query aboutVenue($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    ordering
  }
}
    `;

export function useAboutVenueQuery(options: Omit<Urql.UseQueryArgs<AboutVenueQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AboutVenueQuery>({ query: AboutVenueDocument, ...options });
};
export const AddOrUpdateTableNumberOnCartDocument = gql`
    mutation addOrUpdateTableNumberOnCart($input: CartTableNumberInput!) {
  addOrUpdateTableNumberOnCart(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useAddOrUpdateTableNumberOnCartMutation() {
  return Urql.useMutation<AddOrUpdateTableNumberOnCartMutation, AddOrUpdateTableNumberOnCartMutationVariables>(AddOrUpdateTableNumberOnCartDocument);
};
export const MenuCategoriesDocument = gql`
    query menuCategories($venueSlug: String!, $orderingType: OrderingType!, $tableArea: String, $tableNumber: String, $orderingWindowStartDate: String) {
  guestVenue(slug: $venueSlug) {
    ...VenueForMenuCategory
  }
  guestMenuCategories(
    venueSlug: $venueSlug
    orderingType: $orderingType
    tableArea: $tableArea
    tableNumber: $tableNumber
    orderingWindowStartDate: $orderingWindowStartDate
  ) {
    id
    name
    slug
    menuCategoryType
    orderingType
    isClosed(
      tableArea: $tableArea
      tableNumber: $tableNumber
      orderingType: $orderingType
      orderingWindowStartDate: $orderingWindowStartDate
    )
    image {
      id
      originalImageUrl
      originalImagePath
    }
  }
}
    ${VenueForMenuCategoryFragmentDoc}`;

export function useMenuCategoriesQuery(options: Omit<Urql.UseQueryArgs<MenuCategoriesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MenuCategoriesQuery>({ query: MenuCategoriesDocument, ...options });
};
export const MenuDocument = gql`
    query menu($venueSlug: String!, $orderingType: OrderingType!, $categorySlug: String!, $tableNumber: String, $tableArea: String, $orderingWindowStartDate: String, $priceLevel: String) {
  guestMenuCategory(
    venueSlug: $venueSlug
    categorySlug: $categorySlug
    orderingType: $orderingType
    orderingWindowStartDate: $orderingWindowStartDate
    priceLevel: $priceLevel
  ) {
    id
    name
    slug
    image {
      id
      originalImagePath
      originalImageUrl
    }
    extendedWaitTime {
      id
      estimate
      estimateInMilliseconds
      expiry
      expiryEndTime
    }
    menuSections {
      id
      name
      slug
      subSection
      menuItems {
        id
        slug
        name
        type
        isAvailable(orderingWindowStartDate: $orderingWindowStartDate)
        isLive
        isPopular
        image {
          id
          originalImagePath
          originalImageUrl
        }
        namefr
        imageCredit
        filterTags
        nameel
        namees
        nameit
        namezhCN
        namede
        description
        descriptionPlain
        descriptionfr
        descriptionel
        descriptiones
        descriptionit
        descriptionzhCN
        descriptionde
        dietaryTags
        priceData {
          displayPrice
          priceInCents
          originalDisplayPrice
          hasPriceOverride
          isMembershipPricing
        }
        rewardPrice {
          originalAmountInCents
          originalDisplayAmount
        }
      }
      extendedWaitTime {
        id
        estimate
        estimateInMilliseconds
        expiry
        expiryEndTime
      }
    }
  }
  guestMenuCategories(
    venueSlug: $venueSlug
    orderingType: $orderingType
    tableArea: $tableArea
    tableNumber: $tableNumber
    orderingWindowStartDate: $orderingWindowStartDate
  ) {
    id
    name
    slug
    image {
      id
      originalImagePath
      originalImageUrl
    }
    menuSections {
      id
      name
      slug
      subSection
    }
    extendedWaitTime {
      id
      estimate
      estimateInMilliseconds
      expiry
      expiryEndTime
    }
  }
}
    `;

export function useMenuQuery(options: Omit<Urql.UseQueryArgs<MenuQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MenuQuery>({ query: MenuDocument, ...options });
};
export const MenuVenueDocument = gql`
    query menuVenue($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    name
    slug
    facebookPixelId
    isIframe
    venueId: id
    bookingLink
    currency
    isBarBusy
    isKitchenBusy
    ordering
    countryCode
    timezone
    tabsEnabled
    landingCallToActionText
    landingCallToActionUrl
    isClosed
    isLive
    isOrderingAvailable
    alwaysShowVisualMenu
    hours {
      ...TimeBlocksParts
    }
    supportEmail
    supportPhone
    logo {
      id
      originalImagePath
      originalImageUrl
    }
    banner {
      id
      originalImagePath
      originalImageUrl
    }
    mobileBanner {
      id
      originalImagePath
      originalImageUrl
    }
    location {
      id: googlePlaceId
      googlePlaceId
      priceLevel
      state: adminArea1
      name
      url
      formattedAddress
      streetAddress
      state: adminArea1
      locality
      adminArea2
      adminArea1
      latitude
      longitude
      countryCode
      postalCode
    }
    cuisines {
      name
    }
    orderingTypes {
      id
      orderingType
      enabled
      landingText
      isAvailable
      usingTableGroups
      orderingWindow {
        id
        enabled
      }
    }
    posIntegration {
      id
      type
    }
  }
}
    ${TimeBlocksPartsFragmentDoc}`;

export function useMenuVenueQuery(options: Omit<Urql.UseQueryArgs<MenuVenueQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MenuVenueQuery>({ query: MenuVenueDocument, ...options });
};
export const TableRuleDocument = gql`
    query tableRule($number: String!, $area: String) {
  tableRule(number: $number, area: $area) {
    area
    number
    status
  }
}
    `;

export function useTableRuleQuery(options: Omit<Urql.UseQueryArgs<TableRuleQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TableRuleQuery>({ query: TableRuleDocument, ...options });
};
export const MenuItemDetailsDocument = gql`
    query menuItemDetails($itemSlug: String!, $categorySlug: String!, $venueSlug: String!, $orderingType: OrderingType!, $tableNumber: String, $tableArea: String, $orderingWindowStartDate: String, $priceLevel: String) {
  guestMenuItem(
    itemSlug: $itemSlug
    venueSlug: $venueSlug
    orderingWindowStartDate: $orderingWindowStartDate
    priceLevel: $priceLevel
  ) {
    ...MenuItemDetails
    isAvailable(orderingWindowStartDate: $orderingWindowStartDate)
    isAvailableForOrdering(
      input: {orderingType: $orderingType, tableNumber: $tableNumber, tableArea: $tableArea, orderingWindowStartDate: $orderingWindowStartDate}
    )
  }
  guestMenuCategory(
    venueSlug: $venueSlug
    categorySlug: $categorySlug
    orderingType: $orderingType
    orderingWindowStartDate: $orderingWindowStartDate
    priceLevel: $priceLevel
  ) {
    id
    slug
    isClosed(
      tableArea: $tableArea
      tableNumber: $tableNumber
      orderingType: $orderingType
      orderingWindowStartDate: $orderingWindowStartDate
    )
  }
}
    ${MenuItemDetailsFragmentDoc}`;

export function useMenuItemDetailsQuery(options: Omit<Urql.UseQueryArgs<MenuItemDetailsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MenuItemDetailsQuery>({ query: MenuItemDetailsDocument, ...options });
};
export const MenuItemDetailsVenueDocument = gql`
    query menuItemDetailsVenue($venueSlug: String!, $orderingType: OrderingType!) {
  guestVenue(slug: $venueSlug) {
    id
    currency
    ordering
    isOrderingAvailable
    orderingType(orderingType: $orderingType) {
      id
      isAvailable
    }
    posIntegration {
      id
      type
    }
  }
}
    `;

export function useMenuItemDetailsVenueQuery(options: Omit<Urql.UseQueryArgs<MenuItemDetailsVenueQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MenuItemDetailsVenueQuery>({ query: MenuItemDetailsVenueDocument, ...options });
};
export const ModifiersForMenuItemDocument = gql`
    query modifiersForMenuItem($venueSlug: String!, $itemSlug: String!, $orderingType: OrderingType!, $tableNumber: String, $tableArea: String, $orderingWindowStartDate: String, $priceLevel: String) {
  guestMenuItem(
    venueSlug: $venueSlug
    itemSlug: $itemSlug
    orderingWindowStartDate: $orderingWindowStartDate
    priceLevel: $priceLevel
  ) {
    upgradeGroup {
      id
      name
      available
      selectType
      orderingTypes
      selectRequirement
      minQuantity
      maxQuantity
      hasPreselectedOption
      orderingTypes
      upgrades {
        id
        name
        position
        available
        displayPrice
        showFullPrice
        menuItem {
          ...MenuItemDetails
          id
          slug
          name
          isAvailableForOrdering(
            input: {orderingType: $orderingType, tableNumber: $tableNumber, tableArea: $tableArea, orderingWindowStartDate: $orderingWindowStartDate}
          )
          inventoryEnabled
          inventoryCount
          minQuantity
          maxQuantity
          priceData {
            displayPrice
            priceInCents
            originalDisplayPrice
            hasPriceOverride
            isMembershipPricing
          }
          priceLevels {
            priceInCents
            level
          }
        }
      }
    }
    modifierGroups {
      id
      name
      selectType
      orderingTypes
      displayViewSelectRequirement
      hasPreselectedOption
      selectRequirement
      minQuantity
      maxQuantity
      modifiers {
        id
        name
        available
        displayPrice
        priceInCents
        maxQuantity
        position
        isTaxExempt
        priceData {
          displayPrice
          priceInCents
          originalDisplayPrice
          hasPriceOverride
          isMembershipPricing
        }
      }
    }
    upsellGroups {
      id
      name
      available
      selectType
      orderingTypes
      selectRequirement
      minQuantity
      maxQuantity
      hasPreselectedOption
      displayViewSelectRequirement
      isDynamic
      respectCartQuantity
      upsells {
        id
        name
        position
        displayPrice
        available
        showFullPrice
        menuItem {
          ...MenuItemDetails
          modifierGroups {
            id
            name
            selectType
            orderingTypes
            displayViewSelectRequirement
            hasPreselectedOption
            selectRequirement
            minQuantity
            maxQuantity
            modifiers {
              id
              name
              available
              displayPrice
              priceInCents
              maxQuantity
              position
              isTaxExempt
              priceData {
                displayPrice
                priceInCents
                originalDisplayPrice
                hasPriceOverride
                isMembershipPricing
              }
            }
          }
          isLive
          isAvailable(orderingWindowStartDate: $orderingWindowStartDate)
          isAvailableForOrdering(
            input: {orderingType: $orderingType, tableNumber: $tableNumber, tableArea: $tableArea, orderingWindowStartDate: $orderingWindowStartDate}
          )
        }
      }
    }
  }
}
    ${MenuItemDetailsFragmentDoc}`;

export function useModifiersForMenuItemQuery(options: Omit<Urql.UseQueryArgs<ModifiersForMenuItemQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ModifiersForMenuItemQuery>({ query: ModifiersForMenuItemDocument, ...options });
};
export const VenueMetaImageDocument = gql`
    query venueMetaImage($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    ogImage(transform: "og") {
      id
      originalImagePath
      originalImageUrl
    }
    image: ogImage {
      id
      originalImageUrl
    }
  }
}
    `;

export function useVenueMetaImageQuery(options: Omit<Urql.UseQueryArgs<VenueMetaImageQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueMetaImageQuery>({ query: VenueMetaImageDocument, ...options });
};
export const OrderHistoryDataDocument = gql`
    query orderHistoryData($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    name
    currency
  }
  currentUser {
    id
    receiptEmail
    email
  }
}
    `;

export function useOrderHistoryDataQuery(options: Omit<Urql.UseQueryArgs<OrderHistoryDataQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<OrderHistoryDataQuery>({ query: OrderHistoryDataDocument, ...options });
};
export const OrderHistoryOrdersDocument = gql`
    query orderHistoryOrders($venueSlug: String!) {
  getOrderHistoryV3(slug: $venueSlug) {
    ...OrderHistoryParts
  }
}
    ${OrderHistoryPartsFragmentDoc}`;

export function useOrderHistoryOrdersQuery(options: Omit<Urql.UseQueryArgs<OrderHistoryOrdersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<OrderHistoryOrdersQuery>({ query: OrderHistoryOrdersDocument, ...options });
};
export const UpdateReceiptEmailDocument = gql`
    mutation updateReceiptEmail($receiptEmail: String!, $venueSlug: String!) {
  updateCustomerDetailsAndSendReceipt(
    receiptEmail: $receiptEmail
    venueSlug: $venueSlug
  ) {
    id
    receiptEmail
  }
}
    `;

export function useUpdateReceiptEmailMutation() {
  return Urql.useMutation<UpdateReceiptEmailMutation, UpdateReceiptEmailMutationVariables>(UpdateReceiptEmailDocument);
};
export const CreateEonxOrderIntentDocument = gql`
    mutation createEonxOrderIntent($order: CreateOrderInput!) {
  createOrder(order: $order) {
    orderPaymentCapture {
      intentId
      intentApiKey
    }
  }
}
    `;

export function useCreateEonxOrderIntentMutation() {
  return Urql.useMutation<CreateEonxOrderIntentMutation, CreateEonxOrderIntentMutationVariables>(CreateEonxOrderIntentDocument);
};
export const CreateOrderDocument = gql`
    mutation createOrder($options: CartOptionsInput!, $customer: UpdateCurrentCustomerInput!, $marketing: UpdateMarketingOptInInput!, $order: CreateOrderInput!, $doordashInput: ValidateDoordashOrderDeliveryInput!) {
  validateDoordashOrderDelivery(doordash: $doordashInput) {
    success
    error
  }
  addOrUpdateOptionsOnCart(input: $options) {
    id
  }
  updateCurrentCustomer(input: $customer) {
    id
  }
  updateMarketingOptIn(input: $marketing) {
    id
  }
  createOrder(order: $order) {
    customerId
    orderId
    multiVendorOrder
    validation {
      valid
      error
    }
    socialTabId
    orderPaymentChallenge {
      type
      url
      returnUrl
    }
    orderPaymentRedirect {
      actionToken
      redirectCheckoutUrl
    }
    orderPaymentCapture {
      intentId
      intentApiKey
    }
  }
}
    `;

export function useCreateOrderMutation() {
  return Urql.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument);
};
export const SaveOrderDetailsDocument = gql`
    mutation saveOrderDetails($options: CartOptionsInput!, $customer: UpdateCurrentCustomerInput!) {
  addOrUpdateOptionsOnCart(input: $options) {
    id
  }
  updateCurrentCustomer(input: $customer) {
    id
  }
}
    `;

export function useSaveOrderDetailsMutation() {
  return Urql.useMutation<SaveOrderDetailsMutation, SaveOrderDetailsMutationVariables>(SaveOrderDetailsDocument);
};
export const ValidateOrderDocument = gql`
    mutation validateOrder($options: CartOptionsInput!, $customer: UpdateCurrentCustomerInput!, $marketing: UpdateMarketingOptInInput!, $doordashInput: ValidateDoordashOrderDeliveryInput!) {
  validateDoordashOrderDelivery(doordash: $doordashInput) {
    success
    error
  }
  addOrUpdateOptionsOnCart(input: $options) {
    id
  }
  updateCurrentCustomer(input: $customer) {
    id
  }
  updateMarketingOptIn(input: $marketing) {
    id
  }
}
    `;

export function useValidateOrderMutation() {
  return Urql.useMutation<ValidateOrderMutation, ValidateOrderMutationVariables>(ValidateOrderDocument);
};
export const ExistingMarketingOptInDocument = gql`
    query existingMarketingOptIn($venueSlug: String!, $mobile: String!) {
  existingMarketingOptIn(slug: $venueSlug, mobile: $mobile) {
    id
  }
}
    `;

export function useExistingMarketingOptInQuery(options: Omit<Urql.UseQueryArgs<ExistingMarketingOptInQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ExistingMarketingOptInQuery>({ query: ExistingMarketingOptInDocument, ...options });
};
export const VenueOrderingWindowsDocument = gql`
    query venueOrderingWindows($venueSlug: String!, $orderingType: OrderingType!) {
  guestVenue(slug: $venueSlug) {
    id
    name
    slug
    timezone
    logo {
      id
      originalImagePath
      originalImageUrl
    }
    banner {
      id
      originalImagePath
      originalImageUrl
    }
    mobileBanner {
      id
      originalImagePath
      originalImageUrl
    }
    ordering
    countryCode
    orderingTypes {
      id
      orderingType
      name
      tableAreaText
      usingTableGroups
    }
    location {
      id: googlePlaceId
      state: adminArea1
    }
  }
  venue(slug: $venueSlug) {
    id
    orderingTypeSettingsV2(orderingType: $orderingType) {
      id
      orderingWindow {
        ...WindowParts
      }
    }
  }
}
    ${WindowPartsFragmentDoc}`;

export function useVenueOrderingWindowsQuery(options: Omit<Urql.UseQueryArgs<VenueOrderingWindowsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueOrderingWindowsQuery>({ query: VenueOrderingWindowsDocument, ...options });
};
export const GuestOrderByPaymentTxnIdDocument = gql`
    query guestOrderByPaymentTxnId($paymentTransactionId: String!) {
  guestOrderByPaymentTxnId(paymentTransactionId: $paymentTransactionId) {
    id
  }
}
    `;

export function useGuestOrderByPaymentTxnIdQuery(options: Omit<Urql.UseQueryArgs<GuestOrderByPaymentTxnIdQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GuestOrderByPaymentTxnIdQuery>({ query: GuestOrderByPaymentTxnIdDocument, ...options });
};
export const UpdateCustomerDetailsDocument = gql`
    mutation updateCustomerDetails($email: String, $name: String, $customerId: String, $isOver18: Boolean, $savePaymentDetails: Boolean, $marketingUserOptIn: Boolean, $venueSlug: String) {
  updateCustomerDetails(
    isOver18: $isOver18
    email: $email
    name: $name
    customerId: $customerId
    savePaymentDetails: $savePaymentDetails
    marketingUserOptIn: $marketingUserOptIn
    venueSlug: $venueSlug
  ) {
    ...UserParts
  }
}
    ${UserPartsFragmentDoc}`;

export function useUpdateCustomerDetailsMutation() {
  return Urql.useMutation<UpdateCustomerDetailsMutation, UpdateCustomerDetailsMutationVariables>(UpdateCustomerDetailsDocument);
};
export const AfterpayConfigurationDocument = gql`
    query afterpayConfiguration {
  getAfterpayConfiguration {
    minimumAmount {
      amount
      currency
    }
    maximumAmount {
      amount
      currency
    }
  }
}
    `;

export function useAfterpayConfigurationQuery(options: Omit<Urql.UseQueryArgs<AfterpayConfigurationQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<AfterpayConfigurationQuery>({ query: AfterpayConfigurationDocument, ...options });
};
export const CurrentUserTabsDocument = gql`
    query currentUserTabs($venueSlug: String) {
  currentUser {
    id
    tabs(venueSlug: $venueSlug) {
      id
      tabName
    }
    managedTabs(venueSlug: $venueSlug) {
      id
      tabName
    }
  }
}
    `;

export function useCurrentUserTabsQuery(options: Omit<Urql.UseQueryArgs<CurrentUserTabsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CurrentUserTabsQuery>({ query: CurrentUserTabsDocument, ...options });
};
export const CustomerEonxCardDocument = gql`
    query customerEonxCard($venueSlug: String!) {
  eonxCustomerCard(venueSlug: $venueSlug) {
    ...EonxCardParts
  }
}
    ${EonxCardPartsFragmentDoc}`;

export function useCustomerEonxCardQuery(options: Omit<Urql.UseQueryArgs<CustomerEonxCardQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CustomerEonxCardQuery>({ query: CustomerEonxCardDocument, ...options });
};
export const CustomerPaystackCardDocument = gql`
    query customerPaystackCard($currency: String!, $customerId: String!) {
  paystackCard(currency: $currency, customerId: $customerId) {
    ...PaystackCardParts
  }
}
    ${PaystackCardPartsFragmentDoc}`;

export function useCustomerPaystackCardQuery(options: Omit<Urql.UseQueryArgs<CustomerPaystackCardQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CustomerPaystackCardQuery>({ query: CustomerPaystackCardDocument, ...options });
};
export const CustomerStripeCardDocument = gql`
    query customerStripeCard($currency: String!, $customerId: String!) {
  stripeCard(currency: $currency, customerId: $customerId) {
    ...StripeCardParts
  }
}
    ${StripeCardPartsFragmentDoc}`;

export function useCustomerStripeCardQuery(options: Omit<Urql.UseQueryArgs<CustomerStripeCardQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CustomerStripeCardQuery>({ query: CustomerStripeCardDocument, ...options });
};
export const IsSnapscanPaymentSuccessfulDocument = gql`
    query isSnapscanPaymentSuccessful($cartId: String!) {
  isSnapscanPaymentSuccessful(cartId: $cartId) {
    id
    success
    slug
    orderingType
    orderId
    cart {
      id
    }
  }
}
    `;

export function useIsSnapscanPaymentSuccessfulQuery(options: Omit<Urql.UseQueryArgs<IsSnapscanPaymentSuccessfulQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<IsSnapscanPaymentSuccessfulQuery>({ query: IsSnapscanPaymentSuccessfulDocument, ...options });
};
export const PaymentFormDocument = gql`
    query paymentForm($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    name
    slug
    currency
    marketingOptInEnabled
    marketingOptInDefault
    marketingOptInMessage
    ageRestrictionText
    tabsEnabled
    clubMembershipsEnabled
    gratuityEnabled
    customGratuityText
    multiVendorEnabled
    paymentProcessor {
      types
      unpaidProcessorTypeLabel
    }
    orderingType {
      name
    }
    orderingTypes {
      id
      orderingType
      emailFieldRequirement
      orderingWindow {
        id
        enabled
      }
      hasTableNumber
      optionsText
      options
      notesText
      notesFieldRequirement
      postcodes
      coverCountFieldRequirement
    }
    posIntegration {
      id
      type
    }
  }
  currentUser {
    ...UserParts
    tabs(venueSlug: $venueSlug) {
      ...SocialTabParts
    }
    managedTabs(venueSlug: $venueSlug) {
      ...SocialTabParts
    }
  }
}
    ${UserPartsFragmentDoc}
${SocialTabPartsFragmentDoc}`;

export function usePaymentFormQuery(options: Omit<Urql.UseQueryArgs<PaymentFormQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PaymentFormQuery>({ query: PaymentFormDocument, ...options });
};
export const PaymentIntentDocument = gql`
    mutation paymentIntent($currency: String!, $amount: Int!, $venueSlug: String, $cartId: String, $isSocialTabPreAuth: Boolean) {
  getPaymentIntent(
    currency: $currency
    amount: $amount
    venueSlug: $venueSlug
    cartId: $cartId
    isSocialTabPreAuth: $isSocialTabPreAuth
  ) {
    paymentIntentId
  }
}
    `;

export function usePaymentIntentMutation() {
  return Urql.useMutation<PaymentIntentMutation, PaymentIntentMutationVariables>(PaymentIntentDocument);
};
export const SnapscanPaymentQrUrlDocument = gql`
    query snapscanPaymentQrUrl($input: SnapscanPaymentQrUrlInput!) {
  snapscanPaymentQrUrl(input: $input) {
    url
    cartId
  }
}
    `;

export function useSnapscanPaymentQrUrlQuery(options: Omit<Urql.UseQueryArgs<SnapscanPaymentQrUrlQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SnapscanPaymentQrUrlQuery>({ query: SnapscanPaymentQrUrlDocument, ...options });
};
export const StartTabDocument = gql`
    mutation startTab($customer: UpdateCurrentCustomerInput!, $order: StartTabInput!) {
  updateCurrentCustomer(input: $customer) {
    id
  }
  startTab(data: $order) {
    customerId
    validation {
      valid
      error
    }
    socialTabId
    orderPaymentChallenge {
      type
      url
      returnUrl
    }
    orderPaymentRedirect {
      actionToken
      redirectCheckoutUrl
    }
  }
}
    `;

export function useStartTabMutation() {
  return Urql.useMutation<StartTabMutation, StartTabMutationVariables>(StartTabDocument);
};
export const TouchCartDocument = gql`
    mutation touchCart {
  touchCart
}
    `;

export function useTouchCartMutation() {
  return Urql.useMutation<TouchCartMutation, TouchCartMutationVariables>(TouchCartDocument);
};
export const UpdateBeforeAsyncOrderDocument = gql`
    mutation updateBeforeAsyncOrder($email: String, $name: String, $customerId: String, $isOver18: Boolean, $savePaymentDetails: Boolean, $marketingUserOptIn: Boolean, $venueSlug: String, $options: CartOptionsInput!) {
  addOrUpdateOptionsOnCart(input: $options) {
    ...CartParts
  }
  updateCustomerDetails(
    isOver18: $isOver18
    email: $email
    name: $name
    customerId: $customerId
    savePaymentDetails: $savePaymentDetails
    marketingUserOptIn: $marketingUserOptIn
    venueSlug: $venueSlug
  ) {
    ...UserParts
  }
}
    ${CartPartsFragmentDoc}
${UserPartsFragmentDoc}`;

export function useUpdateBeforeAsyncOrderMutation() {
  return Urql.useMutation<UpdateBeforeAsyncOrderMutation, UpdateBeforeAsyncOrderMutationVariables>(UpdateBeforeAsyncOrderDocument);
};
export const ChargeDocument = gql`
    mutation charge($input: ChargeInput!) {
  charge(input: $input) {
    nextAction
    paymentIntentId
    processorReference
    verificationUrl
  }
}
    `;

export function useChargeMutation() {
  return Urql.useMutation<ChargeMutation, ChargeMutationVariables>(ChargeDocument);
};
export const CreatePaymentIntentDocument = gql`
    mutation createPaymentIntent($input: CreatePaymentIntentInput!) {
  createPaymentIntent(input: $input) {
    paymentIntentId
    processorReference
  }
}
    `;

export function useCreatePaymentIntentMutation() {
  return Urql.useMutation<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>(CreatePaymentIntentDocument);
};
export const CreatePaymentMethodDocument = gql`
    mutation createPaymentMethod($input: CreatePaymentMethodInput!) {
  createPaymentMethod(input: $input) {
    nextAction
    verificationUrl
  }
}
    `;

export function useCreatePaymentMethodMutation() {
  return Urql.useMutation<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>(CreatePaymentMethodDocument);
};
export const FindPaymentDocument = gql`
    query findPayment($paymentTargetId: String!) {
  findPaymentByTargetId(paymentTargetId: $paymentTargetId) {
    id
    paymentTargetId
    processorTransactionId
  }
}
    `;

export function useFindPaymentQuery(options: Omit<Urql.UseQueryArgs<FindPaymentQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FindPaymentQuery>({ query: FindPaymentDocument, ...options });
};
export const GetPaymentDocument = gql`
    query getPayment($paymentId: String!) {
  getPayment(paymentId: $paymentId) {
    id
    paymentTargetId
    paymentStatus
    amount
  }
}
    `;

export function useGetPaymentQuery(options: Omit<Urql.UseQueryArgs<GetPaymentQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetPaymentQuery>({ query: GetPaymentDocument, ...options });
};
export const GetPaymentsDocument = gql`
    query getPayments($paymentTargetId: String!) {
  getPayments(paymentTargetId: $paymentTargetId) {
    id
    paymentTargetId
    paymentStatus
  }
}
    `;

export function useGetPaymentsQuery(options: Omit<Urql.UseQueryArgs<GetPaymentsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetPaymentsQuery>({ query: GetPaymentsDocument, ...options });
};
export const ListPaymentMethodsDocument = gql`
    query listPaymentMethods($currency: String!) {
  listPaymentMethods(currency: $currency) {
    id
    brand
    last4
    expiryMonth
    expiryYear
    createdAt
  }
}
    `;

export function useListPaymentMethodsQuery(options: Omit<Urql.UseQueryArgs<ListPaymentMethodsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ListPaymentMethodsQuery>({ query: ListPaymentMethodsDocument, ...options });
};
export const PaymentV2MetaDocument = gql`
    query paymentV2Meta($venueSlug: String!, $orderingType: String!) {
  listPaymentProcessors(orderingType: $orderingType, venueSlug: $venueSlug) {
    name
  }
}
    `;

export function usePaymentV2MetaQuery(options: Omit<Urql.UseQueryArgs<PaymentV2MetaQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PaymentV2MetaQuery>({ query: PaymentV2MetaDocument, ...options });
};
export const VerifyChargeDocument = gql`
    query verifyCharge($currency: String!, $verificationId: String!) {
  verifyCharge(currency: $currency, verificationId: $verificationId) {
    verificationResult
  }
}
    `;

export function useVerifyChargeQuery(options: Omit<Urql.UseQueryArgs<VerifyChargeQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VerifyChargeQuery>({ query: VerifyChargeDocument, ...options });
};
export const VerifyPaymentMethodDocument = gql`
    query verifyPaymentMethod($currency: String!, $verificationId: String!) {
  verifyPaymentMethod(currency: $currency, verificationId: $verificationId) {
    verificationId
    verificationResult
  }
}
    `;

export function useVerifyPaymentMethodQuery(options: Omit<Urql.UseQueryArgs<VerifyPaymentMethodQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VerifyPaymentMethodQuery>({ query: VerifyPaymentMethodDocument, ...options });
};
export const PopupNotificationModalDocument = gql`
    query popupNotificationModal($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    popupNotificationText
    popupNotificationImage {
      id
      originalImagePath
      originalImageUrl
    }
  }
}
    `;

export function usePopupNotificationModalQuery(options: Omit<Urql.UseQueryArgs<PopupNotificationModalQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PopupNotificationModalQuery>({ query: PopupNotificationModalDocument, ...options });
};
export const ComputePointsToUseDocument = gql`
    query computePointsToUse($rewardId: String!) {
  computePointsToUse(input: {rewardId: $rewardId}) {
    id
    pointsToRedeem
    amountInCents
  }
}
    `;

export function useComputePointsToUseQuery(options: Omit<Urql.UseQueryArgs<ComputePointsToUseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ComputePointsToUseQuery>({ query: ComputePointsToUseDocument, ...options });
};
export const RedeemPointsDocument = gql`
    mutation redeemPoints($input: CartLoyaltyDiscountApplyInput!) {
  applyCartLoyaltyDiscount(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useRedeemPointsMutation() {
  return Urql.useMutation<RedeemPointsMutation, RedeemPointsMutationVariables>(RedeemPointsDocument);
};
export const ReorderDocument = gql`
    mutation reorder($venueSlug: String!, $orderId: String!) {
  reorder(venueSlug: $venueSlug, orderId: $orderId) {
    id
    orderingType
    tableNumber
    tableArea
    total {
      totalInCents
    }
    cartItems {
      ...CartItemParts
    }
  }
}
    ${CartItemPartsFragmentDoc}`;

export function useReorderMutation() {
  return Urql.useMutation<ReorderMutation, ReorderMutationVariables>(ReorderDocument);
};
export const FetchAuraMembershipDocument = gql`
    query fetchAuraMembership($code: String!, $venueId: String!) {
  fetchAuraMembership(code: $code, venueId: $venueId) {
    id
  }
}
    `;

export function useFetchAuraMembershipQuery(options: Omit<Urql.UseQueryArgs<FetchAuraMembershipQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FetchAuraMembershipQuery>({ query: FetchAuraMembershipDocument, ...options });
};
export const FetchAuraOAuthConfigDocument = gql`
    query fetchAuraOAuthConfig($venueId: String!) {
  fetchAuraOAuthConfig(venueId: $venueId) {
    programName
    url
  }
}
    `;

export function useFetchAuraOAuthConfigQuery(options: Omit<Urql.UseQueryArgs<FetchAuraOAuthConfigQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FetchAuraOAuthConfigQuery>({ query: FetchAuraOAuthConfigDocument, ...options });
};
export const LoyaltyDetailsDocument = gql`
    query loyaltyDetails($venueSlug: String!, $externalMemberId: String) {
  loyaltyDetails(
    input: {venueSlug: $venueSlug, externalMemberId: $externalMemberId}
  ) {
    id
    lastOrder {
      id
      points
    }
    features {
      id
      canSpendPoints
      canEarnPoints
      canSignUp
      canShowPointBalance
      canOptIn
    }
    guestData {
      id
      points
      isOptedIn
    }
    rewards {
      id
      rewardId
      name
    }
    metadata {
      id
      introBody
      pointName
      programName
      minimumPointsRequired
      infoLink
    }
  }
}
    `;

export function useLoyaltyDetailsQuery(options: Omit<Urql.UseQueryArgs<LoyaltyDetailsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<LoyaltyDetailsQuery>({ query: LoyaltyDetailsDocument, ...options });
};
export const LoyaltyPointsDocument = gql`
    query loyaltyPoints($venueSlug: String!, $externalMemberId: String) {
  loyaltyDetails(
    input: {venueSlug: $venueSlug, externalMemberId: $externalMemberId}
  ) {
    id
    features {
      id
      canShowPointBalance
    }
    guestData {
      id
      points
      isOptedIn
    }
    metadata {
      id
      pointName
    }
    vouchers {
      id
      name
      description
      barcode
      imgSrc
    }
  }
}
    `;

export function useLoyaltyPointsQuery(options: Omit<Urql.UseQueryArgs<LoyaltyPointsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<LoyaltyPointsQuery>({ query: LoyaltyPointsDocument, ...options });
};
export const OptInToLoyaltyDocument = gql`
    mutation optInToLoyalty($venueSlug: String!) {
  optInToLoyalty(input: {venueSlug: $venueSlug}) {
    success
  }
}
    `;

export function useOptInToLoyaltyMutation() {
  return Urql.useMutation<OptInToLoyaltyMutation, OptInToLoyaltyMutationVariables>(OptInToLoyaltyDocument);
};
export const RewardMenuItemsDocument = gql`
    query rewardMenuItems($venueSlug: String!, $categorySlug: String = "rewards", $orderingType: OrderingType = DINE_IN) {
  guestMenuCategory(
    venueSlug: $venueSlug
    categorySlug: $categorySlug
    orderingType: $orderingType
  ) {
    id
    menuSections {
      id
      menuItems {
        id
        name
        description
        image {
          id
          originalImagePath
          originalImageUrl
        }
        priceData {
          displayPrice
          priceInCents
        }
        rewardPrice {
          originalAmountInCents
          originalDisplayAmount
        }
      }
    }
  }
}
    `;

export function useRewardMenuItemsQuery(options: Omit<Urql.UseQueryArgs<RewardMenuItemsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<RewardMenuItemsQuery>({ query: RewardMenuItemsDocument, ...options });
};
export const CloseSocialTabDocument = gql`
    mutation closeSocialTab($tabId: String!) {
  closeTab(tabId: $tabId)
}
    `;

export function useCloseSocialTabMutation() {
  return Urql.useMutation<CloseSocialTabMutation, CloseSocialTabMutationVariables>(CloseSocialTabDocument);
};
export const ConfirmMemberDocument = gql`
    mutation confirmMember($tabId: String!) {
  confirmMember(tabId: $tabId) {
    success
    validation
  }
}
    `;

export function useConfirmMemberMutation() {
  return Urql.useMutation<ConfirmMemberMutation, ConfirmMemberMutationVariables>(ConfirmMemberDocument);
};
export const SetSocialTabLimitDocument = gql`
    mutation setSocialTabLimit($tabId: String!, $maxSpendInCents: Float!) {
  setSocialTabLimit(tabId: $tabId, maxSpendInCents: $maxSpendInCents) {
    id
  }
}
    `;

export function useSetSocialTabLimitMutation() {
  return Urql.useMutation<SetSocialTabLimitMutation, SetSocialTabLimitMutationVariables>(SetSocialTabLimitDocument);
};
export const TabGuestConfirmationDocument = gql`
    query tabGuestConfirmation($tabId: String!) {
  getTabGuestConfirmation(tabId: $tabId) {
    id
    tabName
    orderingType
    validation
  }
}
    `;

export function useTabGuestConfirmationQuery(options: Omit<Urql.UseQueryArgs<TabGuestConfirmationQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TabGuestConfirmationQuery>({ query: TabGuestConfirmationDocument, ...options });
};
export const TabMetaDocument = gql`
    query tabMeta($tabId: String!) {
  getTabMeta(tabId: $tabId) {
    id
    tabName
  }
}
    `;

export function useTabMetaQuery(options: Omit<Urql.UseQueryArgs<TabMetaQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TabMetaQuery>({ query: TabMetaDocument, ...options });
};
export const TabOrdersDocument = gql`
    query tabOrders($tabId: String!, $skip: Float!, $limit: Float!) {
  getTabOrders(tabId: $tabId, skip: $skip, limit: $limit) {
    items {
      id
      name
      date
      totalInCents
    }
    total
    skip
    limit
  }
}
    `;

export function useTabOrdersQuery(options: Omit<Urql.UseQueryArgs<TabOrdersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TabOrdersQuery>({ query: TabOrdersDocument, ...options });
};
export const TabDocument = gql`
    query tab($tabId: String!) {
  getTab(tabId: $tabId) {
    id
    tabName
    status
    startTime
    tabSpendInCents
    orderingType
    venue {
      id
      name
      currency
    }
    validation
    maxSpendInCents
  }
}
    `;

export function useTabQuery(options: Omit<Urql.UseQueryArgs<TabQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TabQuery>({ query: TabDocument, ...options });
};
export const AuthenticateSwiftPosMemberDocument = gql`
    mutation authenticateSwiftPosMember($venueSlug: String!, $code: String!) {
  authenticateSwiftPosMember(venueSlug: $venueSlug, code: $code) {
    token
  }
}
    `;

export function useAuthenticateSwiftPosMemberMutation() {
  return Urql.useMutation<AuthenticateSwiftPosMemberMutation, AuthenticateSwiftPosMemberMutationVariables>(AuthenticateSwiftPosMemberDocument);
};
export const MslAuthSettingsDocument = gql`
    query mslAuthSettings($venueSlug: String!) {
  getMSLAuthSettings(slug: $venueSlug) {
    id
    membershipAuthUrl
  }
}
    `;

export function useMslAuthSettingsQuery(options: Omit<Urql.UseQueryArgs<MslAuthSettingsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MslAuthSettingsQuery>({ query: MslAuthSettingsDocument, ...options });
};
export const SwiftPosMemberLoggedInCheckDocument = gql`
    query swiftPosMemberLoggedInCheck($venueSlug: String!) {
  swiftPosMemberLoggedInCheckV2(venueSlug: $venueSlug)
}
    `;

export function useSwiftPosMemberLoggedInCheckQuery(options: Omit<Urql.UseQueryArgs<SwiftPosMemberLoggedInCheckQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SwiftPosMemberLoggedInCheckQuery>({ query: SwiftPosMemberLoggedInCheckDocument, ...options });
};
export const SwiftposMemberPriceLevelDocument = gql`
    query swiftposMemberPriceLevel($venueSlug: String!) {
  swiftposMemberPriceLevel(venueSlug: $venueSlug)
}
    `;

export function useSwiftposMemberPriceLevelQuery(options: Omit<Urql.UseQueryArgs<SwiftposMemberPriceLevelQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SwiftposMemberPriceLevelQuery>({ query: SwiftposMemberPriceLevelDocument, ...options });
};
export const VenueTableNumberDocument = gql`
    query venueTableNumber($venueSlug: String!, $orderingType: OrderingType!) {
  guestVenue(slug: $venueSlug) {
    id
    skipTableNumberModal
    ordering
    isOrderingAvailable
    orderingType(orderingType: $orderingType) {
      id
      orderingType
      isAvailable
      tablePromptText
      tableText
      tableAreaText
      tableNumberValidation
      minTableNumber
      maxTableNumber
      hasTableNumber
      tableAreas
      usingTableGroups
      orderingWindow {
        id
        enabled
      }
    }
  }
}
    `;

export function useVenueTableNumberQuery(options: Omit<Urql.UseQueryArgs<VenueTableNumberQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueTableNumberQuery>({ query: VenueTableNumberDocument, ...options });
};
export const LoginAsTestGuestDocument = gql`
    mutation loginAsTestGuest($fresh: Boolean!) {
  loginAsTestGuest(input: {fresh: $fresh}) {
    id
    mobile
  }
}
    `;

export function useLoginAsTestGuestMutation() {
  return Urql.useMutation<LoginAsTestGuestMutation, LoginAsTestGuestMutationVariables>(LoginAsTestGuestDocument);
};
export const ApplyCartTipDocument = gql`
    mutation applyCartTip($input: CartTipApplyInput!) {
  applyCartTip(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useApplyCartTipMutation() {
  return Urql.useMutation<ApplyCartTipMutation, ApplyCartTipMutationVariables>(ApplyCartTipDocument);
};
export const InitialVenueDocument = gql`
    query initialVenue($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    availableOrderingType
    brandingAccent
    brandingAccentText
    brandingEnabled
    brandingPrimary
    brandingPrimaryText
    facebookPixelId
    googleTagManagerId
    organizationId
    showOrderingTypePicker
    currency
  }
}
    `;

export function useInitialVenueQuery(options: Omit<Urql.UseQueryArgs<InitialVenueQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<InitialVenueQuery>({ query: InitialVenueDocument, ...options });
};
export const VenueFacebookPixelIdDocument = gql`
    query venueFacebookPixelId($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    facebookPixelId
  }
}
    `;

export function useVenueFacebookPixelIdQuery(options: Omit<Urql.UseQueryArgs<VenueFacebookPixelIdQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueFacebookPixelIdQuery>({ query: VenueFacebookPixelIdDocument, ...options });
};
export const VenueGoogleTagManagerIdDocument = gql`
    query venueGoogleTagManagerId($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    googleTagManagerId
  }
}
    `;

export function useVenueGoogleTagManagerIdQuery(options: Omit<Urql.UseQueryArgs<VenueGoogleTagManagerIdQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueGoogleTagManagerIdQuery>({ query: VenueGoogleTagManagerIdDocument, ...options });
};
export const VenueInfoForTrackingDocument = gql`
    query venueInfoForTracking($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    organizationId
  }
}
    `;

export function useVenueInfoForTrackingQuery(options: Omit<Urql.UseQueryArgs<VenueInfoForTrackingQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueInfoForTrackingQuery>({ query: VenueInfoForTrackingDocument, ...options });
};
export const MvoSearchDocument = gql`
    query mvoSearch($searchQuery: String!, $orderingWindowStartDate: String, $orderingType: OrderingType!, $venueSlug: String!, $tableNumber: String, $tableArea: String) {
  mvoItemSearch(
    searchQuery: $searchQuery
    orderingWindowStartDate: $orderingWindowStartDate
    orderingType: $orderingType
    venueSlug: $venueSlug
    tableNumber: $tableNumber
    tableArea: $tableArea
  ) {
    categoryId
    categoryName
    categorySlug
    extendedWaitTime {
      id
      estimate
      estimateInMilliseconds
      expiry
      expiryEndTime
    }
    image {
      id
      originalImagePath
      originalImageUrl
    }
    isClosed
    menuCategoryType
    mvoFeatured
    orderingType
    position
    menuItems {
      ...MvoSearchResultMenuItem
    }
  }
  mvoVendorSearch(
    searchQuery: $searchQuery
    orderingWindowStartDate: $orderingWindowStartDate
    orderingType: $orderingType
    venueSlug: $venueSlug
    tableNumber: $tableNumber
    tableArea: $tableArea
  ) {
    ...VenueLandingMenuCategory
  }
}
    ${MvoSearchResultMenuItemFragmentDoc}
${VenueLandingMenuCategoryFragmentDoc}`;

export function useMvoSearchQuery(options: Omit<Urql.UseQueryArgs<MvoSearchQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MvoSearchQuery>({ query: MvoSearchDocument, ...options });
};
export const RefreshSessionDocument = gql`
    mutation refreshSession($tableNumber: String, $tableArea: String, $venueId: String, $orderingType: OrderingType) {
  refreshSession(
    input: {tableNumber: $tableNumber, tableArea: $tableArea, venueId: $venueId, orderingType: $orderingType}
  ) {
    createdAt
  }
}
    `;

export function useRefreshSessionMutation() {
  return Urql.useMutation<RefreshSessionMutation, RefreshSessionMutationVariables>(RefreshSessionDocument);
};
export const StartWithDrinksDocument = gql`
    query startWithDrinks($orderingWindowStartDate: String, $orderingType: OrderingType!, $venueSlug: String!, $tableNumber: String, $tableArea: String) {
  startWithDrinks(
    orderingWindowStartDate: $orderingWindowStartDate
    orderingType: $orderingType
    venueSlug: $venueSlug
    tableNumber: $tableNumber
    tableArea: $tableArea
  ) {
    ...MenuItemWithMenuCategory
  }
}
    ${MenuItemWithMenuCategoryFragmentDoc}`;

export function useStartWithDrinksQuery(options: Omit<Urql.UseQueryArgs<StartWithDrinksQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<StartWithDrinksQuery>({ query: StartWithDrinksDocument, ...options });
};
export const VenueBookingDocument = gql`
    query venueBooking($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    bookingLink
  }
}
    `;

export function useVenueBookingQuery(options: Omit<Urql.UseQueryArgs<VenueBookingQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueBookingQuery>({ query: VenueBookingDocument, ...options });
};
export const VenueIndexDocument = gql`
    query venueIndex($venueSlug: String!) {
  venueIndex: guestVenue(slug: $venueSlug) {
    id
    availableOrderingType
    showOrderingTypePicker
  }
}
    `;

export function useVenueIndexQuery(options: Omit<Urql.UseQueryArgs<VenueIndexQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueIndexQuery>({ query: VenueIndexDocument, ...options });
};
export const VenueLandingAdditionalDocument = gql`
    query venueLandingAdditional($venueSlug: String!, $externalMemberId: String) {
  currentUser {
    id
    managedTabs(venueSlug: $venueSlug) {
      id
    }
  }
  lastOrderByUserByVenueSlug(venueSlug: $venueSlug) {
    id
    orderingType
    lineItems {
      type
      category
    }
  }
  loyaltyDetails(
    input: {venueSlug: $venueSlug, externalMemberId: $externalMemberId}
  ) {
    id
    metadata {
      id
      memberName
      infoLink
    }
  }
}
    `;

export function useVenueLandingAdditionalQuery(options: Omit<Urql.UseQueryArgs<VenueLandingAdditionalQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueLandingAdditionalQuery>({ query: VenueLandingAdditionalDocument, ...options });
};
export const VenueLandingDocument = gql`
    query venueLanding($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    ...VenueLanding
  }
}
    ${VenueLandingFragmentDoc}`;

export function useVenueLandingQuery(options: Omit<Urql.UseQueryArgs<VenueLandingQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueLandingQuery>({ query: VenueLandingDocument, ...options });
};
export const VenueMenuCategoryDocument = gql`
    query venueMenuCategory($venueSlug: String!, $orderingType: OrderingType!, $tableArea: String, $tableNumber: String, $orderingWindowStartDate: String) {
  guestMenuCategories(
    venueSlug: $venueSlug
    orderingType: $orderingType
    tableArea: $tableArea
    tableNumber: $tableNumber
    orderingWindowStartDate: $orderingWindowStartDate
  ) {
    ...VenueLandingMenuCategory
  }
}
    ${VenueLandingMenuCategoryFragmentDoc}`;

export function useVenueMenuCategoryQuery(options: Omit<Urql.UseQueryArgs<VenueMenuCategoryQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueMenuCategoryQuery>({ query: VenueMenuCategoryDocument, ...options });
};
export const VenueBrandingColorsDocument = gql`
    query venueBrandingColors($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    brandingEnabled
    brandingPrimary
    brandingPrimaryText
    brandingAccent
    brandingAccentText
  }
}
    `;

export function useVenueBrandingColorsQuery(options: Omit<Urql.UseQueryArgs<VenueBrandingColorsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueBrandingColorsQuery>({ query: VenueBrandingColorsDocument, ...options });
};
export const AddOrUpdateLocationOnCartDocument = gql`
    mutation addOrUpdateLocationOnCart($input: CartLocationInput!) {
  addOrUpdateLocationOnCart(input: $input) {
    ...CartParts
  }
}
    ${CartPartsFragmentDoc}`;

export function useAddOrUpdateLocationOnCartMutation() {
  return Urql.useMutation<AddOrUpdateLocationOnCartMutation, AddOrUpdateLocationOnCartMutationVariables>(AddOrUpdateLocationOnCartDocument);
};
export const VenueAddressValidationDocument = gql`
    query venueAddressValidation($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    countryCode
    location {
      id: googlePlaceId
      latitude
      longitude
    }
    orderingTypes {
      id
      orderingType
      postcodes
    }
  }
}
    `;

export function useVenueAddressValidationQuery(options: Omit<Urql.UseQueryArgs<VenueAddressValidationQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueAddressValidationQuery>({ query: VenueAddressValidationDocument, ...options });
};
export const VenueCurrencyDocument = gql`
    query venueCurrency($venueSlug: String!) {
  guestVenue(slug: $venueSlug) {
    id
    currency
  }
}
    `;

export function useVenueCurrencyQuery(options: Omit<Urql.UseQueryArgs<VenueCurrencyQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VenueCurrencyQuery>({ query: VenueCurrencyDocument, ...options });
};